import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
export type CreateAttachmentMutationVariables = Exact<{
  input: CreateAttachmentInput;
}>;


export type CreateAttachmentMutation = { __typename?: 'RootMutation', mutation: { __typename?: 'CreateAttachmentPayload', successful: boolean, result: { __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type RemoveAttachmentMutationVariables = Exact<{
  input: RemoveAttachmentInput;
}>;


export type RemoveAttachmentMutation = { __typename?: 'RootMutation', removeAttachment: { __typename?: 'RemoveAttachmentPayload', successful: boolean } | null };

export type RegisterChatMutationVariables = Exact<{
  input: RegisterChatInput;
}>;


export type RegisterChatMutation = { __typename?: 'RootMutation', registerChat: { __typename?: 'RegisterChatPayload', result: { __typename?: 'ChatChannel', externalId: string } | null } | null };

export type CreateCaseResultEditRequestMutationVariables = Exact<{
  input: CreateCaseResultEditRequestInput;
}>;


export type CreateCaseResultEditRequestMutation = { __typename?: 'RootMutation', createCaseResultEditRequest: { __typename?: 'CreateCaseResultEditRequestPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }>, result: { __typename?: 'Case', id: string, completed: boolean | null, openEditRequest: string | null, canEditResult: boolean, canSubmitResult: boolean } | null } | null };

export type ResultFieldFragment = { __typename?: 'CaseResultField', id: string, required: boolean, label: string | null, inputType: string, myResponseValue: any | null };

export type TestCaseFragment = { __typename?: 'Case', id: string, code: string | null, name: string, prerequisites: string | null, myResponseStatus: string | null, completed: boolean | null, openEditRequest: string | null, canEditResult: boolean, canSubmitResult: boolean, feedback: Array<CaseFeedback>, approved: boolean, underReview: boolean, caseFields: { __typename?: 'CaseFieldConnection', nodes: Array<{ __typename?: 'CaseField', id: string, ordinalNumber: number, groupType: string, label: string, value: { __typename: 'CaseFieldStep', instruction: string, expectedResult: string } | { __typename: 'StringValue', content: string } | null, resultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, required: boolean, label: string | null, inputType: string, myResponseValue: any | null }> } }> }, resultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, required: boolean, label: string | null, inputType: string, myResponseValue: any | null }> }, attachments: Array<{ __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null }> | null, testCaseRunVideos: Array<{ __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null }> | null };

export type GetTestQueryVariables = Exact<{
  testId: Scalars['ID']['input'];
}>;


export type GetTestQuery = { __typename?: 'RootQuery', test: { __typename?: 'Test', id: string, activityType: TestActivityTypeEnum | null, name: string, uniqueCode: string | null, scope: string | null, description: string, applicationUrl: string | null, isClosed: boolean, canView: boolean, canReportBlockers: boolean, communityTestManagersEnabled: boolean, remainingIssuesLimit: number | null, plannedEndAt: any | null, closesAutomatically: boolean, testerCompletionTimeFinishesAt: any | null, closedAt: any | null, vendor: string | null, testType: string, credentialsAndAccessInstructions: string | null, predefinedUserAccountsInstructions: string | null, accessToSecureEnvironmentInstructions: string | null, additionalUrlsAndResources: string | null, requestedEnvironments: Array<any> | null, sdlcStage: string | null, extendedOverview: boolean, testerSpecificationLink: string | null, trackerProjectUrl: string | null, estimatedTestCasesPayment: number | null, requireVideoAttachment: boolean, relatedTestCaseRequiredForIssue: boolean, desiredOutcomes: Array<{ __typename?: 'DesiredOutcome', name: string, testerInstructions: string | null, isSelectedForTest: boolean }> | null, cases: { __typename?: 'CaseConnection', totalCount: number | null, nodes: Array<{ __typename?: 'Case', id: string, code: string | null, name: string, prerequisites: string | null, myResponseStatus: string | null, completed: boolean | null, openEditRequest: string | null, canEditResult: boolean, canSubmitResult: boolean, feedback: Array<CaseFeedback>, approved: boolean, underReview: boolean, caseFields: { __typename?: 'CaseFieldConnection', nodes: Array<{ __typename?: 'CaseField', id: string, ordinalNumber: number, groupType: string, label: string, value: { __typename: 'CaseFieldStep', instruction: string, expectedResult: string } | { __typename: 'StringValue', content: string } | null, resultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, required: boolean, label: string | null, inputType: string, myResponseValue: any | null }> } }> }, resultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, required: boolean, label: string | null, inputType: string, myResponseValue: any | null }> }, attachments: Array<{ __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null }> | null, testCaseRunVideos: Array<{ __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null }> | null }> }, blockers: Array<{ __typename?: 'TestBlocker', id: string, name: string, status: string }>, requirementsGroup: { __typename?: 'RequirementsGroup', platforms: Array<string>, operatingSystemAndVersions: Array<string>, operatingSystems: Array<string>, browsers: Array<string>, languages: Array<string>, mobileDevices: Array<string>, deviceTypes: Array<string>, manufacturers: Array<string>, other: string | null } | null, testerSpec: { __typename?: 'TesterSpec', title: string, inScope: string | null, outOfScope: string | null, guidelines: Array<{ __typename?: 'TesterGuideline', title: string, description: string }> } | null } | null };

export type GetTestParticipationQueryVariables = Exact<{
  testId: Scalars['ID']['input'];
}>;


export type GetTestParticipationQuery = { __typename?: 'RootQuery', globalRelevantEnvironments: { __typename?: 'GlobalRelevantEnvironmentsConnection', edges: Array<{ __typename?: 'GlobalRelevantEnvironmentsEdge', node: { __typename?: 'GlobalRelevantEnvironments', deviceType: string, operatingSystemVersion: string | null, operatingSystem: { __typename?: 'OperatingSystem', name: string | null, code: string | null } | null } }> }, test: { __typename?: 'Test', id: string, predefinedUserAccountsInstructions: string | null, accessToSecureEnvironmentInstructions: string | null, activityType: TestActivityTypeEnum | null, name: string, extendedOverview: boolean, externalIssueReporting: boolean, testCode: string | null, description: string, uniqueCode: string | null, requestedEnvironments: Array<any> | null, estimatedTestCasesPayment: number | null, testType: string, isParticipating: boolean, isClosed: boolean, canView: boolean, plannedEndAt: any | null, closesAutomatically: boolean, requiredAttachment: Array<string>, isReadyForExecution: boolean, isFeedbackProvided: boolean, isIssueReportingEnabled: boolean, supportsAutomaticTesterManagement: boolean, executionEnvironment: { __typename?: 'ExecutionEnvironment', operatingSystemAndVersion: string | null, browserOrDevice: string | null, type: Environment | null } | null, cases: { __typename?: 'CaseConnection', totalCount: number | null }, requirementsGroup: { __typename?: 'RequirementsGroup', platforms: Array<string>, operatingSystemAndVersions: Array<string>, operatingSystems: Array<string>, browsers: Array<string>, languages: Array<string>, mobileDevices: Array<string>, deviceTypes: Array<string>, manufacturers: Array<string>, other: string | null } | null, selectionsSettings: { __typename?: 'SelectionsSettings', notStartedGracePeriod: string } | null } | null };

export type JoinFlexibleTestMutationVariables = Exact<{
  input: JoinFlexibleTestInput;
}>;


export type JoinFlexibleTestMutation = { __typename?: 'RootMutation', joinFlexibleTest: { __typename?: 'JoinFlexibleTestPayload', successful: boolean, result: { __typename?: 'TesterSession', id: string, test: { __typename?: 'Test', id: string, isParticipating: boolean } | null } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type LeaveFlexibleTestMutationVariables = Exact<{
  input: LeaveFlexibleTestInput;
}>;


export type LeaveFlexibleTestMutation = { __typename?: 'RootMutation', leaveFlexibleTest: { __typename?: 'LeaveFlexibleTestPayload', successful: boolean, result: { __typename?: 'TesterSession', id: string, test: { __typename?: 'Test', id: string, isClosed: boolean, closedAt: any | null, plannedEndAt: any | null } | null } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type PollTestQueryVariables = Exact<{
  testId: Scalars['ID']['input'];
}>;


export type PollTestQuery = { __typename?: 'RootQuery', test: { __typename?: 'Test', id: string, isClosed: boolean } | null };

export type ResolveTestBlockerMutationVariables = Exact<{
  input: ResolveTestBlockerInput;
}>;


export type ResolveTestBlockerMutation = { __typename?: 'RootMutation', resolveTestBlocker: { __typename?: 'ResolveTestBlockerPayload', successful: boolean, result: { __typename?: 'TestBlocker', id: string, status: string, name: string } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type AddTesterSessionFeedbackMutationVariables = Exact<{
  input: AddTesterSessionFeedbackInput;
}>;


export type AddTesterSessionFeedbackMutation = { __typename?: 'RootMutation', addTesterSessionFeedback: { __typename?: 'AddTesterSessionFeedbackPayload', successful: boolean, result: { __typename?: 'Test', isFeedbackProvided: boolean, id: string } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type CreateIssueMutationVariables = Exact<{
  input: CreateIssueInput;
}>;


export type CreateIssueMutation = { __typename?: 'RootMutation', createIssue: { __typename?: 'CreateIssuePayload', successful: boolean, result: { __typename?: 'Issue', test: { __typename?: 'Test', id: string, remainingIssuesLimit: number | null } } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type GetIssueFieldDefinitionsQueryVariables = Exact<{
  testId: Scalars['ID']['input'];
}>;


export type GetIssueFieldDefinitionsQuery = { __typename?: 'RootQuery', test: { __typename?: 'Test', issueFieldDefinitions: Array<{ __typename?: 'TestIssueFieldDefinition', label: string, code: string, fieldType: string, required: boolean, options: { __typename?: 'SelectFieldOptionConnection', edges: Array<{ __typename?: 'SelectFieldOptionEdge', node: { __typename?: 'SelectFieldOption', label: string, value: string } }> } }> } | null };

export type UpdateExecutionEnvironmentMutationVariables = Exact<{
  input: UpdateExecutionEnvironmentInput;
}>;


export type UpdateExecutionEnvironmentMutation = { __typename?: 'RootMutation', updateExecutionEnvironment: { __typename?: 'UpdateExecutionEnvironmentPayload', successful: boolean, result: { __typename?: 'Test', id: string, isReadyForExecution: boolean, executionEnvironment: { __typename?: 'ExecutionEnvironment', operatingSystemAndVersion: string | null, browserOrDevice: string | null } | null } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type AddCaseResultMutationVariables = Exact<{
  input: AddCaseResultInput;
}>;


export type AddCaseResultMutation = { __typename?: 'RootMutation', mutation: { __typename?: 'AddCaseResultPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }>, result: { __typename?: 'CaseResultField', id: string, myResponseValue: any | null, connectedCase: { __typename?: 'Case', id: string, myResponseStatus: string | null, completed: boolean | null, feedback: Array<CaseFeedback>, underReview: boolean, caseFields: { __typename?: 'CaseFieldConnection', nodes: Array<{ __typename?: 'CaseField', id: string, resultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, required: boolean, myResponseValue: any | null }> } }> } } | null } | null } | null };

export type GetAdditionalAttachmentsQueryVariables = Exact<{
  caseFieldId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAdditionalAttachmentsQuery = { __typename?: 'RootQuery', additionalAttachments: Array<{ __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null }> | null };

export type SubmitCaseResultMutationVariables = Exact<{
  input: SubmitCaseResultInput;
}>;


export type SubmitCaseResultMutation = { __typename?: 'RootMutation', submitCaseResult: { __typename?: 'SubmitCaseResultPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }>, result: { __typename?: 'Case', id: string, completed: boolean | null, canSubmitResult: boolean, canEditResult: boolean, openEditRequest: string | null, feedback: Array<CaseFeedback>, underReview: boolean, caseFields: { __typename?: 'CaseFieldConnection', nodes: Array<{ __typename?: 'CaseField', id: string, caseResultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, myResponseValue: any | null }> } }> } } | null } | null };

export type UpdateTestCaseRunVideoMutationVariables = Exact<{
  input: UpdateTestCaseRunVideoInput;
}>;


export type UpdateTestCaseRunVideoMutation = { __typename?: 'RootMutation', updateTestCaseRunVideo: { __typename?: 'UpdateTestCaseRunVideoPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type CreateTestBlockerMutationVariables = Exact<{
  input: CreateTestBlockerInput;
}>;


export type CreateTestBlockerMutation = { __typename?: 'RootMutation', createTestBlocker: { __typename?: 'CreateTestBlockerPayload', successful: boolean, result: { __typename?: 'Test', id: string, blockers: Array<{ __typename?: 'TestBlocker', id: string, status: string, name: string }> } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type GetViewerHardwareAndSoftwareQueryVariables = Exact<{
  testId: Scalars['ID']['input'];
}>;


export type GetViewerHardwareAndSoftwareQuery = { __typename?: 'RootQuery', viewer: { __typename?: 'Viewer', id: string, desktopOperatingSystems: { __typename?: 'TesterOperatingSystemOwnershipConnection', edges: Array<{ __typename?: 'TesterOperatingSystemOwnershipEdge', node: { __typename?: 'TesterOperatingSystemOwnership', id: string, nameWithVersion: string } }> }, mobileDevices: { __typename?: 'TesterMobileDeviceOwnershipConnection', edges: Array<{ __typename?: 'TesterMobileDeviceOwnershipEdge', node: { __typename?: 'TesterMobileDeviceOwnership', id: string, name: string, operatingSystemNameWithVersion: string } }> } } };

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureFlagsQuery = { __typename?: 'RootQuery', featureFlags: Array<string> };

export type GetTestsCountQueryVariables = Exact<{
  isOpen: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTestsCountQuery = { __typename?: 'RootQuery', reproducibilityTests: { __typename?: 'TestConnection', totalCount: number | null }, joinedTests: { __typename?: 'TestConnection', totalCount: number | null } };

export type GetReproducibilityTestQueryVariables = Exact<{
  testId: Scalars['ID']['input'];
}>;


export type GetReproducibilityTestQuery = { __typename?: 'RootQuery', test: { __typename?: 'Test', id: string, name: string, requestedEnvironments: Array<any> | null, reproducibilitySource: string | null, isParticipating: boolean, isClosed: boolean, responseTemplate: string | null, payoutBaseAmount: number, isReadyForExecution: boolean, isFeedbackProvided: boolean, credentialsAndAccessInstructions: string | null, applicationUrl: string | null, additionalUrlsAndResources: string | null, executionEnvironment: { __typename?: 'ExecutionEnvironment', operatingSystemAndVersion: string | null, browserOrDevice: string | null, type: Environment | null } | null, cases: { __typename?: 'CaseConnection', totalCount: number | null, nodes: Array<{ __typename?: 'Case', id: string, code: string | null, name: string, prerequisites: string | null, myResponseStatus: string | null, completed: boolean | null, openEditRequest: string | null, canEditResult: boolean, canSubmitResult: boolean, feedback: Array<CaseFeedback>, approved: boolean, underReview: boolean, caseFields: { __typename?: 'CaseFieldConnection', nodes: Array<{ __typename?: 'CaseField', id: string, ordinalNumber: number, groupType: string, label: string, value: { __typename: 'CaseFieldStep', instruction: string, expectedResult: string } | { __typename: 'StringValue', content: string } | null, resultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, required: boolean, label: string | null, inputType: string, myResponseValue: any | null }> } }> }, resultFields: { __typename?: 'CaseResultFieldConnection', nodes: Array<{ __typename?: 'CaseResultField', id: string, required: boolean, label: string | null, inputType: string, myResponseValue: any | null }> }, attachments: Array<{ __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null }> | null, testCaseRunVideos: Array<{ __typename?: 'Attachment', attachmentId: string, attachmentUrl: string, attachmentType: string | null }> | null }> }, attachments: Array<{ __typename?: 'Attachment', attachmentUrl: string, attachmentType: string | null }> | null } | null };

export type GetCurrentTesterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentTesterQuery = { __typename?: 'RootQuery', tester: { __typename?: 'Tester', id: string, aboutMe: string | null, address: string | null, birthday: any | null, city: string | null, countryId: string | null, firstName: string | null, gender: string | null, lastName: string | null, linkedinProfileLink: string | null, payoutMethodCode: string | null, payoutMethodId: string | null, payoutMethodIdentifier: string | null, phoneNumber: string | null, profileCompletenessStage: ProfileCompletenessStageEnum, postcode: string | null, region: string | null, skipAssessmentTest: boolean, yearsOfTestingExperience: number | null, email: string, publicId: string, createdAt: any | null, segmentEnabled: boolean, checkUpVerification: boolean, streamChatToken: string, hasVpnAccess: boolean, availablePreferences: Array<{ __typename?: 'AvailablePreference', key: string, name: string, description: string }>, preferences: { __typename?: 'Preferences', emailNotificationsEnabled: boolean }, testerRank: { __typename?: 'TesterRank', tierCode: string, tierPayoutMultiplier: number }, outdatedConsents: Array<{ __typename?: 'TesterConsent', code: string, version: string, label: string, link: string }> } | null };

export type GetBaseRewardQueryVariables = Exact<{
  testType: TestTypesEnum;
}>;


export type GetBaseRewardQuery = { __typename?: 'RootQuery', baseReward: { __typename?: 'BaseReward', payoutBaseAmount: number, lowSeverityIssuePayoutAmount: number, mediumSeverityIssuePayoutAmount: number, highSeverityIssuePayoutAmount: number, criticalSeverityIssuePayoutAmount: number } | null };

export type MarkParticipantAsDeclinedMutationVariables = Exact<{
  input: MarkParticipantAsDeclinedInput;
}>;


export type MarkParticipantAsDeclinedMutation = { __typename?: 'RootMutation', markParticipantAsDeclined: { __typename?: 'MarkParticipantAsDeclinedPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type UpdateCaseFieldAttachmentResponsesMutationVariables = Exact<{
  input: UpdateCaseFieldAttachmentResponsesInput;
}>;


export type UpdateCaseFieldAttachmentResponsesMutation = { __typename?: 'RootMutation', updateCaseFieldAttachmentResponses: { __typename?: 'UpdateCaseFieldAttachmentResponsesPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type UpdateCaseResultAttachmentsMutationVariables = Exact<{
  input: UpdateCaseResultAttachmentsInput;
}>;


export type UpdateCaseResultAttachmentsMutation = { __typename?: 'RootMutation', updateCaseResultAttachments: { __typename?: 'UpdateCaseResultAttachmentsPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type CreateTesterSurveyResponseMutationVariables = Exact<{
  input: CreateTesterSurveyResponseInput;
}>;


export type CreateTesterSurveyResponseMutation = { __typename?: 'RootMutation', mutation: { __typename?: 'CreateTesterSurveyResponsePayload', result: boolean | null, successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type GetTesterSurveyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTesterSurveyQuery = { __typename?: 'RootQuery', survey: { __typename?: 'TesterSurvey', content: any, completed: boolean | null } | null };

export type GetTestCycleInvitationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetTestCycleInvitationQuery = { __typename?: 'RootQuery', testCycleInvitation: { __typename?: 'TestCycleInvitation', id: string, accepted: boolean, testerSpreadsheet: { __typename?: 'TesterSpreadsheet', id: string, url: string } | null } | null };

export type UpdateCheckUpVerificationMutationVariables = Exact<{
  input: UpdateCheckUpVerificationInput;
}>;


export type UpdateCheckUpVerificationMutation = { __typename?: 'RootMutation', updateCheckUpVerification: { __typename?: 'UpdateCheckUpVerificationPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }>, result: { __typename?: 'TesterOwnership', mobileDeviceOwnerships: Array<{ __typename?: 'TesterMobileDeviceOwnership', id: string, mobileDeviceId: string, mobileDeviceOwnershipId: string, name: string, operatingSystemNameWithVersion: string, operatingSystemVersionId: string, platformCode: string | null }>, operatingSystemOwnerships: Array<{ __typename?: 'TesterOperatingSystemOwnership', id: string, nameWithVersion: string, operatingSystemId: string, operatingSystemOwnershipId: string, operatingSystemVersionId: string }> } | null } | null };

export type ConfirmTesterConsentsMutationVariables = Exact<{
  input: ConfirmTesterConsentsInput;
}>;


export type ConfirmTesterConsentsMutation = { __typename?: 'RootMutation', confirmTesterConsents: { __typename?: 'ConfirmTesterConsentsPayload', result: boolean | null, successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type GetTestCycleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTestCycleQuery = { __typename?: 'RootQuery', testCycle: { __typename?: 'TestCycle', status: TestCycleStatus, startAt: any | null, calculatedEndAt: any | null, inProgress: boolean, customerName: string | null, testCycleCode: string | null, applicationInfo: string | null, deviceRequirements: any, payoutBoostLabel: string | null, trackerProjectUrl: string | null, testCasesDocumentUrl: string | null, testerSpecificationLink: string | null, payoutDetails: Array<{ __typename?: 'PayoutDetails', severity: string, baseAmount: string, rankAmount: string, boostedAmount: string }> | null, invitation: { __typename?: 'TestCycleInvitation', token: string | null, accepted: boolean, onWaitingList: boolean } | null } | null };

export type UpdateTestCycleInvitationMutationVariables = Exact<{
  input: UpdateTestCycleInvitationInput;
}>;


export type UpdateTestCycleInvitationMutation = { __typename?: 'RootMutation', updateTestCycleInvitation: { __typename?: 'UpdateTestCycleInvitationPayload', successful: boolean, result: { __typename?: 'TestCycleInvitation', id: string, accepted: boolean, testerSpreadsheet: { __typename?: 'TesterSpreadsheet', id: string, url: string } | null } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type GetTesterRankQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterRankQuery = { __typename?: 'RootQuery', tester: { __typename?: 'Tester', testerRank: { __typename?: 'TesterRank', tierCode: string, tierPayoutMultiplier: number } } | null };

export type GetPayoutsQueryVariables = Exact<{
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type GetPayoutsQuery = { __typename?: 'RootQuery', payouts: { __typename?: 'PayoutConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string | null }, edges: Array<{ __typename?: 'PayoutEdge', node: { __typename?: 'Payout', id: string, amountFormatted: string, amountChangeReason: string | null, correction: boolean, key: string, paidOn: any | null, payoutSystemMemo: string | null, shortPublicId: string, status: PayoutStatuses, details: Array<{ __typename?: 'PayoutDetail', title: string, status: string, errorMessage: string | null, errorExplanation: string | null }>, payoutItems: { __typename?: 'PayoutItemWithoutPaginationConnection', edges: Array<{ __typename?: 'PayoutItemEdge', node: { __typename?: 'PayoutItem', id: string, amountFormatted: string, summary: any | null, subject: any | null } }> } } }> } };

export type GetJoinedTestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJoinedTestsQuery = { __typename?: 'RootQuery', joinedTests: { __typename?: 'TestConnection', edges: Array<{ __typename?: 'TestEdge', node: { __typename?: 'Test', id: string, isParticipating: boolean, status: TestCycleStatus, statusLabel: string, applicationName: string, testType: string, externalUrl: string | null, code: string, payoutBoostLabel: string | null, deviceName: string | null, platformCode: string | null, shortDescription: string | null, promotedGroup: string | null, isClosed: boolean, testId: string } }> } };

export type GetRankingIssuesQueryVariables = Exact<{
  isRejected: Scalars['Boolean']['input'];
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type GetRankingIssuesQuery = { __typename?: 'RootQuery', rankingItems: { __typename?: 'RankingIssueConnection', pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'RankingIssueEdge', node: { __typename?: 'RankingIssue', name: string | null, resolution: string, points: string, moderationFeedback: string | null } }> } };

export type GetTesterPerformanceQueryVariables = Exact<{
  period: TesterPerformancePeriod;
}>;


export type GetTesterPerformanceQuery = { __typename?: 'RootQuery', testerPerformance: { __typename?: 'TesterPerformance', acceptanceRate: number | null, acceptanceRatePercentChange: number | null, issuesCount: number | null, acceptedIssuesCount: number | null, acceptedIssuesWithoutEditsCount: number | null, improvementTips: { __typename?: 'TesterPerformanceImprovementTips', details: string, messagePlaceholderName: string, messagePlaceholderValue: string, messageTemplate: string, tooltip: string } | null } | null };

export type GetAvailabilityConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailabilityConfigQuery = { __typename?: 'RootQuery', availabilityConfig: { __typename?: 'AvailabilityConfig', weekTimeSlots: Array<{ __typename?: 'WeekTimeSlot', timeSlotCode: TimeSlotCodeEnum, isoDayOfWeek: number }>, timesOfDay: Array<{ __typename?: 'TimeOfDay', name: string, startTime: string, endTime: string }>, daysOfWeek: Array<{ __typename?: 'DayOfWeek', isoDayOfWeek: number, name: string }> } | null };

export type GetTesterAvailabilityCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterAvailabilityCalendarQuery = { __typename?: 'RootQuery', tester: { __typename?: 'Tester', id: string, availabilityCalendar: { __typename?: 'TesterAvailabilityCalendar', id: string, timeZoneName: string, nextPossibleUpdateDateTime: any | null, availabilities: Array<{ __typename?: 'TesterAvailability', timeSlotCode: string, available: boolean }> } | null } | null };

export type UpdateTesterAvailabilityCalendarMutationVariables = Exact<{
  input: UpdateTesterAvailabilityCalendarInput;
}>;


export type UpdateTesterAvailabilityCalendarMutation = { __typename?: 'RootMutation', updateTesterAvailabilityCalendar: { __typename?: 'UpdateTesterAvailabilityCalendarPayload', successful: boolean, result: { __typename?: 'Tester', id: string, availabilityCalendar: { __typename?: 'TesterAvailabilityCalendar', id: string, timeZoneName: string, nextPossibleUpdateDateTime: any | null, availabilities: Array<{ __typename?: 'TesterAvailability', timeSlotCode: string, available: boolean }> } | null } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type GetOperatingSystemOwnershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOperatingSystemOwnershipsQuery = { __typename?: 'RootQuery', operatingSystemOwnerships: Array<{ __typename?: 'TesterOperatingSystemOwnership', id: string, nameWithVersion: string, operatingSystemId: string, operatingSystemOwnershipId: string, operatingSystemVersionId: string }> | null };

export type UpdateMobileDeviceOwnershipMutationVariables = Exact<{
  input: UpdateMobileDeviceOwnershipInput;
}>;


export type UpdateMobileDeviceOwnershipMutation = { __typename?: 'RootMutation', updateMobileDeviceOwnership: { __typename?: 'UpdateMobileDeviceOwnershipPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }>, result: Array<{ __typename?: 'TesterMobileDeviceOwnership', id: string, operatingSystemNameWithVersion: string, operatingSystemVersionId: string, mobileDeviceId: string, platformCode: string | null, mobileDeviceOwnershipId: string }> | null } | null };

export type UpdateOperatingSystemOwnershipMutationVariables = Exact<{
  input: UpdateOperatingSystemOwnershipInput;
}>;


export type UpdateOperatingSystemOwnershipMutation = { __typename?: 'RootMutation', updateOperatingSystemOwnership: { __typename?: 'UpdateOperatingSystemOwnershipPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }>, result: Array<{ __typename?: 'TesterOperatingSystemOwnership', id: string, nameWithVersion: string, operatingSystemId: string, operatingSystemOwnershipId: string, operatingSystemVersionId: string }> | null } | null };

export type GetTesterLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterLocationQuery = { __typename?: 'RootQuery', tester: { __typename?: 'Tester', id: string, address: string | null, city: string | null, countryId: string | null, postcode: string | null, profileCompletenessStage: ProfileCompletenessStageEnum, region: string | null } | null };

export type GetMobileDeviceOwnershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMobileDeviceOwnershipsQuery = { __typename?: 'RootQuery', mobileDeviceOwnerships: Array<{ __typename?: 'TesterMobileDeviceOwnership', id: string, mobileDeviceId: string, mobileDeviceOwnershipId: string, name: string, operatingSystemNameWithVersion: string, operatingSystemVersionId: string, platformCode: string | null }> | null };

export type GetTesterProfileDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterProfileDetailsQuery = { __typename?: 'RootQuery', tester: { __typename?: 'Tester', id: string, aboutMe: string | null, birthday: any | null, firstName: string | null, gender: string | null, lastName: string | null, linkedinProfileLink: string | null, phoneNumber: string | null, profileCompletenessStage: ProfileCompletenessStageEnum, yearsOfTestingExperience: number | null } | null };

export type GetTestingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTestingSettingsQuery = { __typename?: 'RootQuery', languages: Array<{ __typename?: 'Language', label: string | null, value: string | null }> | null, languageProficiencyLevels: Array<{ __typename?: 'LanguageProficiencyLevel', label: string, value: string }> | null, testerFields: Array<{ __typename?: 'TesterField', label: string, code: string, type: string, completed: boolean, value: string | null, alphabeticalOrder: boolean, options: Array<{ __typename?: 'TesterFieldOption', id: string, value: string, label: string, selected: boolean }> | null }> | null, languageProficiencies: Array<{ __typename?: 'LanguageProficiency', id: string | null, languageId: string | null, level: LanguageProficiencyLevelEnum | null }> | null };

export type UpdateTestingSettingsMutationVariables = Exact<{
  input: UpdateTestingSettingsInput;
}>;


export type UpdateTestingSettingsMutation = { __typename?: 'RootMutation', updateTestingSettings: { __typename?: 'UpdateTestingSettingsPayload', successful: boolean, result: { __typename?: 'TestingSettingsResult', profileCompletenessStage: string, languageProficiencies: Array<{ __typename?: 'LanguageProficiency', id: string | null, languageId: string | null, level: LanguageProficiencyLevelEnum | null }>, testerFields: Array<{ __typename?: 'TesterField', label: string, code: string, type: string, completed: boolean, value: string | null, options: Array<{ __typename?: 'TesterFieldOption', id: string, value: string, label: string, selected: boolean }> | null }> } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type CreateVpnGatewayPeerMutationVariables = Exact<{
  input: CreateVpnGatewayPeerInput;
}>;


export type CreateVpnGatewayPeerMutation = { __typename?: 'RootMutation', mutation: { __typename?: 'CreateVPNGatewayPeerPayload', successful: boolean, result: { __typename?: 'VPNGatewayPeer', publicKey: string, lastConnectedAt: any | null, userConfig: string | null, userConfigQrcodeSvg: string | null } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type DestroyVpnGatewayPeerMutationVariables = Exact<{
  input: DestroyVpnGatewayPeerInput;
}>;


export type DestroyVpnGatewayPeerMutation = { __typename?: 'RootMutation', mutation: { __typename?: 'DestroyVPNGatewayPeerPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type PeerFragment = { __typename?: 'VPNGatewayPeer', publicKey: string, lastConnectedAt: any | null, isExpired: boolean };

export type GetSubjectVpnGatewayPeerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubjectVpnGatewayPeerQuery = { __typename?: 'RootQuery', node: { __typename?: 'Case' } | { __typename?: 'CaseField' } | { __typename?: 'CaseResult' } | { __typename?: 'CaseResultField' } | { __typename?: 'GlobalRelevantEnvironments' } | { __typename?: 'Issue' } | { __typename?: 'OperatingSystem' } | { __typename?: 'Payout' } | { __typename?: 'PayoutItem' } | { __typename?: 'RankingIssue' } | { __typename?: 'RankingTier' } | { __typename?: 'RequirementsGroup' } | { __typename?: 'Test' } | { __typename?: 'TestBlocker' } | { __typename?: 'TestCycle' } | { __typename?: 'TestCycleInvitation' } | { __typename?: 'Tester' } | { __typename?: 'TesterAvailabilityCalendar' } | { __typename: 'TesterMobileDeviceOwnership', id: string, vpnGatewayPeer: { __typename?: 'VPNGatewayPeer', publicKey: string, lastConnectedAt: any | null, isExpired: boolean } | null } | { __typename: 'TesterOperatingSystemOwnership', id: string, vpnGatewayPeer: { __typename?: 'VPNGatewayPeer', publicKey: string, lastConnectedAt: any | null, isExpired: boolean } | null } | { __typename?: 'TesterPayoutBalance' } | { __typename?: 'TesterQualityAssessmentPage' } | { __typename?: 'TesterQualityAssessmentTest' } | { __typename?: 'TesterRank' } | { __typename?: 'TesterSession' } | { __typename?: 'TesterSpreadsheet' } | { __typename?: 'TesterSurvey' } | { __typename?: 'Viewer' } | { __typename?: 'WorkHistoryIssue' } | { __typename?: 'WorkHistoryItemName' } | { __typename?: 'WorkHistoryItemPayout' } | null };

export type GetTesterAccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterAccountSettingsQuery = { __typename?: 'RootQuery', tester: { __typename?: 'Tester', id: string, email: string, payoutMethodId: string | null, payoutMethodIdentifier: string | null, profileCompletenessStage: ProfileCompletenessStageEnum, availablePreferences: Array<{ __typename?: 'AvailablePreference', key: string, name: string, description: string }>, preferences: { __typename?: 'Preferences', id: string, emailNotificationsEnabled: boolean } } | null };

export type UpdateAccountSettingsMutationVariables = Exact<{
  input: UpdateAccountSettingsInput;
}>;


export type UpdateAccountSettingsMutation = { __typename?: 'RootMutation', updateAccountSettings: { __typename?: 'UpdateAccountSettingsPayload', successful: boolean, result: { __typename?: 'Tester', id: string, firstName: string | null, lastName: string | null, gender: string | null, birthday: any | null, yearsOfTestingExperience: number | null, aboutMe: string | null, countryId: string | null, city: string | null, postcode: string | null, address: string | null, phoneNumber: string | null, payoutMethodId: string | null, payoutMethodIdentifier: string | null, linkedinProfileLink: string | null, region: string | null, preferences: { __typename?: 'Preferences', id: string, emailNotificationsEnabled: boolean } } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type GetTesterQualityAssessmentTestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterQualityAssessmentTestQuery = { __typename?: 'RootQuery', testerQualityAssessmentTest: { __typename?: 'TesterQualityAssessmentTest', name: string, code: string, description: string | null, pages: Array<{ __typename?: 'TesterQualityAssessmentPage', name: string | null, ordinalNumber: number | null, description: string | null, questions: Array<{ __typename?: 'TesterQualityAssessmentQuestion', id: string, text: string, answerType: string, description: string | null, answers: Array<{ __typename?: 'TesterQualityAssessmentAnswer', id: string, text: string }> }> }> } | null, testerQualityAssessmentResponses: Array<{ __typename?: 'TesterQualityAssessmentResponse', id: string, questionId: string, answerIds: Array<string> }> | null };

export type UpdateTesterQualityAssessmentResponsesMutationVariables = Exact<{
  input: UpdateTesterQualityAssessmentResponsesInput;
}>;


export type UpdateTesterQualityAssessmentResponsesMutation = { __typename?: 'RootMutation', updateTesterQualityAssessmentResponses: { __typename?: 'UpdateTesterQualityAssessmentResponsesPayload', successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }>, result: Array<{ __typename?: 'TesterQualityAssessmentResponse', id: string, questionId: string, answerIds: Array<string> }> | null } | null };

export type GetTesterRegistrationAccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterRegistrationAccountSettingsQuery = { __typename?: 'RootQuery', tester: { __typename?: 'Tester', id: string, aboutMe: string | null, address: string | null, birthday: any | null, city: string | null, countryId: string | null, firstName: string | null, gender: string | null, lastName: string | null, linkedinProfileLink: string | null, payoutMethodId: string | null, payoutMethodIdentifier: string | null, phoneNumber: string | null, postcode: string | null, profileCompletenessStage: ProfileCompletenessStageEnum, region: string | null, yearsOfTestingExperience: number | null } | null };

export type UpdateProfileCompletenessStageMutationVariables = Exact<{
  input: UpdateProfileCompletenessStageInput;
}>;


export type UpdateProfileCompletenessStageMutation = { __typename?: 'RootMutation', updateProfileCompletenessStage: { __typename?: 'UpdateProfileCompletenessStagePayload', successful: boolean, result: { __typename?: 'Tester', id: string, profileCompletenessStage: ProfileCompletenessStageEnum, skipAssessmentTest: boolean } | null, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type GetReproducibilityTestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReproducibilityTestsQuery = { __typename?: 'RootQuery', reproducibilityTests: { __typename?: 'TestConnection', edges: Array<{ __typename?: 'TestEdge', node: { __typename?: 'Test', id: string, name: string, payoutBaseAmount: number, isClosed: boolean, isParticipating: boolean, createdAt: any, requestedEnvironments: Array<any> | null } }> } };

export type GetTesterPayoutBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTesterPayoutBalanceQuery = { __typename?: 'RootQuery', testerPayoutBalance: { __typename?: 'TesterPayoutBalance', balance: string, threshold: string, thresholdReached: boolean } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'RootQuery', countries: Array<{ __typename?: 'Country', value: string, label: string, code: string }> | null };

export type CreateTesterDeviceFingerprintMutationVariables = Exact<{
  input: CreateTesterDeviceFingerprintInput;
}>;


export type CreateTesterDeviceFingerprintMutation = { __typename?: 'RootMutation', createTesterDeviceFingerprint: { __typename?: 'CreateTesterDeviceFingerprintPayload', result: boolean | null, successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string }> } | null };

export type GetOperatingSystemVersionsQueryVariables = Exact<{
  deviceTypeCode: DeviceTypeCodesEnum;
}>;


export type GetOperatingSystemVersionsQuery = { __typename?: 'RootQuery', operatingSystemVersions: Array<{ __typename?: 'OperatingSystemVersion', id: string, name: string }> | null };

export type GetPayoutMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutMethodsQuery = { __typename?: 'RootQuery', payoutMethods: Array<{ __typename?: 'PayoutMethod', id: string, name: string, code: string }> | null };

export type GetUsRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsRegionsQuery = { __typename?: 'RootQuery', usRegions: Array<string> | null };

export type SendEmailConfirmationInstructionsMutationVariables = Exact<{
  input: SendEmailConfirmationInstructionsInput;
}>;


export type SendEmailConfirmationInstructionsMutation = { __typename?: 'RootMutation', sendEmailConfirmationInstructions: { __typename?: 'SendEmailConfirmationInstructionsPayload', result: boolean | null, successful: boolean, errors: Array<{ __typename?: 'MutationError', message: string, code: string, path: Array<string> | null }> } | null };

export type GetTimeZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeZonesQuery = { __typename?: 'RootQuery', timeZones: Array<{ __typename?: 'TimeZone', value: string, label: string }> | null };

export type GetTestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTestsQuery = { __typename?: 'RootQuery', tests: { __typename?: 'TestCycleInterfaceWithoutPaginationConnection', totalCount: number | null, edges: Array<{ __typename?: 'TestCycleInterfaceEdge', node: { __typename?: 'Test', isParticipating: boolean, status: TestCycleStatus, statusLabel: string, applicationName: string, testType: string, externalUrl: string | null, code: string, testId: string, payoutBoostLabel: string | null, deviceName: string | null, platformCode: string | null, shortDescription: string | null, promotedGroup: string | null, isClosed: boolean } | { __typename?: 'TestCycle', isParticipating: boolean, status: TestCycleStatus, statusLabel: string, applicationName: string, testType: string, externalUrl: string | null, code: string, testId: string, payoutBoostLabel: string | null, deviceName: string | null, platformCode: string | null, shortDescription: string | null, promotedGroup: string | null, isClosed: boolean } | null }> }, joinedTests: { __typename?: 'TestConnection', totalCount: number | null } };

export type GetWorkHistoryQueryVariables = Exact<{
  status: WorkHistoryStatuses;
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
}>;


export type GetWorkHistoryQuery = { __typename?: 'RootQuery', workHistoryItems: { __typename?: 'WorkHistoryIssueConnection', pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'WorkHistoryIssueEdge', node: { __typename?: 'WorkHistoryIssue', id: string, code: string, status: WorkHistoryItemStatuses, summary: string, testType: WorkHistoryItemTypes, url: string | null, payout: { __typename?: 'WorkHistoryItemPayout', baseAmount: string | null, payoutBoostMultiplier: number | null, rankingTierMultiplier: number | null, totalAmount: string | null, severity: string | null }, testName: { __typename?: 'WorkHistoryItemName', title: string, subtitle: string } } }> } };

export type GetMobileDevicesQueryVariables = Exact<{
  query: InputMaybe<Scalars['String']['input']>;
  platformCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMobileDevicesQuery = { __typename?: 'RootQuery', mobileDevices: Array<{ __typename?: 'MobileDevice', id: string, name: string, platformCode: string }> | null };

export const ResultFieldFragmentDoc = gql`
    fragment resultField on CaseResultField {
  id
  required
  label
  inputType
  myResponseValue
}
    `;
export const TestCaseFragmentDoc = gql`
    fragment testCase on Case {
  id
  code
  name
  prerequisites
  myResponseStatus
  completed
  openEditRequest
  canEditResult
  canSubmitResult
  feedback
  approved
  underReview
  caseFields {
    nodes {
      id
      ordinalNumber
      groupType
      label
      value {
        __typename
        ... on CaseFieldStep {
          instruction
          expectedResult
        }
        ... on StringValue {
          content
        }
      }
      resultFields: caseResultFields {
        nodes {
          ...resultField
        }
      }
    }
  }
  resultFields: caseResultFields {
    nodes {
      ...resultField
    }
  }
  attachments {
    attachmentId: id
    attachmentUrl: url
    attachmentType: type
  }
  testCaseRunVideos {
    attachmentId: id
    attachmentUrl: url
    attachmentType: type
  }
}
    ${ResultFieldFragmentDoc}`;
export const PeerFragmentDoc = gql`
    fragment peer on VPNGatewayPeer {
  publicKey
  lastConnectedAt
  isExpired
}
    `;
export const CreateAttachmentDocument = gql`
    mutation createAttachment($input: CreateAttachmentInput!) {
  mutation: createAttachment(input: $input) {
    result {
      attachmentId: id
      attachmentUrl: url
      attachmentType: type
    }
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<CreateAttachmentMutation, CreateAttachmentMutationVariables>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(CreateAttachmentDocument, options);
      }
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const RemoveAttachmentDocument = gql`
    mutation removeAttachment($input: RemoveAttachmentInput!) {
  removeAttachment(input: $input) {
    successful
  }
}
    `;
export type RemoveAttachmentMutationFn = Apollo.MutationFunction<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>;

/**
 * __useRemoveAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentMutation, { data, loading, error }] = useRemoveAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>(RemoveAttachmentDocument, options);
      }
export type RemoveAttachmentMutationHookResult = ReturnType<typeof useRemoveAttachmentMutation>;
export type RemoveAttachmentMutationResult = Apollo.MutationResult<RemoveAttachmentMutation>;
export type RemoveAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>;
export const RegisterChatDocument = gql`
    mutation registerChat($input: RegisterChatInput!) {
  registerChat(input: $input) {
    result {
      externalId
    }
  }
}
    `;
export type RegisterChatMutationFn = Apollo.MutationFunction<RegisterChatMutation, RegisterChatMutationVariables>;

/**
 * __useRegisterChatMutation__
 *
 * To run a mutation, you first call `useRegisterChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerChatMutation, { data, loading, error }] = useRegisterChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterChatMutation(baseOptions?: Apollo.MutationHookOptions<RegisterChatMutation, RegisterChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterChatMutation, RegisterChatMutationVariables>(RegisterChatDocument, options);
      }
export type RegisterChatMutationHookResult = ReturnType<typeof useRegisterChatMutation>;
export type RegisterChatMutationResult = Apollo.MutationResult<RegisterChatMutation>;
export type RegisterChatMutationOptions = Apollo.BaseMutationOptions<RegisterChatMutation, RegisterChatMutationVariables>;
export const CreateCaseResultEditRequestDocument = gql`
    mutation createCaseResultEditRequest($input: CreateCaseResultEditRequestInput!) {
  createCaseResultEditRequest(input: $input) {
    errors {
      message
      code
    }
    successful
    result {
      id
      completed
      openEditRequest
      canEditResult
      canSubmitResult
    }
  }
}
    `;
export type CreateCaseResultEditRequestMutationFn = Apollo.MutationFunction<CreateCaseResultEditRequestMutation, CreateCaseResultEditRequestMutationVariables>;

/**
 * __useCreateCaseResultEditRequestMutation__
 *
 * To run a mutation, you first call `useCreateCaseResultEditRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseResultEditRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseResultEditRequestMutation, { data, loading, error }] = useCreateCaseResultEditRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaseResultEditRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseResultEditRequestMutation, CreateCaseResultEditRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseResultEditRequestMutation, CreateCaseResultEditRequestMutationVariables>(CreateCaseResultEditRequestDocument, options);
      }
export type CreateCaseResultEditRequestMutationHookResult = ReturnType<typeof useCreateCaseResultEditRequestMutation>;
export type CreateCaseResultEditRequestMutationResult = Apollo.MutationResult<CreateCaseResultEditRequestMutation>;
export type CreateCaseResultEditRequestMutationOptions = Apollo.BaseMutationOptions<CreateCaseResultEditRequestMutation, CreateCaseResultEditRequestMutationVariables>;
export const GetTestDocument = gql`
    query getTest($testId: ID!) {
  test(id: $testId) {
    id
    activityType
    name
    uniqueCode
    scope
    description
    applicationUrl
    isClosed
    canView
    canReportBlockers
    communityTestManagersEnabled
    remainingIssuesLimit
    plannedEndAt
    closesAutomatically
    testerCompletionTimeFinishesAt
    closedAt
    vendor
    testType
    credentialsAndAccessInstructions
    predefinedUserAccountsInstructions
    accessToSecureEnvironmentInstructions
    additionalUrlsAndResources
    requestedEnvironments
    sdlcStage
    extendedOverview
    testerSpecificationLink
    trackerProjectUrl
    estimatedTestCasesPayment
    requireVideoAttachment
    desiredOutcomes {
      name
      testerInstructions
      isSelectedForTest
    }
    cases {
      nodes {
        ...testCase
      }
      totalCount
    }
    relatedTestCaseRequiredForIssue
    blockers {
      id
      name
      status
    }
    requirementsGroup {
      platforms
      operatingSystemAndVersions
      operatingSystems
      browsers
      languages
      mobileDevices
      deviceTypes
      manufacturers
      other
    }
    testerSpec {
      title
      inScope
      outOfScope
      guidelines {
        title
        description
      }
    }
  }
}
    ${TestCaseFragmentDoc}`;

/**
 * __useGetTestQuery__
 *
 * To run a query within a React component, call `useGetTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *   },
 * });
 */
export function useGetTestQuery(baseOptions: Apollo.QueryHookOptions<GetTestQuery, GetTestQueryVariables> & ({ variables: GetTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestQuery, GetTestQueryVariables>(GetTestDocument, options);
      }
export function useGetTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestQuery, GetTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestQuery, GetTestQueryVariables>(GetTestDocument, options);
        }
export function useGetTestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestQuery, GetTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestQuery, GetTestQueryVariables>(GetTestDocument, options);
        }
export type GetTestQueryHookResult = ReturnType<typeof useGetTestQuery>;
export type GetTestLazyQueryHookResult = ReturnType<typeof useGetTestLazyQuery>;
export type GetTestSuspenseQueryHookResult = ReturnType<typeof useGetTestSuspenseQuery>;
export type GetTestQueryResult = Apollo.QueryResult<GetTestQuery, GetTestQueryVariables>;
export const GetTestParticipationDocument = gql`
    query getTestParticipation($testId: ID!) {
  globalRelevantEnvironments {
    edges {
      node {
        deviceType
        operatingSystem {
          name
          code
        }
        operatingSystemVersion
      }
    }
  }
  test(id: $testId) {
    id
    predefinedUserAccountsInstructions
    accessToSecureEnvironmentInstructions
    activityType
    name
    extendedOverview
    externalIssueReporting
    testCode
    description
    uniqueCode
    requestedEnvironments
    estimatedTestCasesPayment
    testType
    isParticipating
    isClosed
    canView
    plannedEndAt
    closesAutomatically
    requiredAttachment
    executionEnvironment {
      operatingSystemAndVersion
      browserOrDevice
      type
    }
    isReadyForExecution
    isFeedbackProvided
    isIssueReportingEnabled
    cases {
      totalCount
    }
    requirementsGroup {
      platforms
      operatingSystemAndVersions
      operatingSystems
      browsers
      languages
      mobileDevices
      deviceTypes
      manufacturers
      other
    }
    supportsAutomaticTesterManagement
    selectionsSettings {
      notStartedGracePeriod
    }
  }
}
    `;

/**
 * __useGetTestParticipationQuery__
 *
 * To run a query within a React component, call `useGetTestParticipationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestParticipationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestParticipationQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *   },
 * });
 */
export function useGetTestParticipationQuery(baseOptions: Apollo.QueryHookOptions<GetTestParticipationQuery, GetTestParticipationQueryVariables> & ({ variables: GetTestParticipationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestParticipationQuery, GetTestParticipationQueryVariables>(GetTestParticipationDocument, options);
      }
export function useGetTestParticipationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestParticipationQuery, GetTestParticipationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestParticipationQuery, GetTestParticipationQueryVariables>(GetTestParticipationDocument, options);
        }
export function useGetTestParticipationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestParticipationQuery, GetTestParticipationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestParticipationQuery, GetTestParticipationQueryVariables>(GetTestParticipationDocument, options);
        }
export type GetTestParticipationQueryHookResult = ReturnType<typeof useGetTestParticipationQuery>;
export type GetTestParticipationLazyQueryHookResult = ReturnType<typeof useGetTestParticipationLazyQuery>;
export type GetTestParticipationSuspenseQueryHookResult = ReturnType<typeof useGetTestParticipationSuspenseQuery>;
export type GetTestParticipationQueryResult = Apollo.QueryResult<GetTestParticipationQuery, GetTestParticipationQueryVariables>;
export const JoinFlexibleTestDocument = gql`
    mutation joinFlexibleTest($input: JoinFlexibleTestInput!) {
  joinFlexibleTest(input: $input) {
    result {
      id
      test {
        id
        isParticipating
      }
    }
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type JoinFlexibleTestMutationFn = Apollo.MutationFunction<JoinFlexibleTestMutation, JoinFlexibleTestMutationVariables>;

/**
 * __useJoinFlexibleTestMutation__
 *
 * To run a mutation, you first call `useJoinFlexibleTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinFlexibleTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinFlexibleTestMutation, { data, loading, error }] = useJoinFlexibleTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinFlexibleTestMutation(baseOptions?: Apollo.MutationHookOptions<JoinFlexibleTestMutation, JoinFlexibleTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinFlexibleTestMutation, JoinFlexibleTestMutationVariables>(JoinFlexibleTestDocument, options);
      }
export type JoinFlexibleTestMutationHookResult = ReturnType<typeof useJoinFlexibleTestMutation>;
export type JoinFlexibleTestMutationResult = Apollo.MutationResult<JoinFlexibleTestMutation>;
export type JoinFlexibleTestMutationOptions = Apollo.BaseMutationOptions<JoinFlexibleTestMutation, JoinFlexibleTestMutationVariables>;
export const LeaveFlexibleTestDocument = gql`
    mutation leaveFlexibleTest($input: LeaveFlexibleTestInput!) {
  leaveFlexibleTest(input: $input) {
    result {
      id
      test {
        id
        isClosed
        closedAt
        plannedEndAt
      }
    }
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type LeaveFlexibleTestMutationFn = Apollo.MutationFunction<LeaveFlexibleTestMutation, LeaveFlexibleTestMutationVariables>;

/**
 * __useLeaveFlexibleTestMutation__
 *
 * To run a mutation, you first call `useLeaveFlexibleTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveFlexibleTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveFlexibleTestMutation, { data, loading, error }] = useLeaveFlexibleTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveFlexibleTestMutation(baseOptions?: Apollo.MutationHookOptions<LeaveFlexibleTestMutation, LeaveFlexibleTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveFlexibleTestMutation, LeaveFlexibleTestMutationVariables>(LeaveFlexibleTestDocument, options);
      }
export type LeaveFlexibleTestMutationHookResult = ReturnType<typeof useLeaveFlexibleTestMutation>;
export type LeaveFlexibleTestMutationResult = Apollo.MutationResult<LeaveFlexibleTestMutation>;
export type LeaveFlexibleTestMutationOptions = Apollo.BaseMutationOptions<LeaveFlexibleTestMutation, LeaveFlexibleTestMutationVariables>;
export const PollTestDocument = gql`
    query pollTest($testId: ID!) {
  test(id: $testId) {
    id
    isClosed
  }
}
    `;

/**
 * __usePollTestQuery__
 *
 * To run a query within a React component, call `usePollTestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollTestQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *   },
 * });
 */
export function usePollTestQuery(baseOptions: Apollo.QueryHookOptions<PollTestQuery, PollTestQueryVariables> & ({ variables: PollTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollTestQuery, PollTestQueryVariables>(PollTestDocument, options);
      }
export function usePollTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollTestQuery, PollTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollTestQuery, PollTestQueryVariables>(PollTestDocument, options);
        }
export function usePollTestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PollTestQuery, PollTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PollTestQuery, PollTestQueryVariables>(PollTestDocument, options);
        }
export type PollTestQueryHookResult = ReturnType<typeof usePollTestQuery>;
export type PollTestLazyQueryHookResult = ReturnType<typeof usePollTestLazyQuery>;
export type PollTestSuspenseQueryHookResult = ReturnType<typeof usePollTestSuspenseQuery>;
export type PollTestQueryResult = Apollo.QueryResult<PollTestQuery, PollTestQueryVariables>;
export const ResolveTestBlockerDocument = gql`
    mutation resolveTestBlocker($input: ResolveTestBlockerInput!) {
  resolveTestBlocker(input: $input) {
    result {
      id
      status
      name
    }
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type ResolveTestBlockerMutationFn = Apollo.MutationFunction<ResolveTestBlockerMutation, ResolveTestBlockerMutationVariables>;

/**
 * __useResolveTestBlockerMutation__
 *
 * To run a mutation, you first call `useResolveTestBlockerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveTestBlockerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveTestBlockerMutation, { data, loading, error }] = useResolveTestBlockerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveTestBlockerMutation(baseOptions?: Apollo.MutationHookOptions<ResolveTestBlockerMutation, ResolveTestBlockerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveTestBlockerMutation, ResolveTestBlockerMutationVariables>(ResolveTestBlockerDocument, options);
      }
export type ResolveTestBlockerMutationHookResult = ReturnType<typeof useResolveTestBlockerMutation>;
export type ResolveTestBlockerMutationResult = Apollo.MutationResult<ResolveTestBlockerMutation>;
export type ResolveTestBlockerMutationOptions = Apollo.BaseMutationOptions<ResolveTestBlockerMutation, ResolveTestBlockerMutationVariables>;
export const AddTesterSessionFeedbackDocument = gql`
    mutation addTesterSessionFeedback($input: AddTesterSessionFeedbackInput!) {
  addTesterSessionFeedback(input: $input) {
    result {
      isFeedbackProvided
      id
    }
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type AddTesterSessionFeedbackMutationFn = Apollo.MutationFunction<AddTesterSessionFeedbackMutation, AddTesterSessionFeedbackMutationVariables>;

/**
 * __useAddTesterSessionFeedbackMutation__
 *
 * To run a mutation, you first call `useAddTesterSessionFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTesterSessionFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTesterSessionFeedbackMutation, { data, loading, error }] = useAddTesterSessionFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTesterSessionFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddTesterSessionFeedbackMutation, AddTesterSessionFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTesterSessionFeedbackMutation, AddTesterSessionFeedbackMutationVariables>(AddTesterSessionFeedbackDocument, options);
      }
export type AddTesterSessionFeedbackMutationHookResult = ReturnType<typeof useAddTesterSessionFeedbackMutation>;
export type AddTesterSessionFeedbackMutationResult = Apollo.MutationResult<AddTesterSessionFeedbackMutation>;
export type AddTesterSessionFeedbackMutationOptions = Apollo.BaseMutationOptions<AddTesterSessionFeedbackMutation, AddTesterSessionFeedbackMutationVariables>;
export const CreateIssueDocument = gql`
    mutation createIssue($input: CreateIssueInput!) {
  createIssue(input: $input) {
    result {
      test {
        id
        remainingIssuesLimit
      }
    }
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type CreateIssueMutationFn = Apollo.MutationFunction<CreateIssueMutation, CreateIssueMutationVariables>;

/**
 * __useCreateIssueMutation__
 *
 * To run a mutation, you first call `useCreateIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIssueMutation, { data, loading, error }] = useCreateIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIssueMutation(baseOptions?: Apollo.MutationHookOptions<CreateIssueMutation, CreateIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIssueMutation, CreateIssueMutationVariables>(CreateIssueDocument, options);
      }
export type CreateIssueMutationHookResult = ReturnType<typeof useCreateIssueMutation>;
export type CreateIssueMutationResult = Apollo.MutationResult<CreateIssueMutation>;
export type CreateIssueMutationOptions = Apollo.BaseMutationOptions<CreateIssueMutation, CreateIssueMutationVariables>;
export const GetIssueFieldDefinitionsDocument = gql`
    query getIssueFieldDefinitions($testId: ID!) {
  test(id: $testId) {
    issueFieldDefinitions {
      label
      code
      fieldType
      required
      options {
        edges {
          node {
            label
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetIssueFieldDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetIssueFieldDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssueFieldDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssueFieldDefinitionsQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *   },
 * });
 */
export function useGetIssueFieldDefinitionsQuery(baseOptions: Apollo.QueryHookOptions<GetIssueFieldDefinitionsQuery, GetIssueFieldDefinitionsQueryVariables> & ({ variables: GetIssueFieldDefinitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIssueFieldDefinitionsQuery, GetIssueFieldDefinitionsQueryVariables>(GetIssueFieldDefinitionsDocument, options);
      }
export function useGetIssueFieldDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssueFieldDefinitionsQuery, GetIssueFieldDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIssueFieldDefinitionsQuery, GetIssueFieldDefinitionsQueryVariables>(GetIssueFieldDefinitionsDocument, options);
        }
export function useGetIssueFieldDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIssueFieldDefinitionsQuery, GetIssueFieldDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIssueFieldDefinitionsQuery, GetIssueFieldDefinitionsQueryVariables>(GetIssueFieldDefinitionsDocument, options);
        }
export type GetIssueFieldDefinitionsQueryHookResult = ReturnType<typeof useGetIssueFieldDefinitionsQuery>;
export type GetIssueFieldDefinitionsLazyQueryHookResult = ReturnType<typeof useGetIssueFieldDefinitionsLazyQuery>;
export type GetIssueFieldDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetIssueFieldDefinitionsSuspenseQuery>;
export type GetIssueFieldDefinitionsQueryResult = Apollo.QueryResult<GetIssueFieldDefinitionsQuery, GetIssueFieldDefinitionsQueryVariables>;
export const UpdateExecutionEnvironmentDocument = gql`
    mutation updateExecutionEnvironment($input: UpdateExecutionEnvironmentInput!) {
  updateExecutionEnvironment(input: $input) {
    result {
      executionEnvironment {
        operatingSystemAndVersion
        browserOrDevice
      }
      id
      isReadyForExecution
    }
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type UpdateExecutionEnvironmentMutationFn = Apollo.MutationFunction<UpdateExecutionEnvironmentMutation, UpdateExecutionEnvironmentMutationVariables>;

/**
 * __useUpdateExecutionEnvironmentMutation__
 *
 * To run a mutation, you first call `useUpdateExecutionEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExecutionEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExecutionEnvironmentMutation, { data, loading, error }] = useUpdateExecutionEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExecutionEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExecutionEnvironmentMutation, UpdateExecutionEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExecutionEnvironmentMutation, UpdateExecutionEnvironmentMutationVariables>(UpdateExecutionEnvironmentDocument, options);
      }
export type UpdateExecutionEnvironmentMutationHookResult = ReturnType<typeof useUpdateExecutionEnvironmentMutation>;
export type UpdateExecutionEnvironmentMutationResult = Apollo.MutationResult<UpdateExecutionEnvironmentMutation>;
export type UpdateExecutionEnvironmentMutationOptions = Apollo.BaseMutationOptions<UpdateExecutionEnvironmentMutation, UpdateExecutionEnvironmentMutationVariables>;
export const AddCaseResultDocument = gql`
    mutation addCaseResult($input: AddCaseResultInput!) {
  mutation: addCaseResult(input: $input) {
    errors {
      message
      code
    }
    successful
    result {
      id
      myResponseValue
      connectedCase {
        id
        myResponseStatus
        completed
        feedback
        underReview
        caseFields {
          nodes {
            id
            resultFields: caseResultFields {
              nodes {
                id
                required
                myResponseValue
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type AddCaseResultMutationFn = Apollo.MutationFunction<AddCaseResultMutation, AddCaseResultMutationVariables>;

/**
 * __useAddCaseResultMutation__
 *
 * To run a mutation, you first call `useAddCaseResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaseResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaseResultMutation, { data, loading, error }] = useAddCaseResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCaseResultMutation(baseOptions?: Apollo.MutationHookOptions<AddCaseResultMutation, AddCaseResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCaseResultMutation, AddCaseResultMutationVariables>(AddCaseResultDocument, options);
      }
export type AddCaseResultMutationHookResult = ReturnType<typeof useAddCaseResultMutation>;
export type AddCaseResultMutationResult = Apollo.MutationResult<AddCaseResultMutation>;
export type AddCaseResultMutationOptions = Apollo.BaseMutationOptions<AddCaseResultMutation, AddCaseResultMutationVariables>;
export const GetAdditionalAttachmentsDocument = gql`
    query getAdditionalAttachments($caseFieldId: ID) {
  additionalAttachments(caseFieldId: $caseFieldId) {
    attachmentId: id
    attachmentUrl: url
    attachmentType: type
  }
}
    `;

/**
 * __useGetAdditionalAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetAdditionalAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalAttachmentsQuery({
 *   variables: {
 *      caseFieldId: // value for 'caseFieldId'
 *   },
 * });
 */
export function useGetAdditionalAttachmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdditionalAttachmentsQuery, GetAdditionalAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalAttachmentsQuery, GetAdditionalAttachmentsQueryVariables>(GetAdditionalAttachmentsDocument, options);
      }
export function useGetAdditionalAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalAttachmentsQuery, GetAdditionalAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalAttachmentsQuery, GetAdditionalAttachmentsQueryVariables>(GetAdditionalAttachmentsDocument, options);
        }
export function useGetAdditionalAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdditionalAttachmentsQuery, GetAdditionalAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdditionalAttachmentsQuery, GetAdditionalAttachmentsQueryVariables>(GetAdditionalAttachmentsDocument, options);
        }
export type GetAdditionalAttachmentsQueryHookResult = ReturnType<typeof useGetAdditionalAttachmentsQuery>;
export type GetAdditionalAttachmentsLazyQueryHookResult = ReturnType<typeof useGetAdditionalAttachmentsLazyQuery>;
export type GetAdditionalAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetAdditionalAttachmentsSuspenseQuery>;
export type GetAdditionalAttachmentsQueryResult = Apollo.QueryResult<GetAdditionalAttachmentsQuery, GetAdditionalAttachmentsQueryVariables>;
export const SubmitCaseResultDocument = gql`
    mutation submitCaseResult($input: SubmitCaseResultInput!) {
  submitCaseResult(input: $input) {
    errors {
      message
      code
    }
    successful
    result {
      id
      completed
      canSubmitResult
      canEditResult
      openEditRequest
      feedback
      underReview
      caseFields {
        nodes {
          id
          caseResultFields {
            nodes {
              id
              myResponseValue
            }
          }
        }
      }
    }
  }
}
    `;
export type SubmitCaseResultMutationFn = Apollo.MutationFunction<SubmitCaseResultMutation, SubmitCaseResultMutationVariables>;

/**
 * __useSubmitCaseResultMutation__
 *
 * To run a mutation, you first call `useSubmitCaseResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCaseResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCaseResultMutation, { data, loading, error }] = useSubmitCaseResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCaseResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCaseResultMutation, SubmitCaseResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCaseResultMutation, SubmitCaseResultMutationVariables>(SubmitCaseResultDocument, options);
      }
export type SubmitCaseResultMutationHookResult = ReturnType<typeof useSubmitCaseResultMutation>;
export type SubmitCaseResultMutationResult = Apollo.MutationResult<SubmitCaseResultMutation>;
export type SubmitCaseResultMutationOptions = Apollo.BaseMutationOptions<SubmitCaseResultMutation, SubmitCaseResultMutationVariables>;
export const UpdateTestCaseRunVideoDocument = gql`
    mutation updateTestCaseRunVideo($input: UpdateTestCaseRunVideoInput!) {
  updateTestCaseRunVideo(input: $input) {
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type UpdateTestCaseRunVideoMutationFn = Apollo.MutationFunction<UpdateTestCaseRunVideoMutation, UpdateTestCaseRunVideoMutationVariables>;

/**
 * __useUpdateTestCaseRunVideoMutation__
 *
 * To run a mutation, you first call `useUpdateTestCaseRunVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestCaseRunVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestCaseRunVideoMutation, { data, loading, error }] = useUpdateTestCaseRunVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestCaseRunVideoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestCaseRunVideoMutation, UpdateTestCaseRunVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestCaseRunVideoMutation, UpdateTestCaseRunVideoMutationVariables>(UpdateTestCaseRunVideoDocument, options);
      }
export type UpdateTestCaseRunVideoMutationHookResult = ReturnType<typeof useUpdateTestCaseRunVideoMutation>;
export type UpdateTestCaseRunVideoMutationResult = Apollo.MutationResult<UpdateTestCaseRunVideoMutation>;
export type UpdateTestCaseRunVideoMutationOptions = Apollo.BaseMutationOptions<UpdateTestCaseRunVideoMutation, UpdateTestCaseRunVideoMutationVariables>;
export const CreateTestBlockerDocument = gql`
    mutation createTestBlocker($input: CreateTestBlockerInput!) {
  createTestBlocker(input: $input) {
    successful
    result {
      id
      blockers {
        id
        status
        name
      }
    }
    errors {
      message
      code
    }
  }
}
    `;
export type CreateTestBlockerMutationFn = Apollo.MutationFunction<CreateTestBlockerMutation, CreateTestBlockerMutationVariables>;

/**
 * __useCreateTestBlockerMutation__
 *
 * To run a mutation, you first call `useCreateTestBlockerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestBlockerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestBlockerMutation, { data, loading, error }] = useCreateTestBlockerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestBlockerMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestBlockerMutation, CreateTestBlockerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestBlockerMutation, CreateTestBlockerMutationVariables>(CreateTestBlockerDocument, options);
      }
export type CreateTestBlockerMutationHookResult = ReturnType<typeof useCreateTestBlockerMutation>;
export type CreateTestBlockerMutationResult = Apollo.MutationResult<CreateTestBlockerMutation>;
export type CreateTestBlockerMutationOptions = Apollo.BaseMutationOptions<CreateTestBlockerMutation, CreateTestBlockerMutationVariables>;
export const GetViewerHardwareAndSoftwareDocument = gql`
    query getViewerHardwareAndSoftware($testId: ID!) {
  viewer {
    id
    desktopOperatingSystems(filters: {test_id: $testId}) {
      edges {
        node {
          id
          nameWithVersion
        }
      }
    }
    mobileDevices(filters: {test_id: $testId}) {
      edges {
        node {
          id
          name
          operatingSystemNameWithVersion
        }
      }
    }
  }
}
    `;

/**
 * __useGetViewerHardwareAndSoftwareQuery__
 *
 * To run a query within a React component, call `useGetViewerHardwareAndSoftwareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerHardwareAndSoftwareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerHardwareAndSoftwareQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *   },
 * });
 */
export function useGetViewerHardwareAndSoftwareQuery(baseOptions: Apollo.QueryHookOptions<GetViewerHardwareAndSoftwareQuery, GetViewerHardwareAndSoftwareQueryVariables> & ({ variables: GetViewerHardwareAndSoftwareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewerHardwareAndSoftwareQuery, GetViewerHardwareAndSoftwareQueryVariables>(GetViewerHardwareAndSoftwareDocument, options);
      }
export function useGetViewerHardwareAndSoftwareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerHardwareAndSoftwareQuery, GetViewerHardwareAndSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewerHardwareAndSoftwareQuery, GetViewerHardwareAndSoftwareQueryVariables>(GetViewerHardwareAndSoftwareDocument, options);
        }
export function useGetViewerHardwareAndSoftwareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetViewerHardwareAndSoftwareQuery, GetViewerHardwareAndSoftwareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViewerHardwareAndSoftwareQuery, GetViewerHardwareAndSoftwareQueryVariables>(GetViewerHardwareAndSoftwareDocument, options);
        }
export type GetViewerHardwareAndSoftwareQueryHookResult = ReturnType<typeof useGetViewerHardwareAndSoftwareQuery>;
export type GetViewerHardwareAndSoftwareLazyQueryHookResult = ReturnType<typeof useGetViewerHardwareAndSoftwareLazyQuery>;
export type GetViewerHardwareAndSoftwareSuspenseQueryHookResult = ReturnType<typeof useGetViewerHardwareAndSoftwareSuspenseQuery>;
export type GetViewerHardwareAndSoftwareQueryResult = Apollo.QueryResult<GetViewerHardwareAndSoftwareQuery, GetViewerHardwareAndSoftwareQueryVariables>;
export const GetFeatureFlagsDocument = gql`
    query GetFeatureFlags {
  featureFlags
}
    `;

/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
      }
export function useGetFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export function useGetFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export type GetFeatureFlagsQueryHookResult = ReturnType<typeof useGetFeatureFlagsQuery>;
export type GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsLazyQuery>;
export type GetFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFlagsSuspenseQuery>;
export type GetFeatureFlagsQueryResult = Apollo.QueryResult<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export const GetTestsCountDocument = gql`
    query getTestsCount($isOpen: Boolean) {
  reproducibilityTests(filters: {is_open: $isOpen}) {
    totalCount
  }
  joinedTests {
    totalCount
  }
}
    `;

/**
 * __useGetTestsCountQuery__
 *
 * To run a query within a React component, call `useGetTestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestsCountQuery({
 *   variables: {
 *      isOpen: // value for 'isOpen'
 *   },
 * });
 */
export function useGetTestsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetTestsCountQuery, GetTestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestsCountQuery, GetTestsCountQueryVariables>(GetTestsCountDocument, options);
      }
export function useGetTestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestsCountQuery, GetTestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestsCountQuery, GetTestsCountQueryVariables>(GetTestsCountDocument, options);
        }
export function useGetTestsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestsCountQuery, GetTestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestsCountQuery, GetTestsCountQueryVariables>(GetTestsCountDocument, options);
        }
export type GetTestsCountQueryHookResult = ReturnType<typeof useGetTestsCountQuery>;
export type GetTestsCountLazyQueryHookResult = ReturnType<typeof useGetTestsCountLazyQuery>;
export type GetTestsCountSuspenseQueryHookResult = ReturnType<typeof useGetTestsCountSuspenseQuery>;
export type GetTestsCountQueryResult = Apollo.QueryResult<GetTestsCountQuery, GetTestsCountQueryVariables>;
export const GetReproducibilityTestDocument = gql`
    query getReproducibilityTest($testId: ID!) {
  test(id: $testId) {
    id
    name
    requestedEnvironments
    reproducibilitySource
    isParticipating
    isClosed
    responseTemplate
    payoutBaseAmount
    executionEnvironment {
      operatingSystemAndVersion
      browserOrDevice
      type
    }
    isReadyForExecution
    isFeedbackProvided
    cases {
      totalCount
      nodes {
        ...testCase
      }
    }
    attachments {
      attachmentUrl: url
      attachmentType: type
    }
    credentialsAndAccessInstructions
    applicationUrl
    additionalUrlsAndResources
  }
}
    ${TestCaseFragmentDoc}`;

/**
 * __useGetReproducibilityTestQuery__
 *
 * To run a query within a React component, call `useGetReproducibilityTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReproducibilityTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReproducibilityTestQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *   },
 * });
 */
export function useGetReproducibilityTestQuery(baseOptions: Apollo.QueryHookOptions<GetReproducibilityTestQuery, GetReproducibilityTestQueryVariables> & ({ variables: GetReproducibilityTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReproducibilityTestQuery, GetReproducibilityTestQueryVariables>(GetReproducibilityTestDocument, options);
      }
export function useGetReproducibilityTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReproducibilityTestQuery, GetReproducibilityTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReproducibilityTestQuery, GetReproducibilityTestQueryVariables>(GetReproducibilityTestDocument, options);
        }
export function useGetReproducibilityTestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReproducibilityTestQuery, GetReproducibilityTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReproducibilityTestQuery, GetReproducibilityTestQueryVariables>(GetReproducibilityTestDocument, options);
        }
export type GetReproducibilityTestQueryHookResult = ReturnType<typeof useGetReproducibilityTestQuery>;
export type GetReproducibilityTestLazyQueryHookResult = ReturnType<typeof useGetReproducibilityTestLazyQuery>;
export type GetReproducibilityTestSuspenseQueryHookResult = ReturnType<typeof useGetReproducibilityTestSuspenseQuery>;
export type GetReproducibilityTestQueryResult = Apollo.QueryResult<GetReproducibilityTestQuery, GetReproducibilityTestQueryVariables>;
export const GetCurrentTesterDocument = gql`
    query getCurrentTester {
  tester {
    id
    aboutMe
    address
    birthday
    city
    countryId
    firstName
    gender
    lastName
    linkedinProfileLink
    payoutMethodCode
    payoutMethodId
    payoutMethodIdentifier
    phoneNumber
    profileCompletenessStage
    postcode
    region
    skipAssessmentTest
    yearsOfTestingExperience
    email
    publicId
    createdAt
    segmentEnabled
    checkUpVerification
    streamChatToken
    hasVpnAccess
    availablePreferences {
      key
      name
      description
    }
    preferences {
      emailNotificationsEnabled
    }
    testerRank {
      tierCode
      tierPayoutMultiplier
    }
    outdatedConsents {
      code
      version
      label
      link
    }
  }
}
    `;

/**
 * __useGetCurrentTesterQuery__
 *
 * To run a query within a React component, call `useGetCurrentTesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentTesterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentTesterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentTesterQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentTesterQuery, GetCurrentTesterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentTesterQuery, GetCurrentTesterQueryVariables>(GetCurrentTesterDocument, options);
      }
export function useGetCurrentTesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentTesterQuery, GetCurrentTesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentTesterQuery, GetCurrentTesterQueryVariables>(GetCurrentTesterDocument, options);
        }
export function useGetCurrentTesterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentTesterQuery, GetCurrentTesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentTesterQuery, GetCurrentTesterQueryVariables>(GetCurrentTesterDocument, options);
        }
export type GetCurrentTesterQueryHookResult = ReturnType<typeof useGetCurrentTesterQuery>;
export type GetCurrentTesterLazyQueryHookResult = ReturnType<typeof useGetCurrentTesterLazyQuery>;
export type GetCurrentTesterSuspenseQueryHookResult = ReturnType<typeof useGetCurrentTesterSuspenseQuery>;
export type GetCurrentTesterQueryResult = Apollo.QueryResult<GetCurrentTesterQuery, GetCurrentTesterQueryVariables>;
export const GetBaseRewardDocument = gql`
    query getBaseReward($testType: TestTypesEnum!) {
  baseReward(testType: $testType) {
    payoutBaseAmount
    lowSeverityIssuePayoutAmount
    mediumSeverityIssuePayoutAmount
    highSeverityIssuePayoutAmount
    criticalSeverityIssuePayoutAmount
  }
}
    `;

/**
 * __useGetBaseRewardQuery__
 *
 * To run a query within a React component, call `useGetBaseRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseRewardQuery({
 *   variables: {
 *      testType: // value for 'testType'
 *   },
 * });
 */
export function useGetBaseRewardQuery(baseOptions: Apollo.QueryHookOptions<GetBaseRewardQuery, GetBaseRewardQueryVariables> & ({ variables: GetBaseRewardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaseRewardQuery, GetBaseRewardQueryVariables>(GetBaseRewardDocument, options);
      }
export function useGetBaseRewardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaseRewardQuery, GetBaseRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaseRewardQuery, GetBaseRewardQueryVariables>(GetBaseRewardDocument, options);
        }
export function useGetBaseRewardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaseRewardQuery, GetBaseRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaseRewardQuery, GetBaseRewardQueryVariables>(GetBaseRewardDocument, options);
        }
export type GetBaseRewardQueryHookResult = ReturnType<typeof useGetBaseRewardQuery>;
export type GetBaseRewardLazyQueryHookResult = ReturnType<typeof useGetBaseRewardLazyQuery>;
export type GetBaseRewardSuspenseQueryHookResult = ReturnType<typeof useGetBaseRewardSuspenseQuery>;
export type GetBaseRewardQueryResult = Apollo.QueryResult<GetBaseRewardQuery, GetBaseRewardQueryVariables>;
export const MarkParticipantAsDeclinedDocument = gql`
    mutation markParticipantAsDeclined($input: MarkParticipantAsDeclinedInput!) {
  markParticipantAsDeclined(input: $input) {
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type MarkParticipantAsDeclinedMutationFn = Apollo.MutationFunction<MarkParticipantAsDeclinedMutation, MarkParticipantAsDeclinedMutationVariables>;

/**
 * __useMarkParticipantAsDeclinedMutation__
 *
 * To run a mutation, you first call `useMarkParticipantAsDeclinedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkParticipantAsDeclinedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markParticipantAsDeclinedMutation, { data, loading, error }] = useMarkParticipantAsDeclinedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkParticipantAsDeclinedMutation(baseOptions?: Apollo.MutationHookOptions<MarkParticipantAsDeclinedMutation, MarkParticipantAsDeclinedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkParticipantAsDeclinedMutation, MarkParticipantAsDeclinedMutationVariables>(MarkParticipantAsDeclinedDocument, options);
      }
export type MarkParticipantAsDeclinedMutationHookResult = ReturnType<typeof useMarkParticipantAsDeclinedMutation>;
export type MarkParticipantAsDeclinedMutationResult = Apollo.MutationResult<MarkParticipantAsDeclinedMutation>;
export type MarkParticipantAsDeclinedMutationOptions = Apollo.BaseMutationOptions<MarkParticipantAsDeclinedMutation, MarkParticipantAsDeclinedMutationVariables>;
export const UpdateCaseFieldAttachmentResponsesDocument = gql`
    mutation updateCaseFieldAttachmentResponses($input: UpdateCaseFieldAttachmentResponsesInput!) {
  updateCaseFieldAttachmentResponses(input: $input) {
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type UpdateCaseFieldAttachmentResponsesMutationFn = Apollo.MutationFunction<UpdateCaseFieldAttachmentResponsesMutation, UpdateCaseFieldAttachmentResponsesMutationVariables>;

/**
 * __useUpdateCaseFieldAttachmentResponsesMutation__
 *
 * To run a mutation, you first call `useUpdateCaseFieldAttachmentResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseFieldAttachmentResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseFieldAttachmentResponsesMutation, { data, loading, error }] = useUpdateCaseFieldAttachmentResponsesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseFieldAttachmentResponsesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseFieldAttachmentResponsesMutation, UpdateCaseFieldAttachmentResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseFieldAttachmentResponsesMutation, UpdateCaseFieldAttachmentResponsesMutationVariables>(UpdateCaseFieldAttachmentResponsesDocument, options);
      }
export type UpdateCaseFieldAttachmentResponsesMutationHookResult = ReturnType<typeof useUpdateCaseFieldAttachmentResponsesMutation>;
export type UpdateCaseFieldAttachmentResponsesMutationResult = Apollo.MutationResult<UpdateCaseFieldAttachmentResponsesMutation>;
export type UpdateCaseFieldAttachmentResponsesMutationOptions = Apollo.BaseMutationOptions<UpdateCaseFieldAttachmentResponsesMutation, UpdateCaseFieldAttachmentResponsesMutationVariables>;
export const UpdateCaseResultAttachmentsDocument = gql`
    mutation updateCaseResultAttachments($input: UpdateCaseResultAttachmentsInput!) {
  updateCaseResultAttachments(input: $input) {
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type UpdateCaseResultAttachmentsMutationFn = Apollo.MutationFunction<UpdateCaseResultAttachmentsMutation, UpdateCaseResultAttachmentsMutationVariables>;

/**
 * __useUpdateCaseResultAttachmentsMutation__
 *
 * To run a mutation, you first call `useUpdateCaseResultAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseResultAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseResultAttachmentsMutation, { data, loading, error }] = useUpdateCaseResultAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseResultAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseResultAttachmentsMutation, UpdateCaseResultAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseResultAttachmentsMutation, UpdateCaseResultAttachmentsMutationVariables>(UpdateCaseResultAttachmentsDocument, options);
      }
export type UpdateCaseResultAttachmentsMutationHookResult = ReturnType<typeof useUpdateCaseResultAttachmentsMutation>;
export type UpdateCaseResultAttachmentsMutationResult = Apollo.MutationResult<UpdateCaseResultAttachmentsMutation>;
export type UpdateCaseResultAttachmentsMutationOptions = Apollo.BaseMutationOptions<UpdateCaseResultAttachmentsMutation, UpdateCaseResultAttachmentsMutationVariables>;
export const CreateTesterSurveyResponseDocument = gql`
    mutation createTesterSurveyResponse($input: CreateTesterSurveyResponseInput!) {
  mutation: createTesterSurveyResponse(input: $input) {
    result
    successful
    errors {
      message
      code
      path
    }
  }
}
    `;
export type CreateTesterSurveyResponseMutationFn = Apollo.MutationFunction<CreateTesterSurveyResponseMutation, CreateTesterSurveyResponseMutationVariables>;

/**
 * __useCreateTesterSurveyResponseMutation__
 *
 * To run a mutation, you first call `useCreateTesterSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTesterSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTesterSurveyResponseMutation, { data, loading, error }] = useCreateTesterSurveyResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTesterSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateTesterSurveyResponseMutation, CreateTesterSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTesterSurveyResponseMutation, CreateTesterSurveyResponseMutationVariables>(CreateTesterSurveyResponseDocument, options);
      }
export type CreateTesterSurveyResponseMutationHookResult = ReturnType<typeof useCreateTesterSurveyResponseMutation>;
export type CreateTesterSurveyResponseMutationResult = Apollo.MutationResult<CreateTesterSurveyResponseMutation>;
export type CreateTesterSurveyResponseMutationOptions = Apollo.BaseMutationOptions<CreateTesterSurveyResponseMutation, CreateTesterSurveyResponseMutationVariables>;
export const GetTesterSurveyDocument = gql`
    query getTesterSurvey($id: ID!) {
  survey(id: $id) {
    content
    completed
  }
}
    `;

/**
 * __useGetTesterSurveyQuery__
 *
 * To run a query within a React component, call `useGetTesterSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTesterSurveyQuery(baseOptions: Apollo.QueryHookOptions<GetTesterSurveyQuery, GetTesterSurveyQueryVariables> & ({ variables: GetTesterSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterSurveyQuery, GetTesterSurveyQueryVariables>(GetTesterSurveyDocument, options);
      }
export function useGetTesterSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterSurveyQuery, GetTesterSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterSurveyQuery, GetTesterSurveyQueryVariables>(GetTesterSurveyDocument, options);
        }
export function useGetTesterSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterSurveyQuery, GetTesterSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterSurveyQuery, GetTesterSurveyQueryVariables>(GetTesterSurveyDocument, options);
        }
export type GetTesterSurveyQueryHookResult = ReturnType<typeof useGetTesterSurveyQuery>;
export type GetTesterSurveyLazyQueryHookResult = ReturnType<typeof useGetTesterSurveyLazyQuery>;
export type GetTesterSurveySuspenseQueryHookResult = ReturnType<typeof useGetTesterSurveySuspenseQuery>;
export type GetTesterSurveyQueryResult = Apollo.QueryResult<GetTesterSurveyQuery, GetTesterSurveyQueryVariables>;
export const GetTestCycleInvitationDocument = gql`
    query getTestCycleInvitation($token: String!) {
  testCycleInvitation(token: $token) {
    id
    accepted
    testerSpreadsheet {
      id
      url
    }
  }
}
    `;

/**
 * __useGetTestCycleInvitationQuery__
 *
 * To run a query within a React component, call `useGetTestCycleInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestCycleInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestCycleInvitationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetTestCycleInvitationQuery(baseOptions: Apollo.QueryHookOptions<GetTestCycleInvitationQuery, GetTestCycleInvitationQueryVariables> & ({ variables: GetTestCycleInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestCycleInvitationQuery, GetTestCycleInvitationQueryVariables>(GetTestCycleInvitationDocument, options);
      }
export function useGetTestCycleInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestCycleInvitationQuery, GetTestCycleInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestCycleInvitationQuery, GetTestCycleInvitationQueryVariables>(GetTestCycleInvitationDocument, options);
        }
export function useGetTestCycleInvitationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestCycleInvitationQuery, GetTestCycleInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestCycleInvitationQuery, GetTestCycleInvitationQueryVariables>(GetTestCycleInvitationDocument, options);
        }
export type GetTestCycleInvitationQueryHookResult = ReturnType<typeof useGetTestCycleInvitationQuery>;
export type GetTestCycleInvitationLazyQueryHookResult = ReturnType<typeof useGetTestCycleInvitationLazyQuery>;
export type GetTestCycleInvitationSuspenseQueryHookResult = ReturnType<typeof useGetTestCycleInvitationSuspenseQuery>;
export type GetTestCycleInvitationQueryResult = Apollo.QueryResult<GetTestCycleInvitationQuery, GetTestCycleInvitationQueryVariables>;
export const UpdateCheckUpVerificationDocument = gql`
    mutation updateCheckUpVerification($input: UpdateCheckUpVerificationInput!) {
  updateCheckUpVerification(input: $input) {
    errors {
      message
      code
      path
    }
    successful
    result {
      mobileDeviceOwnerships {
        id
        mobileDeviceId
        mobileDeviceOwnershipId
        name
        operatingSystemNameWithVersion
        operatingSystemVersionId
        platformCode
      }
      operatingSystemOwnerships {
        id
        nameWithVersion
        operatingSystemId
        operatingSystemOwnershipId
        operatingSystemVersionId
      }
    }
  }
}
    `;
export type UpdateCheckUpVerificationMutationFn = Apollo.MutationFunction<UpdateCheckUpVerificationMutation, UpdateCheckUpVerificationMutationVariables>;

/**
 * __useUpdateCheckUpVerificationMutation__
 *
 * To run a mutation, you first call `useUpdateCheckUpVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckUpVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckUpVerificationMutation, { data, loading, error }] = useUpdateCheckUpVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckUpVerificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckUpVerificationMutation, UpdateCheckUpVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckUpVerificationMutation, UpdateCheckUpVerificationMutationVariables>(UpdateCheckUpVerificationDocument, options);
      }
export type UpdateCheckUpVerificationMutationHookResult = ReturnType<typeof useUpdateCheckUpVerificationMutation>;
export type UpdateCheckUpVerificationMutationResult = Apollo.MutationResult<UpdateCheckUpVerificationMutation>;
export type UpdateCheckUpVerificationMutationOptions = Apollo.BaseMutationOptions<UpdateCheckUpVerificationMutation, UpdateCheckUpVerificationMutationVariables>;
export const ConfirmTesterConsentsDocument = gql`
    mutation confirmTesterConsents($input: ConfirmTesterConsentsInput!) {
  confirmTesterConsents(input: $input) {
    result
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type ConfirmTesterConsentsMutationFn = Apollo.MutationFunction<ConfirmTesterConsentsMutation, ConfirmTesterConsentsMutationVariables>;

/**
 * __useConfirmTesterConsentsMutation__
 *
 * To run a mutation, you first call `useConfirmTesterConsentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTesterConsentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTesterConsentsMutation, { data, loading, error }] = useConfirmTesterConsentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmTesterConsentsMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTesterConsentsMutation, ConfirmTesterConsentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmTesterConsentsMutation, ConfirmTesterConsentsMutationVariables>(ConfirmTesterConsentsDocument, options);
      }
export type ConfirmTesterConsentsMutationHookResult = ReturnType<typeof useConfirmTesterConsentsMutation>;
export type ConfirmTesterConsentsMutationResult = Apollo.MutationResult<ConfirmTesterConsentsMutation>;
export type ConfirmTesterConsentsMutationOptions = Apollo.BaseMutationOptions<ConfirmTesterConsentsMutation, ConfirmTesterConsentsMutationVariables>;
export const GetTestCycleDocument = gql`
    query getTestCycle($id: ID!) {
  testCycle(id: $id) {
    status
    startAt
    calculatedEndAt
    inProgress
    customerName
    testCycleCode
    applicationInfo
    payoutDetails {
      severity
      baseAmount
      rankAmount
      boostedAmount
    }
    deviceRequirements
    payoutBoostLabel
    trackerProjectUrl
    testCasesDocumentUrl
    testerSpecificationLink
    invitation {
      token
      accepted
      onWaitingList
    }
  }
}
    `;

/**
 * __useGetTestCycleQuery__
 *
 * To run a query within a React component, call `useGetTestCycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestCycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestCycleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTestCycleQuery(baseOptions: Apollo.QueryHookOptions<GetTestCycleQuery, GetTestCycleQueryVariables> & ({ variables: GetTestCycleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestCycleQuery, GetTestCycleQueryVariables>(GetTestCycleDocument, options);
      }
export function useGetTestCycleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestCycleQuery, GetTestCycleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestCycleQuery, GetTestCycleQueryVariables>(GetTestCycleDocument, options);
        }
export function useGetTestCycleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestCycleQuery, GetTestCycleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestCycleQuery, GetTestCycleQueryVariables>(GetTestCycleDocument, options);
        }
export type GetTestCycleQueryHookResult = ReturnType<typeof useGetTestCycleQuery>;
export type GetTestCycleLazyQueryHookResult = ReturnType<typeof useGetTestCycleLazyQuery>;
export type GetTestCycleSuspenseQueryHookResult = ReturnType<typeof useGetTestCycleSuspenseQuery>;
export type GetTestCycleQueryResult = Apollo.QueryResult<GetTestCycleQuery, GetTestCycleQueryVariables>;
export const UpdateTestCycleInvitationDocument = gql`
    mutation updateTestCycleInvitation($input: UpdateTestCycleInvitationInput!) {
  updateTestCycleInvitation(input: $input) {
    result {
      id
      accepted
      testerSpreadsheet {
        id
        url
      }
    }
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type UpdateTestCycleInvitationMutationFn = Apollo.MutationFunction<UpdateTestCycleInvitationMutation, UpdateTestCycleInvitationMutationVariables>;

/**
 * __useUpdateTestCycleInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateTestCycleInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestCycleInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestCycleInvitationMutation, { data, loading, error }] = useUpdateTestCycleInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestCycleInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestCycleInvitationMutation, UpdateTestCycleInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestCycleInvitationMutation, UpdateTestCycleInvitationMutationVariables>(UpdateTestCycleInvitationDocument, options);
      }
export type UpdateTestCycleInvitationMutationHookResult = ReturnType<typeof useUpdateTestCycleInvitationMutation>;
export type UpdateTestCycleInvitationMutationResult = Apollo.MutationResult<UpdateTestCycleInvitationMutation>;
export type UpdateTestCycleInvitationMutationOptions = Apollo.BaseMutationOptions<UpdateTestCycleInvitationMutation, UpdateTestCycleInvitationMutationVariables>;
export const GetTesterRankDocument = gql`
    query getTesterRank {
  tester {
    testerRank {
      tierCode
      tierPayoutMultiplier
    }
  }
}
    `;

/**
 * __useGetTesterRankQuery__
 *
 * To run a query within a React component, call `useGetTesterRankQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterRankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterRankQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterRankQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterRankQuery, GetTesterRankQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterRankQuery, GetTesterRankQueryVariables>(GetTesterRankDocument, options);
      }
export function useGetTesterRankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterRankQuery, GetTesterRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterRankQuery, GetTesterRankQueryVariables>(GetTesterRankDocument, options);
        }
export function useGetTesterRankSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterRankQuery, GetTesterRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterRankQuery, GetTesterRankQueryVariables>(GetTesterRankDocument, options);
        }
export type GetTesterRankQueryHookResult = ReturnType<typeof useGetTesterRankQuery>;
export type GetTesterRankLazyQueryHookResult = ReturnType<typeof useGetTesterRankLazyQuery>;
export type GetTesterRankSuspenseQueryHookResult = ReturnType<typeof useGetTesterRankSuspenseQuery>;
export type GetTesterRankQueryResult = Apollo.QueryResult<GetTesterRankQuery, GetTesterRankQueryVariables>;
export const GetPayoutsDocument = gql`
    query getPayouts($after: String, $pageSize: Int!) {
  payouts(after: $after, first: $pageSize) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        amountFormatted
        amountChangeReason
        correction
        key
        paidOn
        payoutSystemMemo
        shortPublicId
        status
        details {
          title
          status
          errorMessage
          errorExplanation
        }
        payoutItems {
          edges {
            node {
              id
              amountFormatted
              summary
              subject
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPayoutsQuery__
 *
 * To run a query within a React component, call `useGetPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetPayoutsQuery(baseOptions: Apollo.QueryHookOptions<GetPayoutsQuery, GetPayoutsQueryVariables> & ({ variables: GetPayoutsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(GetPayoutsDocument, options);
      }
export function useGetPayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayoutsQuery, GetPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(GetPayoutsDocument, options);
        }
export function useGetPayoutsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayoutsQuery, GetPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(GetPayoutsDocument, options);
        }
export type GetPayoutsQueryHookResult = ReturnType<typeof useGetPayoutsQuery>;
export type GetPayoutsLazyQueryHookResult = ReturnType<typeof useGetPayoutsLazyQuery>;
export type GetPayoutsSuspenseQueryHookResult = ReturnType<typeof useGetPayoutsSuspenseQuery>;
export type GetPayoutsQueryResult = Apollo.QueryResult<GetPayoutsQuery, GetPayoutsQueryVariables>;
export const GetJoinedTestsDocument = gql`
    query getJoinedTests {
  joinedTests {
    edges {
      node {
        id
        isParticipating
        status
        statusLabel
        applicationName
        testType
        externalUrl
        code
        payoutBoostLabel
        deviceName
        platformCode
        shortDescription
        promotedGroup
        isClosed
        testId
      }
    }
  }
}
    `;

/**
 * __useGetJoinedTestsQuery__
 *
 * To run a query within a React component, call `useGetJoinedTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJoinedTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJoinedTestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJoinedTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetJoinedTestsQuery, GetJoinedTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJoinedTestsQuery, GetJoinedTestsQueryVariables>(GetJoinedTestsDocument, options);
      }
export function useGetJoinedTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJoinedTestsQuery, GetJoinedTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJoinedTestsQuery, GetJoinedTestsQueryVariables>(GetJoinedTestsDocument, options);
        }
export function useGetJoinedTestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJoinedTestsQuery, GetJoinedTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJoinedTestsQuery, GetJoinedTestsQueryVariables>(GetJoinedTestsDocument, options);
        }
export type GetJoinedTestsQueryHookResult = ReturnType<typeof useGetJoinedTestsQuery>;
export type GetJoinedTestsLazyQueryHookResult = ReturnType<typeof useGetJoinedTestsLazyQuery>;
export type GetJoinedTestsSuspenseQueryHookResult = ReturnType<typeof useGetJoinedTestsSuspenseQuery>;
export type GetJoinedTestsQueryResult = Apollo.QueryResult<GetJoinedTestsQuery, GetJoinedTestsQueryVariables>;
export const GetRankingIssuesDocument = gql`
    query getRankingIssues($isRejected: Boolean!, $after: String, $pageSize: Int!) {
  rankingItems(
    filters: {is_rejected: $isRejected}
    after: $after
    first: $pageSize
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        name
        resolution
        points
        moderationFeedback
      }
    }
  }
}
    `;

/**
 * __useGetRankingIssuesQuery__
 *
 * To run a query within a React component, call `useGetRankingIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRankingIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRankingIssuesQuery({
 *   variables: {
 *      isRejected: // value for 'isRejected'
 *      after: // value for 'after'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetRankingIssuesQuery(baseOptions: Apollo.QueryHookOptions<GetRankingIssuesQuery, GetRankingIssuesQueryVariables> & ({ variables: GetRankingIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRankingIssuesQuery, GetRankingIssuesQueryVariables>(GetRankingIssuesDocument, options);
      }
export function useGetRankingIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRankingIssuesQuery, GetRankingIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRankingIssuesQuery, GetRankingIssuesQueryVariables>(GetRankingIssuesDocument, options);
        }
export function useGetRankingIssuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRankingIssuesQuery, GetRankingIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRankingIssuesQuery, GetRankingIssuesQueryVariables>(GetRankingIssuesDocument, options);
        }
export type GetRankingIssuesQueryHookResult = ReturnType<typeof useGetRankingIssuesQuery>;
export type GetRankingIssuesLazyQueryHookResult = ReturnType<typeof useGetRankingIssuesLazyQuery>;
export type GetRankingIssuesSuspenseQueryHookResult = ReturnType<typeof useGetRankingIssuesSuspenseQuery>;
export type GetRankingIssuesQueryResult = Apollo.QueryResult<GetRankingIssuesQuery, GetRankingIssuesQueryVariables>;
export const GetTesterPerformanceDocument = gql`
    query getTesterPerformance($period: TesterPerformancePeriod!) {
  testerPerformance(period: $period) {
    acceptanceRate
    acceptanceRatePercentChange
    issuesCount
    acceptedIssuesCount
    acceptedIssuesWithoutEditsCount
    improvementTips {
      details
      messagePlaceholderName
      messagePlaceholderValue
      messageTemplate
      tooltip
    }
  }
}
    `;

/**
 * __useGetTesterPerformanceQuery__
 *
 * To run a query within a React component, call `useGetTesterPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterPerformanceQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetTesterPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetTesterPerformanceQuery, GetTesterPerformanceQueryVariables> & ({ variables: GetTesterPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterPerformanceQuery, GetTesterPerformanceQueryVariables>(GetTesterPerformanceDocument, options);
      }
export function useGetTesterPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterPerformanceQuery, GetTesterPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterPerformanceQuery, GetTesterPerformanceQueryVariables>(GetTesterPerformanceDocument, options);
        }
export function useGetTesterPerformanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterPerformanceQuery, GetTesterPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterPerformanceQuery, GetTesterPerformanceQueryVariables>(GetTesterPerformanceDocument, options);
        }
export type GetTesterPerformanceQueryHookResult = ReturnType<typeof useGetTesterPerformanceQuery>;
export type GetTesterPerformanceLazyQueryHookResult = ReturnType<typeof useGetTesterPerformanceLazyQuery>;
export type GetTesterPerformanceSuspenseQueryHookResult = ReturnType<typeof useGetTesterPerformanceSuspenseQuery>;
export type GetTesterPerformanceQueryResult = Apollo.QueryResult<GetTesterPerformanceQuery, GetTesterPerformanceQueryVariables>;
export const GetAvailabilityConfigDocument = gql`
    query getAvailabilityConfig {
  availabilityConfig {
    weekTimeSlots {
      timeSlotCode
      isoDayOfWeek
    }
    timesOfDay {
      name
      startTime
      endTime
    }
    daysOfWeek {
      isoDayOfWeek
      name
    }
  }
}
    `;

/**
 * __useGetAvailabilityConfigQuery__
 *
 * To run a query within a React component, call `useGetAvailabilityConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailabilityConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailabilityConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailabilityConfigQuery, GetAvailabilityConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailabilityConfigQuery, GetAvailabilityConfigQueryVariables>(GetAvailabilityConfigDocument, options);
      }
export function useGetAvailabilityConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailabilityConfigQuery, GetAvailabilityConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailabilityConfigQuery, GetAvailabilityConfigQueryVariables>(GetAvailabilityConfigDocument, options);
        }
export function useGetAvailabilityConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailabilityConfigQuery, GetAvailabilityConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailabilityConfigQuery, GetAvailabilityConfigQueryVariables>(GetAvailabilityConfigDocument, options);
        }
export type GetAvailabilityConfigQueryHookResult = ReturnType<typeof useGetAvailabilityConfigQuery>;
export type GetAvailabilityConfigLazyQueryHookResult = ReturnType<typeof useGetAvailabilityConfigLazyQuery>;
export type GetAvailabilityConfigSuspenseQueryHookResult = ReturnType<typeof useGetAvailabilityConfigSuspenseQuery>;
export type GetAvailabilityConfigQueryResult = Apollo.QueryResult<GetAvailabilityConfigQuery, GetAvailabilityConfigQueryVariables>;
export const GetTesterAvailabilityCalendarDocument = gql`
    query getTesterAvailabilityCalendar {
  tester {
    id
    availabilityCalendar {
      id
      timeZoneName
      nextPossibleUpdateDateTime
      availabilities {
        timeSlotCode
        available
      }
    }
  }
}
    `;

/**
 * __useGetTesterAvailabilityCalendarQuery__
 *
 * To run a query within a React component, call `useGetTesterAvailabilityCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterAvailabilityCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterAvailabilityCalendarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterAvailabilityCalendarQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterAvailabilityCalendarQuery, GetTesterAvailabilityCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterAvailabilityCalendarQuery, GetTesterAvailabilityCalendarQueryVariables>(GetTesterAvailabilityCalendarDocument, options);
      }
export function useGetTesterAvailabilityCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterAvailabilityCalendarQuery, GetTesterAvailabilityCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterAvailabilityCalendarQuery, GetTesterAvailabilityCalendarQueryVariables>(GetTesterAvailabilityCalendarDocument, options);
        }
export function useGetTesterAvailabilityCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterAvailabilityCalendarQuery, GetTesterAvailabilityCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterAvailabilityCalendarQuery, GetTesterAvailabilityCalendarQueryVariables>(GetTesterAvailabilityCalendarDocument, options);
        }
export type GetTesterAvailabilityCalendarQueryHookResult = ReturnType<typeof useGetTesterAvailabilityCalendarQuery>;
export type GetTesterAvailabilityCalendarLazyQueryHookResult = ReturnType<typeof useGetTesterAvailabilityCalendarLazyQuery>;
export type GetTesterAvailabilityCalendarSuspenseQueryHookResult = ReturnType<typeof useGetTesterAvailabilityCalendarSuspenseQuery>;
export type GetTesterAvailabilityCalendarQueryResult = Apollo.QueryResult<GetTesterAvailabilityCalendarQuery, GetTesterAvailabilityCalendarQueryVariables>;
export const UpdateTesterAvailabilityCalendarDocument = gql`
    mutation updateTesterAvailabilityCalendar($input: UpdateTesterAvailabilityCalendarInput!) {
  updateTesterAvailabilityCalendar(input: $input) {
    result {
      id
      availabilityCalendar {
        id
        timeZoneName
        nextPossibleUpdateDateTime
        availabilities {
          timeSlotCode
          available
        }
      }
    }
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type UpdateTesterAvailabilityCalendarMutationFn = Apollo.MutationFunction<UpdateTesterAvailabilityCalendarMutation, UpdateTesterAvailabilityCalendarMutationVariables>;

/**
 * __useUpdateTesterAvailabilityCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateTesterAvailabilityCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTesterAvailabilityCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTesterAvailabilityCalendarMutation, { data, loading, error }] = useUpdateTesterAvailabilityCalendarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTesterAvailabilityCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTesterAvailabilityCalendarMutation, UpdateTesterAvailabilityCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTesterAvailabilityCalendarMutation, UpdateTesterAvailabilityCalendarMutationVariables>(UpdateTesterAvailabilityCalendarDocument, options);
      }
export type UpdateTesterAvailabilityCalendarMutationHookResult = ReturnType<typeof useUpdateTesterAvailabilityCalendarMutation>;
export type UpdateTesterAvailabilityCalendarMutationResult = Apollo.MutationResult<UpdateTesterAvailabilityCalendarMutation>;
export type UpdateTesterAvailabilityCalendarMutationOptions = Apollo.BaseMutationOptions<UpdateTesterAvailabilityCalendarMutation, UpdateTesterAvailabilityCalendarMutationVariables>;
export const GetOperatingSystemOwnershipsDocument = gql`
    query getOperatingSystemOwnerships {
  operatingSystemOwnerships {
    id
    nameWithVersion
    operatingSystemId
    operatingSystemOwnershipId
    operatingSystemVersionId
  }
}
    `;

/**
 * __useGetOperatingSystemOwnershipsQuery__
 *
 * To run a query within a React component, call `useGetOperatingSystemOwnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatingSystemOwnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatingSystemOwnershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOperatingSystemOwnershipsQuery(baseOptions?: Apollo.QueryHookOptions<GetOperatingSystemOwnershipsQuery, GetOperatingSystemOwnershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperatingSystemOwnershipsQuery, GetOperatingSystemOwnershipsQueryVariables>(GetOperatingSystemOwnershipsDocument, options);
      }
export function useGetOperatingSystemOwnershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperatingSystemOwnershipsQuery, GetOperatingSystemOwnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperatingSystemOwnershipsQuery, GetOperatingSystemOwnershipsQueryVariables>(GetOperatingSystemOwnershipsDocument, options);
        }
export function useGetOperatingSystemOwnershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperatingSystemOwnershipsQuery, GetOperatingSystemOwnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperatingSystemOwnershipsQuery, GetOperatingSystemOwnershipsQueryVariables>(GetOperatingSystemOwnershipsDocument, options);
        }
export type GetOperatingSystemOwnershipsQueryHookResult = ReturnType<typeof useGetOperatingSystemOwnershipsQuery>;
export type GetOperatingSystemOwnershipsLazyQueryHookResult = ReturnType<typeof useGetOperatingSystemOwnershipsLazyQuery>;
export type GetOperatingSystemOwnershipsSuspenseQueryHookResult = ReturnType<typeof useGetOperatingSystemOwnershipsSuspenseQuery>;
export type GetOperatingSystemOwnershipsQueryResult = Apollo.QueryResult<GetOperatingSystemOwnershipsQuery, GetOperatingSystemOwnershipsQueryVariables>;
export const UpdateMobileDeviceOwnershipDocument = gql`
    mutation updateMobileDeviceOwnership($input: UpdateMobileDeviceOwnershipInput!) {
  updateMobileDeviceOwnership(input: $input) {
    errors {
      message
      code
      path
    }
    successful
    result {
      id
      operatingSystemNameWithVersion
      operatingSystemVersionId
      mobileDeviceId
      platformCode
      mobileDeviceOwnershipId
    }
  }
}
    `;
export type UpdateMobileDeviceOwnershipMutationFn = Apollo.MutationFunction<UpdateMobileDeviceOwnershipMutation, UpdateMobileDeviceOwnershipMutationVariables>;

/**
 * __useUpdateMobileDeviceOwnershipMutation__
 *
 * To run a mutation, you first call `useUpdateMobileDeviceOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMobileDeviceOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMobileDeviceOwnershipMutation, { data, loading, error }] = useUpdateMobileDeviceOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMobileDeviceOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMobileDeviceOwnershipMutation, UpdateMobileDeviceOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMobileDeviceOwnershipMutation, UpdateMobileDeviceOwnershipMutationVariables>(UpdateMobileDeviceOwnershipDocument, options);
      }
export type UpdateMobileDeviceOwnershipMutationHookResult = ReturnType<typeof useUpdateMobileDeviceOwnershipMutation>;
export type UpdateMobileDeviceOwnershipMutationResult = Apollo.MutationResult<UpdateMobileDeviceOwnershipMutation>;
export type UpdateMobileDeviceOwnershipMutationOptions = Apollo.BaseMutationOptions<UpdateMobileDeviceOwnershipMutation, UpdateMobileDeviceOwnershipMutationVariables>;
export const UpdateOperatingSystemOwnershipDocument = gql`
    mutation updateOperatingSystemOwnership($input: UpdateOperatingSystemOwnershipInput!) {
  updateOperatingSystemOwnership(input: $input) {
    errors {
      message
      code
      path
    }
    successful
    result {
      id
      nameWithVersion
      operatingSystemId
      operatingSystemOwnershipId
      operatingSystemVersionId
    }
  }
}
    `;
export type UpdateOperatingSystemOwnershipMutationFn = Apollo.MutationFunction<UpdateOperatingSystemOwnershipMutation, UpdateOperatingSystemOwnershipMutationVariables>;

/**
 * __useUpdateOperatingSystemOwnershipMutation__
 *
 * To run a mutation, you first call `useUpdateOperatingSystemOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOperatingSystemOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOperatingSystemOwnershipMutation, { data, loading, error }] = useUpdateOperatingSystemOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOperatingSystemOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOperatingSystemOwnershipMutation, UpdateOperatingSystemOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOperatingSystemOwnershipMutation, UpdateOperatingSystemOwnershipMutationVariables>(UpdateOperatingSystemOwnershipDocument, options);
      }
export type UpdateOperatingSystemOwnershipMutationHookResult = ReturnType<typeof useUpdateOperatingSystemOwnershipMutation>;
export type UpdateOperatingSystemOwnershipMutationResult = Apollo.MutationResult<UpdateOperatingSystemOwnershipMutation>;
export type UpdateOperatingSystemOwnershipMutationOptions = Apollo.BaseMutationOptions<UpdateOperatingSystemOwnershipMutation, UpdateOperatingSystemOwnershipMutationVariables>;
export const GetTesterLocationDocument = gql`
    query getTesterLocation {
  tester {
    id
    address
    city
    countryId
    postcode
    profileCompletenessStage
    region
  }
}
    `;

/**
 * __useGetTesterLocationQuery__
 *
 * To run a query within a React component, call `useGetTesterLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterLocationQuery, GetTesterLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterLocationQuery, GetTesterLocationQueryVariables>(GetTesterLocationDocument, options);
      }
export function useGetTesterLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterLocationQuery, GetTesterLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterLocationQuery, GetTesterLocationQueryVariables>(GetTesterLocationDocument, options);
        }
export function useGetTesterLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterLocationQuery, GetTesterLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterLocationQuery, GetTesterLocationQueryVariables>(GetTesterLocationDocument, options);
        }
export type GetTesterLocationQueryHookResult = ReturnType<typeof useGetTesterLocationQuery>;
export type GetTesterLocationLazyQueryHookResult = ReturnType<typeof useGetTesterLocationLazyQuery>;
export type GetTesterLocationSuspenseQueryHookResult = ReturnType<typeof useGetTesterLocationSuspenseQuery>;
export type GetTesterLocationQueryResult = Apollo.QueryResult<GetTesterLocationQuery, GetTesterLocationQueryVariables>;
export const GetMobileDeviceOwnershipsDocument = gql`
    query getMobileDeviceOwnerships {
  mobileDeviceOwnerships {
    id
    mobileDeviceId
    mobileDeviceOwnershipId
    name
    operatingSystemNameWithVersion
    operatingSystemVersionId
    platformCode
  }
}
    `;

/**
 * __useGetMobileDeviceOwnershipsQuery__
 *
 * To run a query within a React component, call `useGetMobileDeviceOwnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileDeviceOwnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileDeviceOwnershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMobileDeviceOwnershipsQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileDeviceOwnershipsQuery, GetMobileDeviceOwnershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileDeviceOwnershipsQuery, GetMobileDeviceOwnershipsQueryVariables>(GetMobileDeviceOwnershipsDocument, options);
      }
export function useGetMobileDeviceOwnershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileDeviceOwnershipsQuery, GetMobileDeviceOwnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileDeviceOwnershipsQuery, GetMobileDeviceOwnershipsQueryVariables>(GetMobileDeviceOwnershipsDocument, options);
        }
export function useGetMobileDeviceOwnershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileDeviceOwnershipsQuery, GetMobileDeviceOwnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileDeviceOwnershipsQuery, GetMobileDeviceOwnershipsQueryVariables>(GetMobileDeviceOwnershipsDocument, options);
        }
export type GetMobileDeviceOwnershipsQueryHookResult = ReturnType<typeof useGetMobileDeviceOwnershipsQuery>;
export type GetMobileDeviceOwnershipsLazyQueryHookResult = ReturnType<typeof useGetMobileDeviceOwnershipsLazyQuery>;
export type GetMobileDeviceOwnershipsSuspenseQueryHookResult = ReturnType<typeof useGetMobileDeviceOwnershipsSuspenseQuery>;
export type GetMobileDeviceOwnershipsQueryResult = Apollo.QueryResult<GetMobileDeviceOwnershipsQuery, GetMobileDeviceOwnershipsQueryVariables>;
export const GetTesterProfileDetailsDocument = gql`
    query getTesterProfileDetails {
  tester {
    id
    aboutMe
    birthday
    firstName
    gender
    lastName
    linkedinProfileLink
    phoneNumber
    profileCompletenessStage
    yearsOfTestingExperience
  }
}
    `;

/**
 * __useGetTesterProfileDetailsQuery__
 *
 * To run a query within a React component, call `useGetTesterProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterProfileDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterProfileDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterProfileDetailsQuery, GetTesterProfileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterProfileDetailsQuery, GetTesterProfileDetailsQueryVariables>(GetTesterProfileDetailsDocument, options);
      }
export function useGetTesterProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterProfileDetailsQuery, GetTesterProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterProfileDetailsQuery, GetTesterProfileDetailsQueryVariables>(GetTesterProfileDetailsDocument, options);
        }
export function useGetTesterProfileDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterProfileDetailsQuery, GetTesterProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterProfileDetailsQuery, GetTesterProfileDetailsQueryVariables>(GetTesterProfileDetailsDocument, options);
        }
export type GetTesterProfileDetailsQueryHookResult = ReturnType<typeof useGetTesterProfileDetailsQuery>;
export type GetTesterProfileDetailsLazyQueryHookResult = ReturnType<typeof useGetTesterProfileDetailsLazyQuery>;
export type GetTesterProfileDetailsSuspenseQueryHookResult = ReturnType<typeof useGetTesterProfileDetailsSuspenseQuery>;
export type GetTesterProfileDetailsQueryResult = Apollo.QueryResult<GetTesterProfileDetailsQuery, GetTesterProfileDetailsQueryVariables>;
export const GetTestingSettingsDocument = gql`
    query getTestingSettings {
  languages {
    label
    value
  }
  languageProficiencyLevels {
    label
    value
  }
  testerFields {
    label
    code
    type
    completed
    value
    alphabeticalOrder
    options {
      id
      value
      label
      selected
    }
  }
  languageProficiencies {
    id
    languageId
    level
  }
}
    `;

/**
 * __useGetTestingSettingsQuery__
 *
 * To run a query within a React component, call `useGetTestingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestingSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTestingSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetTestingSettingsQuery, GetTestingSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestingSettingsQuery, GetTestingSettingsQueryVariables>(GetTestingSettingsDocument, options);
      }
export function useGetTestingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestingSettingsQuery, GetTestingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestingSettingsQuery, GetTestingSettingsQueryVariables>(GetTestingSettingsDocument, options);
        }
export function useGetTestingSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestingSettingsQuery, GetTestingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestingSettingsQuery, GetTestingSettingsQueryVariables>(GetTestingSettingsDocument, options);
        }
export type GetTestingSettingsQueryHookResult = ReturnType<typeof useGetTestingSettingsQuery>;
export type GetTestingSettingsLazyQueryHookResult = ReturnType<typeof useGetTestingSettingsLazyQuery>;
export type GetTestingSettingsSuspenseQueryHookResult = ReturnType<typeof useGetTestingSettingsSuspenseQuery>;
export type GetTestingSettingsQueryResult = Apollo.QueryResult<GetTestingSettingsQuery, GetTestingSettingsQueryVariables>;
export const UpdateTestingSettingsDocument = gql`
    mutation updateTestingSettings($input: UpdateTestingSettingsInput!) {
  updateTestingSettings(input: $input) {
    result {
      profileCompletenessStage
      languageProficiencies {
        id
        languageId
        level
      }
      testerFields {
        label
        code
        type
        completed
        value
        options {
          id
          value
          label
          selected
        }
      }
    }
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type UpdateTestingSettingsMutationFn = Apollo.MutationFunction<UpdateTestingSettingsMutation, UpdateTestingSettingsMutationVariables>;

/**
 * __useUpdateTestingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTestingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestingSettingsMutation, { data, loading, error }] = useUpdateTestingSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestingSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestingSettingsMutation, UpdateTestingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestingSettingsMutation, UpdateTestingSettingsMutationVariables>(UpdateTestingSettingsDocument, options);
      }
export type UpdateTestingSettingsMutationHookResult = ReturnType<typeof useUpdateTestingSettingsMutation>;
export type UpdateTestingSettingsMutationResult = Apollo.MutationResult<UpdateTestingSettingsMutation>;
export type UpdateTestingSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTestingSettingsMutation, UpdateTestingSettingsMutationVariables>;
export const CreateVpnGatewayPeerDocument = gql`
    mutation createVpnGatewayPeer($input: CreateVPNGatewayPeerInput!) {
  mutation: createVpnGatewayPeer(input: $input) {
    result {
      publicKey
      lastConnectedAt
      userConfig
      userConfigQrcodeSvg
    }
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type CreateVpnGatewayPeerMutationFn = Apollo.MutationFunction<CreateVpnGatewayPeerMutation, CreateVpnGatewayPeerMutationVariables>;

/**
 * __useCreateVpnGatewayPeerMutation__
 *
 * To run a mutation, you first call `useCreateVpnGatewayPeerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVpnGatewayPeerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVpnGatewayPeerMutation, { data, loading, error }] = useCreateVpnGatewayPeerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVpnGatewayPeerMutation(baseOptions?: Apollo.MutationHookOptions<CreateVpnGatewayPeerMutation, CreateVpnGatewayPeerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVpnGatewayPeerMutation, CreateVpnGatewayPeerMutationVariables>(CreateVpnGatewayPeerDocument, options);
      }
export type CreateVpnGatewayPeerMutationHookResult = ReturnType<typeof useCreateVpnGatewayPeerMutation>;
export type CreateVpnGatewayPeerMutationResult = Apollo.MutationResult<CreateVpnGatewayPeerMutation>;
export type CreateVpnGatewayPeerMutationOptions = Apollo.BaseMutationOptions<CreateVpnGatewayPeerMutation, CreateVpnGatewayPeerMutationVariables>;
export const DestroyVpnGatewayPeerDocument = gql`
    mutation destroyVpnGatewayPeer($input: DestroyVPNGatewayPeerInput!) {
  mutation: destroyVpnGatewayPeer(input: $input) {
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type DestroyVpnGatewayPeerMutationFn = Apollo.MutationFunction<DestroyVpnGatewayPeerMutation, DestroyVpnGatewayPeerMutationVariables>;

/**
 * __useDestroyVpnGatewayPeerMutation__
 *
 * To run a mutation, you first call `useDestroyVpnGatewayPeerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyVpnGatewayPeerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyVpnGatewayPeerMutation, { data, loading, error }] = useDestroyVpnGatewayPeerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestroyVpnGatewayPeerMutation(baseOptions?: Apollo.MutationHookOptions<DestroyVpnGatewayPeerMutation, DestroyVpnGatewayPeerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyVpnGatewayPeerMutation, DestroyVpnGatewayPeerMutationVariables>(DestroyVpnGatewayPeerDocument, options);
      }
export type DestroyVpnGatewayPeerMutationHookResult = ReturnType<typeof useDestroyVpnGatewayPeerMutation>;
export type DestroyVpnGatewayPeerMutationResult = Apollo.MutationResult<DestroyVpnGatewayPeerMutation>;
export type DestroyVpnGatewayPeerMutationOptions = Apollo.BaseMutationOptions<DestroyVpnGatewayPeerMutation, DestroyVpnGatewayPeerMutationVariables>;
export const GetSubjectVpnGatewayPeerDocument = gql`
    query getSubjectVPNGatewayPeer($id: ID!) {
  node(id: $id) {
    ... on TesterOperatingSystemOwnership {
      __typename
      id
      vpnGatewayPeer {
        ...peer
      }
    }
    ... on TesterMobileDeviceOwnership {
      __typename
      id
      vpnGatewayPeer {
        ...peer
      }
    }
  }
}
    ${PeerFragmentDoc}`;

/**
 * __useGetSubjectVpnGatewayPeerQuery__
 *
 * To run a query within a React component, call `useGetSubjectVpnGatewayPeerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectVpnGatewayPeerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubjectVpnGatewayPeerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubjectVpnGatewayPeerQuery(baseOptions: Apollo.QueryHookOptions<GetSubjectVpnGatewayPeerQuery, GetSubjectVpnGatewayPeerQueryVariables> & ({ variables: GetSubjectVpnGatewayPeerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubjectVpnGatewayPeerQuery, GetSubjectVpnGatewayPeerQueryVariables>(GetSubjectVpnGatewayPeerDocument, options);
      }
export function useGetSubjectVpnGatewayPeerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubjectVpnGatewayPeerQuery, GetSubjectVpnGatewayPeerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubjectVpnGatewayPeerQuery, GetSubjectVpnGatewayPeerQueryVariables>(GetSubjectVpnGatewayPeerDocument, options);
        }
export function useGetSubjectVpnGatewayPeerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubjectVpnGatewayPeerQuery, GetSubjectVpnGatewayPeerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubjectVpnGatewayPeerQuery, GetSubjectVpnGatewayPeerQueryVariables>(GetSubjectVpnGatewayPeerDocument, options);
        }
export type GetSubjectVpnGatewayPeerQueryHookResult = ReturnType<typeof useGetSubjectVpnGatewayPeerQuery>;
export type GetSubjectVpnGatewayPeerLazyQueryHookResult = ReturnType<typeof useGetSubjectVpnGatewayPeerLazyQuery>;
export type GetSubjectVpnGatewayPeerSuspenseQueryHookResult = ReturnType<typeof useGetSubjectVpnGatewayPeerSuspenseQuery>;
export type GetSubjectVpnGatewayPeerQueryResult = Apollo.QueryResult<GetSubjectVpnGatewayPeerQuery, GetSubjectVpnGatewayPeerQueryVariables>;
export const GetTesterAccountSettingsDocument = gql`
    query getTesterAccountSettings {
  tester {
    id
    email
    payoutMethodId
    payoutMethodIdentifier
    profileCompletenessStage
    availablePreferences {
      key
      name
      description
    }
    preferences {
      id
      emailNotificationsEnabled
    }
  }
}
    `;

/**
 * __useGetTesterAccountSettingsQuery__
 *
 * To run a query within a React component, call `useGetTesterAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterAccountSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterAccountSettingsQuery, GetTesterAccountSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterAccountSettingsQuery, GetTesterAccountSettingsQueryVariables>(GetTesterAccountSettingsDocument, options);
      }
export function useGetTesterAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterAccountSettingsQuery, GetTesterAccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterAccountSettingsQuery, GetTesterAccountSettingsQueryVariables>(GetTesterAccountSettingsDocument, options);
        }
export function useGetTesterAccountSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterAccountSettingsQuery, GetTesterAccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterAccountSettingsQuery, GetTesterAccountSettingsQueryVariables>(GetTesterAccountSettingsDocument, options);
        }
export type GetTesterAccountSettingsQueryHookResult = ReturnType<typeof useGetTesterAccountSettingsQuery>;
export type GetTesterAccountSettingsLazyQueryHookResult = ReturnType<typeof useGetTesterAccountSettingsLazyQuery>;
export type GetTesterAccountSettingsSuspenseQueryHookResult = ReturnType<typeof useGetTesterAccountSettingsSuspenseQuery>;
export type GetTesterAccountSettingsQueryResult = Apollo.QueryResult<GetTesterAccountSettingsQuery, GetTesterAccountSettingsQueryVariables>;
export const UpdateAccountSettingsDocument = gql`
    mutation updateAccountSettings($input: UpdateAccountSettingsInput!) {
  updateAccountSettings(input: $input) {
    result {
      id
      firstName
      lastName
      gender
      birthday
      yearsOfTestingExperience
      aboutMe
      countryId
      city
      postcode
      address
      phoneNumber
      payoutMethodId
      payoutMethodIdentifier
      linkedinProfileLink
      region
      preferences {
        id
        emailNotificationsEnabled
      }
    }
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type UpdateAccountSettingsMutationFn = Apollo.MutationFunction<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>;

/**
 * __useUpdateAccountSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAccountSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountSettingsMutation, { data, loading, error }] = useUpdateAccountSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>(UpdateAccountSettingsDocument, options);
      }
export type UpdateAccountSettingsMutationHookResult = ReturnType<typeof useUpdateAccountSettingsMutation>;
export type UpdateAccountSettingsMutationResult = Apollo.MutationResult<UpdateAccountSettingsMutation>;
export type UpdateAccountSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAccountSettingsMutation, UpdateAccountSettingsMutationVariables>;
export const GetTesterQualityAssessmentTestDocument = gql`
    query getTesterQualityAssessmentTest {
  testerQualityAssessmentTest {
    name
    code
    description
    pages {
      name
      ordinalNumber
      description
      questions {
        id
        text
        answerType
        description
        answers {
          id
          text
        }
      }
    }
  }
  testerQualityAssessmentResponses {
    id
    questionId
    answerIds
  }
}
    `;

/**
 * __useGetTesterQualityAssessmentTestQuery__
 *
 * To run a query within a React component, call `useGetTesterQualityAssessmentTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterQualityAssessmentTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterQualityAssessmentTestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterQualityAssessmentTestQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterQualityAssessmentTestQuery, GetTesterQualityAssessmentTestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterQualityAssessmentTestQuery, GetTesterQualityAssessmentTestQueryVariables>(GetTesterQualityAssessmentTestDocument, options);
      }
export function useGetTesterQualityAssessmentTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterQualityAssessmentTestQuery, GetTesterQualityAssessmentTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterQualityAssessmentTestQuery, GetTesterQualityAssessmentTestQueryVariables>(GetTesterQualityAssessmentTestDocument, options);
        }
export function useGetTesterQualityAssessmentTestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterQualityAssessmentTestQuery, GetTesterQualityAssessmentTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterQualityAssessmentTestQuery, GetTesterQualityAssessmentTestQueryVariables>(GetTesterQualityAssessmentTestDocument, options);
        }
export type GetTesterQualityAssessmentTestQueryHookResult = ReturnType<typeof useGetTesterQualityAssessmentTestQuery>;
export type GetTesterQualityAssessmentTestLazyQueryHookResult = ReturnType<typeof useGetTesterQualityAssessmentTestLazyQuery>;
export type GetTesterQualityAssessmentTestSuspenseQueryHookResult = ReturnType<typeof useGetTesterQualityAssessmentTestSuspenseQuery>;
export type GetTesterQualityAssessmentTestQueryResult = Apollo.QueryResult<GetTesterQualityAssessmentTestQuery, GetTesterQualityAssessmentTestQueryVariables>;
export const UpdateTesterQualityAssessmentResponsesDocument = gql`
    mutation updateTesterQualityAssessmentResponses($input: UpdateTesterQualityAssessmentResponsesInput!) {
  updateTesterQualityAssessmentResponses(input: $input) {
    errors {
      message
      code
      path
    }
    successful
    result {
      id
      questionId
      answerIds
    }
  }
}
    `;
export type UpdateTesterQualityAssessmentResponsesMutationFn = Apollo.MutationFunction<UpdateTesterQualityAssessmentResponsesMutation, UpdateTesterQualityAssessmentResponsesMutationVariables>;

/**
 * __useUpdateTesterQualityAssessmentResponsesMutation__
 *
 * To run a mutation, you first call `useUpdateTesterQualityAssessmentResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTesterQualityAssessmentResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTesterQualityAssessmentResponsesMutation, { data, loading, error }] = useUpdateTesterQualityAssessmentResponsesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTesterQualityAssessmentResponsesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTesterQualityAssessmentResponsesMutation, UpdateTesterQualityAssessmentResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTesterQualityAssessmentResponsesMutation, UpdateTesterQualityAssessmentResponsesMutationVariables>(UpdateTesterQualityAssessmentResponsesDocument, options);
      }
export type UpdateTesterQualityAssessmentResponsesMutationHookResult = ReturnType<typeof useUpdateTesterQualityAssessmentResponsesMutation>;
export type UpdateTesterQualityAssessmentResponsesMutationResult = Apollo.MutationResult<UpdateTesterQualityAssessmentResponsesMutation>;
export type UpdateTesterQualityAssessmentResponsesMutationOptions = Apollo.BaseMutationOptions<UpdateTesterQualityAssessmentResponsesMutation, UpdateTesterQualityAssessmentResponsesMutationVariables>;
export const GetTesterRegistrationAccountSettingsDocument = gql`
    query getTesterRegistrationAccountSettings {
  tester {
    id
    aboutMe
    address
    birthday
    city
    countryId
    firstName
    gender
    lastName
    linkedinProfileLink
    payoutMethodId
    payoutMethodIdentifier
    phoneNumber
    postcode
    profileCompletenessStage
    region
    yearsOfTestingExperience
  }
}
    `;

/**
 * __useGetTesterRegistrationAccountSettingsQuery__
 *
 * To run a query within a React component, call `useGetTesterRegistrationAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterRegistrationAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterRegistrationAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterRegistrationAccountSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterRegistrationAccountSettingsQuery, GetTesterRegistrationAccountSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterRegistrationAccountSettingsQuery, GetTesterRegistrationAccountSettingsQueryVariables>(GetTesterRegistrationAccountSettingsDocument, options);
      }
export function useGetTesterRegistrationAccountSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterRegistrationAccountSettingsQuery, GetTesterRegistrationAccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterRegistrationAccountSettingsQuery, GetTesterRegistrationAccountSettingsQueryVariables>(GetTesterRegistrationAccountSettingsDocument, options);
        }
export function useGetTesterRegistrationAccountSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterRegistrationAccountSettingsQuery, GetTesterRegistrationAccountSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterRegistrationAccountSettingsQuery, GetTesterRegistrationAccountSettingsQueryVariables>(GetTesterRegistrationAccountSettingsDocument, options);
        }
export type GetTesterRegistrationAccountSettingsQueryHookResult = ReturnType<typeof useGetTesterRegistrationAccountSettingsQuery>;
export type GetTesterRegistrationAccountSettingsLazyQueryHookResult = ReturnType<typeof useGetTesterRegistrationAccountSettingsLazyQuery>;
export type GetTesterRegistrationAccountSettingsSuspenseQueryHookResult = ReturnType<typeof useGetTesterRegistrationAccountSettingsSuspenseQuery>;
export type GetTesterRegistrationAccountSettingsQueryResult = Apollo.QueryResult<GetTesterRegistrationAccountSettingsQuery, GetTesterRegistrationAccountSettingsQueryVariables>;
export const UpdateProfileCompletenessStageDocument = gql`
    mutation updateProfileCompletenessStage($input: UpdateProfileCompletenessStageInput!) {
  updateProfileCompletenessStage(input: $input) {
    result {
      id
      profileCompletenessStage
      skipAssessmentTest
    }
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type UpdateProfileCompletenessStageMutationFn = Apollo.MutationFunction<UpdateProfileCompletenessStageMutation, UpdateProfileCompletenessStageMutationVariables>;

/**
 * __useUpdateProfileCompletenessStageMutation__
 *
 * To run a mutation, you first call `useUpdateProfileCompletenessStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileCompletenessStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileCompletenessStageMutation, { data, loading, error }] = useUpdateProfileCompletenessStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileCompletenessStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileCompletenessStageMutation, UpdateProfileCompletenessStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileCompletenessStageMutation, UpdateProfileCompletenessStageMutationVariables>(UpdateProfileCompletenessStageDocument, options);
      }
export type UpdateProfileCompletenessStageMutationHookResult = ReturnType<typeof useUpdateProfileCompletenessStageMutation>;
export type UpdateProfileCompletenessStageMutationResult = Apollo.MutationResult<UpdateProfileCompletenessStageMutation>;
export type UpdateProfileCompletenessStageMutationOptions = Apollo.BaseMutationOptions<UpdateProfileCompletenessStageMutation, UpdateProfileCompletenessStageMutationVariables>;
export const GetReproducibilityTestsDocument = gql`
    query getReproducibilityTests {
  reproducibilityTests {
    edges {
      node {
        id
        name
        payoutBaseAmount
        isClosed
        isParticipating
        createdAt
        requestedEnvironments
      }
    }
  }
}
    `;

/**
 * __useGetReproducibilityTestsQuery__
 *
 * To run a query within a React component, call `useGetReproducibilityTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReproducibilityTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReproducibilityTestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReproducibilityTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetReproducibilityTestsQuery, GetReproducibilityTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReproducibilityTestsQuery, GetReproducibilityTestsQueryVariables>(GetReproducibilityTestsDocument, options);
      }
export function useGetReproducibilityTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReproducibilityTestsQuery, GetReproducibilityTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReproducibilityTestsQuery, GetReproducibilityTestsQueryVariables>(GetReproducibilityTestsDocument, options);
        }
export function useGetReproducibilityTestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReproducibilityTestsQuery, GetReproducibilityTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReproducibilityTestsQuery, GetReproducibilityTestsQueryVariables>(GetReproducibilityTestsDocument, options);
        }
export type GetReproducibilityTestsQueryHookResult = ReturnType<typeof useGetReproducibilityTestsQuery>;
export type GetReproducibilityTestsLazyQueryHookResult = ReturnType<typeof useGetReproducibilityTestsLazyQuery>;
export type GetReproducibilityTestsSuspenseQueryHookResult = ReturnType<typeof useGetReproducibilityTestsSuspenseQuery>;
export type GetReproducibilityTestsQueryResult = Apollo.QueryResult<GetReproducibilityTestsQuery, GetReproducibilityTestsQueryVariables>;
export const GetTesterPayoutBalanceDocument = gql`
    query getTesterPayoutBalance {
  testerPayoutBalance {
    balance
    threshold
    thresholdReached
  }
}
    `;

/**
 * __useGetTesterPayoutBalanceQuery__
 *
 * To run a query within a React component, call `useGetTesterPayoutBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTesterPayoutBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTesterPayoutBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTesterPayoutBalanceQuery(baseOptions?: Apollo.QueryHookOptions<GetTesterPayoutBalanceQuery, GetTesterPayoutBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTesterPayoutBalanceQuery, GetTesterPayoutBalanceQueryVariables>(GetTesterPayoutBalanceDocument, options);
      }
export function useGetTesterPayoutBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTesterPayoutBalanceQuery, GetTesterPayoutBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTesterPayoutBalanceQuery, GetTesterPayoutBalanceQueryVariables>(GetTesterPayoutBalanceDocument, options);
        }
export function useGetTesterPayoutBalanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTesterPayoutBalanceQuery, GetTesterPayoutBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTesterPayoutBalanceQuery, GetTesterPayoutBalanceQueryVariables>(GetTesterPayoutBalanceDocument, options);
        }
export type GetTesterPayoutBalanceQueryHookResult = ReturnType<typeof useGetTesterPayoutBalanceQuery>;
export type GetTesterPayoutBalanceLazyQueryHookResult = ReturnType<typeof useGetTesterPayoutBalanceLazyQuery>;
export type GetTesterPayoutBalanceSuspenseQueryHookResult = ReturnType<typeof useGetTesterPayoutBalanceSuspenseQuery>;
export type GetTesterPayoutBalanceQueryResult = Apollo.QueryResult<GetTesterPayoutBalanceQuery, GetTesterPayoutBalanceQueryVariables>;
export const GetCountriesDocument = gql`
    query getCountries {
  countries {
    value
    label
    code
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const CreateTesterDeviceFingerprintDocument = gql`
    mutation createTesterDeviceFingerprint($input: CreateTesterDeviceFingerprintInput!) {
  createTesterDeviceFingerprint(input: $input) {
    result
    errors {
      message
      code
    }
    successful
  }
}
    `;
export type CreateTesterDeviceFingerprintMutationFn = Apollo.MutationFunction<CreateTesterDeviceFingerprintMutation, CreateTesterDeviceFingerprintMutationVariables>;

/**
 * __useCreateTesterDeviceFingerprintMutation__
 *
 * To run a mutation, you first call `useCreateTesterDeviceFingerprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTesterDeviceFingerprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTesterDeviceFingerprintMutation, { data, loading, error }] = useCreateTesterDeviceFingerprintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTesterDeviceFingerprintMutation(baseOptions?: Apollo.MutationHookOptions<CreateTesterDeviceFingerprintMutation, CreateTesterDeviceFingerprintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTesterDeviceFingerprintMutation, CreateTesterDeviceFingerprintMutationVariables>(CreateTesterDeviceFingerprintDocument, options);
      }
export type CreateTesterDeviceFingerprintMutationHookResult = ReturnType<typeof useCreateTesterDeviceFingerprintMutation>;
export type CreateTesterDeviceFingerprintMutationResult = Apollo.MutationResult<CreateTesterDeviceFingerprintMutation>;
export type CreateTesterDeviceFingerprintMutationOptions = Apollo.BaseMutationOptions<CreateTesterDeviceFingerprintMutation, CreateTesterDeviceFingerprintMutationVariables>;
export const GetOperatingSystemVersionsDocument = gql`
    query getOperatingSystemVersions($deviceTypeCode: DeviceTypeCodesEnum!) {
  operatingSystemVersions(deviceTypeCode: $deviceTypeCode) {
    id
    name
  }
}
    `;

/**
 * __useGetOperatingSystemVersionsQuery__
 *
 * To run a query within a React component, call `useGetOperatingSystemVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatingSystemVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatingSystemVersionsQuery({
 *   variables: {
 *      deviceTypeCode: // value for 'deviceTypeCode'
 *   },
 * });
 */
export function useGetOperatingSystemVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetOperatingSystemVersionsQuery, GetOperatingSystemVersionsQueryVariables> & ({ variables: GetOperatingSystemVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperatingSystemVersionsQuery, GetOperatingSystemVersionsQueryVariables>(GetOperatingSystemVersionsDocument, options);
      }
export function useGetOperatingSystemVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperatingSystemVersionsQuery, GetOperatingSystemVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperatingSystemVersionsQuery, GetOperatingSystemVersionsQueryVariables>(GetOperatingSystemVersionsDocument, options);
        }
export function useGetOperatingSystemVersionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOperatingSystemVersionsQuery, GetOperatingSystemVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOperatingSystemVersionsQuery, GetOperatingSystemVersionsQueryVariables>(GetOperatingSystemVersionsDocument, options);
        }
export type GetOperatingSystemVersionsQueryHookResult = ReturnType<typeof useGetOperatingSystemVersionsQuery>;
export type GetOperatingSystemVersionsLazyQueryHookResult = ReturnType<typeof useGetOperatingSystemVersionsLazyQuery>;
export type GetOperatingSystemVersionsSuspenseQueryHookResult = ReturnType<typeof useGetOperatingSystemVersionsSuspenseQuery>;
export type GetOperatingSystemVersionsQueryResult = Apollo.QueryResult<GetOperatingSystemVersionsQuery, GetOperatingSystemVersionsQueryVariables>;
export const GetPayoutMethodsDocument = gql`
    query getPayoutMethods {
  payoutMethods {
    id
    name
    code
  }
}
    `;

/**
 * __useGetPayoutMethodsQuery__
 *
 * To run a query within a React component, call `useGetPayoutMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>(GetPayoutMethodsDocument, options);
      }
export function useGetPayoutMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>(GetPayoutMethodsDocument, options);
        }
export function useGetPayoutMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>(GetPayoutMethodsDocument, options);
        }
export type GetPayoutMethodsQueryHookResult = ReturnType<typeof useGetPayoutMethodsQuery>;
export type GetPayoutMethodsLazyQueryHookResult = ReturnType<typeof useGetPayoutMethodsLazyQuery>;
export type GetPayoutMethodsSuspenseQueryHookResult = ReturnType<typeof useGetPayoutMethodsSuspenseQuery>;
export type GetPayoutMethodsQueryResult = Apollo.QueryResult<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>;
export const GetUsRegionsDocument = gql`
    query getUsRegions {
  usRegions
}
    `;

/**
 * __useGetUsRegionsQuery__
 *
 * To run a query within a React component, call `useGetUsRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsRegionsQuery, GetUsRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsRegionsQuery, GetUsRegionsQueryVariables>(GetUsRegionsDocument, options);
      }
export function useGetUsRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsRegionsQuery, GetUsRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsRegionsQuery, GetUsRegionsQueryVariables>(GetUsRegionsDocument, options);
        }
export function useGetUsRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsRegionsQuery, GetUsRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsRegionsQuery, GetUsRegionsQueryVariables>(GetUsRegionsDocument, options);
        }
export type GetUsRegionsQueryHookResult = ReturnType<typeof useGetUsRegionsQuery>;
export type GetUsRegionsLazyQueryHookResult = ReturnType<typeof useGetUsRegionsLazyQuery>;
export type GetUsRegionsSuspenseQueryHookResult = ReturnType<typeof useGetUsRegionsSuspenseQuery>;
export type GetUsRegionsQueryResult = Apollo.QueryResult<GetUsRegionsQuery, GetUsRegionsQueryVariables>;
export const SendEmailConfirmationInstructionsDocument = gql`
    mutation sendEmailConfirmationInstructions($input: SendEmailConfirmationInstructionsInput!) {
  sendEmailConfirmationInstructions(input: $input) {
    result
    errors {
      message
      code
      path
    }
    successful
  }
}
    `;
export type SendEmailConfirmationInstructionsMutationFn = Apollo.MutationFunction<SendEmailConfirmationInstructionsMutation, SendEmailConfirmationInstructionsMutationVariables>;

/**
 * __useSendEmailConfirmationInstructionsMutation__
 *
 * To run a mutation, you first call `useSendEmailConfirmationInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailConfirmationInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailConfirmationInstructionsMutation, { data, loading, error }] = useSendEmailConfirmationInstructionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailConfirmationInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailConfirmationInstructionsMutation, SendEmailConfirmationInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailConfirmationInstructionsMutation, SendEmailConfirmationInstructionsMutationVariables>(SendEmailConfirmationInstructionsDocument, options);
      }
export type SendEmailConfirmationInstructionsMutationHookResult = ReturnType<typeof useSendEmailConfirmationInstructionsMutation>;
export type SendEmailConfirmationInstructionsMutationResult = Apollo.MutationResult<SendEmailConfirmationInstructionsMutation>;
export type SendEmailConfirmationInstructionsMutationOptions = Apollo.BaseMutationOptions<SendEmailConfirmationInstructionsMutation, SendEmailConfirmationInstructionsMutationVariables>;
export const GetTimeZonesDocument = gql`
    query getTimeZones {
  timeZones {
    value
    label
  }
}
    `;

/**
 * __useGetTimeZonesQuery__
 *
 * To run a query within a React component, call `useGetTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimeZonesQuery(baseOptions?: Apollo.QueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
      }
export function useGetTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
        }
export function useGetTimeZonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
        }
export type GetTimeZonesQueryHookResult = ReturnType<typeof useGetTimeZonesQuery>;
export type GetTimeZonesLazyQueryHookResult = ReturnType<typeof useGetTimeZonesLazyQuery>;
export type GetTimeZonesSuspenseQueryHookResult = ReturnType<typeof useGetTimeZonesSuspenseQuery>;
export type GetTimeZonesQueryResult = Apollo.QueryResult<GetTimeZonesQuery, GetTimeZonesQueryVariables>;
export const GetTestsDocument = gql`
    query getTests {
  tests {
    edges {
      node {
        isParticipating
        status
        statusLabel
        applicationName
        testType
        externalUrl
        code
        testId
        payoutBoostLabel
        deviceName
        platformCode
        shortDescription
        promotedGroup
        isClosed
      }
    }
    totalCount
  }
  joinedTests {
    totalCount
  }
}
    `;

/**
 * __useGetTestsQuery__
 *
 * To run a query within a React component, call `useGetTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTestsQuery(baseOptions?: Apollo.QueryHookOptions<GetTestsQuery, GetTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestsQuery, GetTestsQueryVariables>(GetTestsDocument, options);
      }
export function useGetTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestsQuery, GetTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestsQuery, GetTestsQueryVariables>(GetTestsDocument, options);
        }
export function useGetTestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestsQuery, GetTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestsQuery, GetTestsQueryVariables>(GetTestsDocument, options);
        }
export type GetTestsQueryHookResult = ReturnType<typeof useGetTestsQuery>;
export type GetTestsLazyQueryHookResult = ReturnType<typeof useGetTestsLazyQuery>;
export type GetTestsSuspenseQueryHookResult = ReturnType<typeof useGetTestsSuspenseQuery>;
export type GetTestsQueryResult = Apollo.QueryResult<GetTestsQuery, GetTestsQueryVariables>;
export const GetWorkHistoryDocument = gql`
    query getWorkHistory($status: WorkHistoryStatuses!, $after: String, $pageSize: Int!) {
  workHistoryItems(filters: {status: $status}, after: $after, first: $pageSize) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        payout {
          baseAmount
          payoutBoostMultiplier
          rankingTierMultiplier
          totalAmount
          severity
        }
        code
        status
        summary
        testName {
          title
          subtitle
        }
        testType
        url
      }
    }
  }
}
    `;

/**
 * __useGetWorkHistoryQuery__
 *
 * To run a query within a React component, call `useGetWorkHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkHistoryQuery({
 *   variables: {
 *      status: // value for 'status'
 *      after: // value for 'after'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetWorkHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetWorkHistoryQuery, GetWorkHistoryQueryVariables> & ({ variables: GetWorkHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkHistoryQuery, GetWorkHistoryQueryVariables>(GetWorkHistoryDocument, options);
      }
export function useGetWorkHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkHistoryQuery, GetWorkHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkHistoryQuery, GetWorkHistoryQueryVariables>(GetWorkHistoryDocument, options);
        }
export function useGetWorkHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkHistoryQuery, GetWorkHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkHistoryQuery, GetWorkHistoryQueryVariables>(GetWorkHistoryDocument, options);
        }
export type GetWorkHistoryQueryHookResult = ReturnType<typeof useGetWorkHistoryQuery>;
export type GetWorkHistoryLazyQueryHookResult = ReturnType<typeof useGetWorkHistoryLazyQuery>;
export type GetWorkHistorySuspenseQueryHookResult = ReturnType<typeof useGetWorkHistorySuspenseQuery>;
export type GetWorkHistoryQueryResult = Apollo.QueryResult<GetWorkHistoryQuery, GetWorkHistoryQueryVariables>;
export const GetMobileDevicesDocument = gql`
    query getMobileDevices($query: String, $platformCode: String) {
  mobileDevices(query: $query, platformCode: $platformCode) {
    id
    name
    platformCode
  }
}
    `;

/**
 * __useGetMobileDevicesQuery__
 *
 * To run a query within a React component, call `useGetMobileDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileDevicesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      platformCode: // value for 'platformCode'
 *   },
 * });
 */
export function useGetMobileDevicesQuery(baseOptions?: Apollo.QueryHookOptions<GetMobileDevicesQuery, GetMobileDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileDevicesQuery, GetMobileDevicesQueryVariables>(GetMobileDevicesDocument, options);
      }
export function useGetMobileDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileDevicesQuery, GetMobileDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileDevicesQuery, GetMobileDevicesQueryVariables>(GetMobileDevicesDocument, options);
        }
export function useGetMobileDevicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileDevicesQuery, GetMobileDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileDevicesQuery, GetMobileDevicesQueryVariables>(GetMobileDevicesDocument, options);
        }
export type GetMobileDevicesQueryHookResult = ReturnType<typeof useGetMobileDevicesQuery>;
export type GetMobileDevicesLazyQueryHookResult = ReturnType<typeof useGetMobileDevicesLazyQuery>;
export type GetMobileDevicesSuspenseQueryHookResult = ReturnType<typeof useGetMobileDevicesSuspenseQuery>;
export type GetMobileDevicesQueryResult = Apollo.QueryResult<GetMobileDevicesQuery, GetMobileDevicesQueryVariables>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Hash: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Json: { input: any; output: any; }
  TesterFieldValue: { input: any; output: any; }
};

export type AccountSettingsInput = {
  aboutMe: InputMaybe<Scalars['String']['input']>;
  address: InputMaybe<Scalars['String']['input']>;
  birthday: InputMaybe<Scalars['String']['input']>;
  city: InputMaybe<Scalars['String']['input']>;
  countryId: InputMaybe<Scalars['ID']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  gender: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  linkedinProfileLink: InputMaybe<Scalars['String']['input']>;
  payoutMethodId: InputMaybe<Scalars['ID']['input']>;
  payoutMethodIdentifier: InputMaybe<Scalars['String']['input']>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  postcode: InputMaybe<Scalars['String']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  testerPreferencesAttributes: InputMaybe<PreferencesInput>;
  yearsOfTestingExperience: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of AddCaseResult */
export type AddCaseResultInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  resultFieldId: Scalars['ID']['input'];
  value: Scalars['JSON']['input'];
};

/** Autogenerated return type of AddCaseResult. */
export type AddCaseResultPayload = MutationResult & {
  __typename?: 'AddCaseResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<CaseResultField>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddTesterSessionFeedback */
export type AddTesterSessionFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  feedback: Scalars['String']['input'];
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddTesterSessionFeedback. */
export type AddTesterSessionFeedbackPayload = MutationResult & {
  __typename?: 'AddTesterSessionFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Test>;
  successful: Scalars['Boolean']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  type: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};


export type AttachmentNodeArgs = {
  id: Scalars['ID']['input'];
};


export type AttachmentNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type AvailabilityConfig = {
  __typename?: 'AvailabilityConfig';
  daysOfWeek: Array<DayOfWeek>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  timesOfDay: Array<TimeOfDay>;
  weekTimeSlots: Array<WeekTimeSlot>;
};


export type AvailabilityConfigNodeArgs = {
  id: Scalars['ID']['input'];
};


export type AvailabilityConfigNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type AvailablePreference = {
  __typename?: 'AvailablePreference';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type AvailablePreferenceNodeArgs = {
  id: Scalars['ID']['input'];
};


export type AvailablePreferenceNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type BaseReward = {
  __typename?: 'BaseReward';
  criticalSeverityIssuePayoutAmount: Scalars['Float']['output'];
  highSeverityIssuePayoutAmount: Scalars['Float']['output'];
  lowSeverityIssuePayoutAmount: Scalars['Float']['output'];
  mediumSeverityIssuePayoutAmount: Scalars['Float']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  payoutBaseAmount: Scalars['Float']['output'];
};


export type BaseRewardNodeArgs = {
  id: Scalars['ID']['input'];
};


export type BaseRewardNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type Case = HasId & Node & {
  __typename?: 'Case';
  _id: Scalars['ID']['output'];
  approved: Scalars['Boolean']['output'];
  attachments: Maybe<Array<Attachment>>;
  canEditResult: Scalars['Boolean']['output'];
  canSubmitResult: Scalars['Boolean']['output'];
  caseFields: CaseFieldConnection;
  caseResultFields: CaseResultFieldConnection;
  code: Maybe<Scalars['String']['output']>;
  completed: Maybe<Scalars['Boolean']['output']>;
  feedback: Array<CaseFeedback>;
  id: Scalars['ID']['output'];
  myResponseStatus: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  openEditRequest: Maybe<Scalars['String']['output']>;
  prerequisites: Maybe<Scalars['String']['output']>;
  testCaseRunVideos: Maybe<Array<Attachment>>;
  underReview: Scalars['Boolean']['output'];
};


export type CaseCaseFieldsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type CaseCaseResultFieldsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type CaseNodeArgs = {
  id: Scalars['ID']['input'];
};


export type CaseNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for Case. */
export type CaseConnection = {
  __typename?: 'CaseConnection';
  /** A list of edges. */
  edges: Array<CaseEdge>;
  /** A list of nodes. */
  nodes: Array<Case>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CaseEdge = {
  __typename?: 'CaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Case;
};

export enum CaseFeedback {
  InstructionsAreConfusing = 'instructions_are_confusing',
  InstructionsDoNotMatchTheApp = 'instructions_do_not_match_the_app',
  TakesTooLong = 'takes_too_long'
}

export enum CaseFeedbackInput {
  InstructionsAreConfusing = 'instructions_are_confusing',
  InstructionsDoNotMatchTheApp = 'instructions_do_not_match_the_app',
  TakesTooLong = 'takes_too_long'
}

export type CaseField = HasId & Node & {
  __typename?: 'CaseField';
  _id: Scalars['ID']['output'];
  caseResultFields: CaseResultFieldConnection;
  displayType: Scalars['String']['output'];
  groupType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  ordinalNumber: Scalars['Int']['output'];
  value: Maybe<CaseFieldValue>;
};


export type CaseFieldCaseResultFieldsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type CaseFieldNodeArgs = {
  id: Scalars['ID']['input'];
};


export type CaseFieldNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for CaseField. */
export type CaseFieldConnection = {
  __typename?: 'CaseFieldConnection';
  /** A list of edges. */
  edges: Array<CaseFieldEdge>;
  /** A list of nodes. */
  nodes: Array<CaseField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CaseFieldEdge = {
  __typename?: 'CaseFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CaseField;
};

export type CaseFieldStep = {
  __typename?: 'CaseFieldStep';
  expectedResult: Scalars['String']['output'];
  instruction: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type CaseFieldStepNodeArgs = {
  id: Scalars['ID']['input'];
};


export type CaseFieldStepNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type CaseFieldValue = CaseFieldStep | StringValue;

export type CaseResult = HasId & Node & {
  __typename?: 'CaseResult';
  _id: Scalars['ID']['output'];
  completed: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type CaseResultNodeArgs = {
  id: Scalars['ID']['input'];
};


export type CaseResultNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type CaseResultField = HasId & Node & {
  __typename?: 'CaseResultField';
  _id: Scalars['ID']['output'];
  connectedCase: Maybe<Case>;
  id: Scalars['ID']['output'];
  inputType: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
  myResponseValue: Maybe<Scalars['JSON']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  required: Scalars['Boolean']['output'];
};


export type CaseResultFieldNodeArgs = {
  id: Scalars['ID']['input'];
};


export type CaseResultFieldNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for CaseResultField. */
export type CaseResultFieldConnection = {
  __typename?: 'CaseResultFieldConnection';
  /** A list of edges. */
  edges: Array<CaseResultFieldEdge>;
  /** A list of nodes. */
  nodes: Array<CaseResultField>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CaseResultFieldEdge = {
  __typename?: 'CaseResultFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CaseResultField;
};

export type CaseResultInput = {
  resultFieldId: Scalars['ID']['input'];
  value: Scalars['JSON']['input'];
};

export type ChatChannel = {
  __typename?: 'ChatChannel';
  chatType: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type ChatChannelNodeArgs = {
  id: Scalars['ID']['input'];
};


export type ChatChannelNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum ChatType {
  TestBlockerPrivateTmsTester = 'test_blocker_private_tms_tester',
  TestPrivateCtmsTester = 'test_private_ctms_tester',
  TestPrivateTmsTester = 'test_private_tms_tester',
  TestPublicTmsCtms = 'test_public_tms_ctms',
  TestPublicTmsTesters = 'test_public_tms_testers'
}

/** Autogenerated input type of CompareEnvironments */
export type CompareEnvironmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  gpsCoordinates: InputMaybe<GpsCoordinatesInput>;
  operatingSystem: OperatingSystemInput;
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of CompareEnvironments. */
export type CompareEnvironmentsPayload = MutationResult & {
  __typename?: 'CompareEnvironmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Test>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConfirmTesterConsents */
export type ConfirmTesterConsentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  consents: Array<TesterConsentInput>;
};

/** Autogenerated return type of ConfirmTesterConsents. */
export type ConfirmTesterConsentsPayload = MutationResult & {
  __typename?: 'ConfirmTesterConsentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Scalars['Boolean']['output']>;
  successful: Scalars['Boolean']['output'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  value: Scalars['ID']['output'];
};


export type CountryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type CountryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of CreateAttachment */
export type CreateAttachmentInput = {
  attachmentUrl: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAttachment. */
export type CreateAttachmentPayload = MutationResult & {
  __typename?: 'CreateAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Attachment>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCaseResultEditRequest */
export type CreateCaseResultEditRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  testCaseId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCaseResultEditRequest. */
export type CreateCaseResultEditRequestPayload = MutationResult & {
  __typename?: 'CreateCaseResultEditRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Case>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateIssue */
export type CreateIssueInput = {
  attachmentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  issueFields: Array<IssueFieldInput>;
  testCaseId: InputMaybe<Scalars['ID']['input']>;
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateIssue. */
export type CreateIssuePayload = MutationResult & {
  __typename?: 'CreateIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Issue>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTestBlocker */
export type CreateTestBlockerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTestBlocker. */
export type CreateTestBlockerPayload = MutationResult & {
  __typename?: 'CreateTestBlockerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Test>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTesterDeviceFingerprint */
export type CreateTesterDeviceFingerprintInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  deviceFingerprint: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTesterDeviceFingerprint. */
export type CreateTesterDeviceFingerprintPayload = MutationResult & {
  __typename?: 'CreateTesterDeviceFingerprintPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Scalars['Boolean']['output']>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTesterSurveyResponse */
export type CreateTesterSurveyResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  content: Scalars['JSON']['input'];
  testerSurveyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTesterSurveyResponse. */
export type CreateTesterSurveyResponsePayload = MutationResult & {
  __typename?: 'CreateTesterSurveyResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Scalars['Boolean']['output']>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateVPNGatewayPeer */
export type CreateVpnGatewayPeerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testerMobileDeviceOwnershipId: InputMaybe<Scalars['ID']['input']>;
  testerOperatingSystemOwnershipId: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateVPNGatewayPeer. */
export type CreateVpnGatewayPeerPayload = MutationResult & {
  __typename?: 'CreateVPNGatewayPeerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<VpnGatewayPeer>;
  successful: Scalars['Boolean']['output'];
};

export type DayOfWeek = {
  __typename?: 'DayOfWeek';
  isoDayOfWeek: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type DayOfWeekNodeArgs = {
  id: Scalars['ID']['input'];
};


export type DayOfWeekNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type DesiredOutcome = {
  __typename?: 'DesiredOutcome';
  isSelectedForTest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  testerInstructions: Maybe<Scalars['String']['output']>;
};


export type DesiredOutcomeNodeArgs = {
  id: Scalars['ID']['input'];
};


export type DesiredOutcomeNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of DestroyVPNGatewayPeer */
export type DestroyVpnGatewayPeerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testerMobileDeviceOwnershipId: InputMaybe<Scalars['ID']['input']>;
  testerOperatingSystemOwnershipId: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of DestroyVPNGatewayPeer. */
export type DestroyVpnGatewayPeerPayload = MutationResult & {
  __typename?: 'DestroyVPNGatewayPeerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Scalars['Boolean']['output']>;
  successful: Scalars['Boolean']['output'];
};

export enum DeviceTypeCodesEnum {
  /** desktop */
  Desktop = 'desktop',
  /** mobile */
  Mobile = 'mobile'
}

export enum Environment {
  /** desktop */
  Desktop = 'desktop',
  /** mobile */
  Mobile = 'mobile'
}

export type ExecutionEnvironment = {
  __typename?: 'ExecutionEnvironment';
  browserOrDevice: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystemAndVersion: Maybe<Scalars['String']['output']>;
  type: Maybe<Environment>;
};


export type ExecutionEnvironmentNodeArgs = {
  id: Scalars['ID']['input'];
};


export type ExecutionEnvironmentNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type GlobalRelevantEnvironments = HasId & Node & {
  __typename?: 'GlobalRelevantEnvironments';
  _id: Scalars['ID']['output'];
  deviceType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystem: Maybe<OperatingSystem>;
  operatingSystemVersion: Maybe<Scalars['String']['output']>;
};


export type GlobalRelevantEnvironmentsNodeArgs = {
  id: Scalars['ID']['input'];
};


export type GlobalRelevantEnvironmentsNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for GlobalRelevantEnvironments. */
export type GlobalRelevantEnvironmentsConnection = {
  __typename?: 'GlobalRelevantEnvironmentsConnection';
  /** A list of edges. */
  edges: Array<GlobalRelevantEnvironmentsEdge>;
  /** A list of nodes. */
  nodes: Array<GlobalRelevantEnvironments>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type GlobalRelevantEnvironmentsEdge = {
  __typename?: 'GlobalRelevantEnvironmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GlobalRelevantEnvironments;
};

export type GpsCoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type HasId = {
  _id: Scalars['ID']['output'];
};

export type Issue = HasId & Node & {
  __typename?: 'Issue';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  test: Test;
};


export type IssueNodeArgs = {
  id: Scalars['ID']['input'];
};


export type IssueNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type IssueFieldInput = {
  issueFieldDefinitionCode: Scalars['String']['input'];
  listOfValues: InputMaybe<Array<Scalars['String']['input']>>;
  singleValue: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of JoinFlexibleTest */
export type JoinFlexibleTestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of JoinFlexibleTest. */
export type JoinFlexibleTestPayload = MutationResult & {
  __typename?: 'JoinFlexibleTestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<TesterSession>;
  successful: Scalars['Boolean']['output'];
};

export type Language = {
  __typename?: 'Language';
  label: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  value: Maybe<Scalars['ID']['output']>;
};


export type LanguageNodeArgs = {
  id: Scalars['ID']['input'];
};


export type LanguageNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type LanguageProficiency = {
  __typename?: 'LanguageProficiency';
  id: Maybe<Scalars['ID']['output']>;
  languageId: Maybe<Scalars['ID']['output']>;
  level: Maybe<LanguageProficiencyLevelEnum>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type LanguageProficiencyNodeArgs = {
  id: Scalars['ID']['input'];
};


export type LanguageProficiencyNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type LanguageProficiencyInput = {
  id: InputMaybe<Scalars['ID']['input']>;
  languageId: InputMaybe<Scalars['ID']['input']>;
  level: InputMaybe<LanguageProficiencyLevelEnum>;
  markForDestruction: InputMaybe<Scalars['Boolean']['input']>;
};

export type LanguageProficiencyLevel = {
  __typename?: 'LanguageProficiencyLevel';
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  value: Scalars['String']['output'];
};


export type LanguageProficiencyLevelNodeArgs = {
  id: Scalars['ID']['input'];
};


export type LanguageProficiencyLevelNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum LanguageProficiencyLevelEnum {
  /** expert */
  Expert = 'expert',
  /** intermediate */
  Intermediate = 'intermediate',
  /** native */
  Native = 'native',
  /** novice */
  Novice = 'novice'
}

/** Autogenerated input type of LeaveFlexibleTest */
export type LeaveFlexibleTestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  closeReason: Scalars['String']['input'];
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of LeaveFlexibleTest. */
export type LeaveFlexibleTestPayload = MutationResult & {
  __typename?: 'LeaveFlexibleTestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<TesterSession>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkParticipantAsDeclined */
export type MarkParticipantAsDeclinedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkParticipantAsDeclined. */
export type MarkParticipantAsDeclinedPayload = MutationResult & {
  __typename?: 'MarkParticipantAsDeclinedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  successful: Scalars['Boolean']['output'];
};

export type MobileDevice = {
  __typename?: 'MobileDevice';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  platformCode: Scalars['String']['output'];
};


export type MobileDeviceNodeArgs = {
  id: Scalars['ID']['input'];
};


export type MobileDeviceNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MobileDeviceOwnershipInput = {
  id: InputMaybe<Scalars['ID']['input']>;
  markForDestruction: InputMaybe<Scalars['Boolean']['input']>;
  mobileDeviceId: InputMaybe<Scalars['ID']['input']>;
  operatingSystemVersionId: InputMaybe<Scalars['ID']['input']>;
};

/** A mutation error */
export type MutationError = {
  __typename?: 'MutationError';
  /** Defined code of the error */
  code: Scalars['String']['output'];
  /** User friendly error message that can be shown in the form / alert. */
  message: Scalars['String']['output'];
  /** Path points to an attribute that's causing an error */
  path: Maybe<Array<Scalars['String']['output']>>;
};

export type MutationResult = {
  errors: Array<MutationError>;
  successful: Scalars['Boolean']['output'];
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type OperatingSystem = HasId & Node & {
  __typename?: 'OperatingSystem';
  _id: Scalars['ID']['output'];
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type OperatingSystemNodeArgs = {
  id: Scalars['ID']['input'];
};


export type OperatingSystemNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type OperatingSystemInput = {
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type OperatingSystemOwnershipInput = {
  id: InputMaybe<Scalars['ID']['input']>;
  markForDestruction: InputMaybe<Scalars['Boolean']['input']>;
  operatingSystemId: InputMaybe<Scalars['ID']['input']>;
  operatingSystemVersionId: InputMaybe<Scalars['ID']['input']>;
};

export type OperatingSystemVersion = {
  __typename?: 'OperatingSystemVersion';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystemCode: Scalars['String']['output'];
  vpnGatewayPeer: Maybe<VpnGatewayPeer>;
};


export type OperatingSystemVersionNodeArgs = {
  id: Scalars['ID']['input'];
};


export type OperatingSystemVersionNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type OwnershipCheckUpInput = {
  id: Scalars['ID']['input'];
  markForDestruction: InputMaybe<Scalars['Boolean']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type Payout = HasId & Node & {
  __typename?: 'Payout';
  _id: Scalars['ID']['output'];
  amountChangeReason: Maybe<Scalars['String']['output']>;
  amountFormatted: Scalars['String']['output'];
  correction: Scalars['Boolean']['output'];
  details: Array<PayoutDetail>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  paidOn: Maybe<Scalars['ISO8601DateTime']['output']>;
  payoutItems: PayoutItemWithoutPaginationConnection;
  payoutSystemMemo: Maybe<Scalars['String']['output']>;
  shortPublicId: Scalars['String']['output'];
  status: PayoutStatuses;
  statusMessage: Maybe<Scalars['String']['output']>;
};


export type PayoutNodeArgs = {
  id: Scalars['ID']['input'];
};


export type PayoutNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for Payout. */
export type PayoutConnection = {
  __typename?: 'PayoutConnection';
  /** A list of edges. */
  edges: Array<PayoutEdge>;
  /** A list of nodes. */
  nodes: Array<Payout>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PayoutDetail = {
  __typename?: 'PayoutDetail';
  errorExplanation: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type PayoutDetailNodeArgs = {
  id: Scalars['ID']['input'];
};


export type PayoutDetailNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type PayoutDetails = {
  __typename?: 'PayoutDetails';
  baseAmount: Scalars['String']['output'];
  boostedAmount: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  rankAmount: Scalars['String']['output'];
  severity: Scalars['String']['output'];
};


export type PayoutDetailsNodeArgs = {
  id: Scalars['ID']['input'];
};


export type PayoutDetailsNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type PayoutEdge = {
  __typename?: 'PayoutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Payout;
};

export type PayoutItem = HasId & Node & {
  __typename?: 'PayoutItem';
  _id: Scalars['ID']['output'];
  amountFormatted: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  subject: Maybe<Scalars['Json']['output']>;
  summary: Maybe<Scalars['Json']['output']>;
};


export type PayoutItemNodeArgs = {
  id: Scalars['ID']['input'];
};


export type PayoutItemNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type PayoutItemEdge = {
  __typename?: 'PayoutItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PayoutItem;
};

/** The connection type for PayoutItem. */
export type PayoutItemWithoutPaginationConnection = {
  __typename?: 'PayoutItemWithoutPaginationConnection';
  /** A list of edges. */
  edges: Array<PayoutItemEdge>;
  /** A list of nodes. */
  nodes: Array<PayoutItem>;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type PayoutMethod = {
  __typename?: 'PayoutMethod';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type PayoutMethodNodeArgs = {
  id: Scalars['ID']['input'];
};


export type PayoutMethodNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum PayoutStatuses {
  Failed = 'failed',
  Processed = 'processed',
  Processing = 'processing',
  Unclaimed = 'unclaimed'
}

export type Preferences = {
  __typename?: 'Preferences';
  emailNotificationsEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type PreferencesNodeArgs = {
  id: Scalars['ID']['input'];
};


export type PreferencesNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type PreferencesInput = {
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export enum ProfileCompletenessStageEnum {
  /** account_settings */
  AccountSettings = 'account_settings',
  /** community_test */
  CommunityTest = 'community_test',
  /** failed_follow_up_test */
  FailedFollowUpTest = 'failed_follow_up_test',
  /** finished */
  Finished = 'finished',
  /** follow_up_test */
  FollowUpTest = 'follow_up_test',
  /** hardware_and_software */
  HardwareAndSoftware = 'hardware_and_software',
  /** registration_confirmation */
  RegistrationConfirmation = 'registration_confirmation',
  /** test_completed */
  TestCompleted = 'test_completed',
  /** testing_settings */
  TestingSettings = 'testing_settings'
}

export enum ProfileCompletenessStageUpdateEnum {
  CommunityTest = 'community_test',
  FollowUpTest = 'follow_up_test',
  HardwareAndSoftware = 'hardware_and_software'
}

export type RankingIssue = HasId & Node & {
  __typename?: 'RankingIssue';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  moderationFeedback: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  points: Scalars['String']['output'];
  resolution: Scalars['String']['output'];
};


export type RankingIssueNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RankingIssueNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for RankingIssue. */
export type RankingIssueConnection = {
  __typename?: 'RankingIssueConnection';
  /** A list of edges. */
  edges: Array<RankingIssueEdge>;
  /** A list of nodes. */
  nodes: Array<RankingIssue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type RankingIssueEdge = {
  __typename?: 'RankingIssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RankingIssue;
};

export type RankingIssueFilter = {
  is_rejected: Scalars['Boolean']['input'];
};

export type RankingTier = HasId & Node & {
  __typename?: 'RankingTier';
  _id: Scalars['ID']['output'];
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  minimumPercentile: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  payoutMultiplier: Maybe<Scalars['Float']['output']>;
  rankDetails: Maybe<Scalars['String']['output']>;
};


export type RankingTierNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RankingTierNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type RankingTierEdge = {
  __typename?: 'RankingTierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RankingTier;
};

/** The connection type for RankingTier. */
export type RankingTierWithoutPaginationConnection = {
  __typename?: 'RankingTierWithoutPaginationConnection';
  /** A list of edges. */
  edges: Array<RankingTierEdge>;
  /** A list of nodes. */
  nodes: Array<RankingTier>;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of RegisterChat */
export type RegisterChatInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
  type: ChatType;
};

/** Autogenerated return type of RegisterChat. */
export type RegisterChatPayload = MutationResult & {
  __typename?: 'RegisterChatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<ChatChannel>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveAttachment */
export type RemoveAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveAttachment. */
export type RemoveAttachmentPayload = MutationResult & {
  __typename?: 'RemoveAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  successful: Scalars['Boolean']['output'];
};

export type RequirementsGroup = HasId & Node & {
  __typename?: 'RequirementsGroup';
  _id: Scalars['ID']['output'];
  browsers: Array<Scalars['String']['output']>;
  deviceTypes: Array<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  languages: Array<Scalars['String']['output']>;
  manufacturers: Array<Scalars['String']['output']>;
  mobileDevices: Array<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystemAndVersions: Array<Scalars['String']['output']>;
  operatingSystems: Array<Scalars['String']['output']>;
  other: Maybe<Scalars['String']['output']>;
  platforms: Array<Scalars['String']['output']>;
};


export type RequirementsGroupNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RequirementsGroupNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of ResolveTestBlocker */
export type ResolveTestBlockerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testBlockerId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResolveTestBlocker. */
export type ResolveTestBlockerPayload = MutationResult & {
  __typename?: 'ResolveTestBlockerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<TestBlocker>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RetryPayout */
export type RetryPayoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  payoutId: Scalars['ID']['input'];
};

/** Autogenerated return type of RetryPayout. */
export type RetryPayoutPayload = MutationResult & {
  __typename?: 'RetryPayoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Payout>;
  successful: Scalars['Boolean']['output'];
};

export type RootMutation = {
  __typename?: 'RootMutation';
  addCaseResult: Maybe<AddCaseResultPayload>;
  addTesterSessionFeedback: Maybe<AddTesterSessionFeedbackPayload>;
  compareEnvironments: Maybe<CompareEnvironmentsPayload>;
  confirmTesterConsents: Maybe<ConfirmTesterConsentsPayload>;
  createAttachment: Maybe<CreateAttachmentPayload>;
  createCaseResultEditRequest: Maybe<CreateCaseResultEditRequestPayload>;
  createIssue: Maybe<CreateIssuePayload>;
  createTestBlocker: Maybe<CreateTestBlockerPayload>;
  createTesterDeviceFingerprint: Maybe<CreateTesterDeviceFingerprintPayload>;
  createTesterSurveyResponse: Maybe<CreateTesterSurveyResponsePayload>;
  createVpnGatewayPeer: Maybe<CreateVpnGatewayPeerPayload>;
  destroyVpnGatewayPeer: Maybe<DestroyVpnGatewayPeerPayload>;
  joinFlexibleTest: Maybe<JoinFlexibleTestPayload>;
  leaveFlexibleTest: Maybe<LeaveFlexibleTestPayload>;
  markParticipantAsDeclined: Maybe<MarkParticipantAsDeclinedPayload>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  registerChat: Maybe<RegisterChatPayload>;
  removeAttachment: Maybe<RemoveAttachmentPayload>;
  resolveTestBlocker: Maybe<ResolveTestBlockerPayload>;
  retryPayout: Maybe<RetryPayoutPayload>;
  sendEmailConfirmationInstructions: Maybe<SendEmailConfirmationInstructionsPayload>;
  submitCaseResult: Maybe<SubmitCaseResultPayload>;
  updateAccountSettings: Maybe<UpdateAccountSettingsPayload>;
  updateCaseFieldAttachmentResponses: Maybe<UpdateCaseFieldAttachmentResponsesPayload>;
  updateCaseResultAttachments: Maybe<UpdateCaseResultAttachmentsPayload>;
  updateCheckUpVerification: Maybe<UpdateCheckUpVerificationPayload>;
  updateExecutionEnvironment: Maybe<UpdateExecutionEnvironmentPayload>;
  updateMobileDeviceOwnership: Maybe<UpdateMobileDeviceOwnershipPayload>;
  updateOperatingSystemOwnership: Maybe<UpdateOperatingSystemOwnershipPayload>;
  updateProfileCompletenessStage: Maybe<UpdateProfileCompletenessStagePayload>;
  updateTestCaseRunVideo: Maybe<UpdateTestCaseRunVideoPayload>;
  updateTestCycleInvitation: Maybe<UpdateTestCycleInvitationPayload>;
  updateTesterAvailabilityCalendar: Maybe<UpdateTesterAvailabilityCalendarPayload>;
  updateTesterQualityAssessmentResponses: Maybe<UpdateTesterQualityAssessmentResponsesPayload>;
  updateTestingSettings: Maybe<UpdateTestingSettingsPayload>;
};


export type RootMutationAddCaseResultArgs = {
  input: AddCaseResultInput;
};


export type RootMutationAddTesterSessionFeedbackArgs = {
  input: AddTesterSessionFeedbackInput;
};


export type RootMutationCompareEnvironmentsArgs = {
  input: CompareEnvironmentsInput;
};


export type RootMutationConfirmTesterConsentsArgs = {
  input: ConfirmTesterConsentsInput;
};


export type RootMutationCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};


export type RootMutationCreateCaseResultEditRequestArgs = {
  input: CreateCaseResultEditRequestInput;
};


export type RootMutationCreateIssueArgs = {
  input: CreateIssueInput;
};


export type RootMutationCreateTestBlockerArgs = {
  input: CreateTestBlockerInput;
};


export type RootMutationCreateTesterDeviceFingerprintArgs = {
  input: CreateTesterDeviceFingerprintInput;
};


export type RootMutationCreateTesterSurveyResponseArgs = {
  input: CreateTesterSurveyResponseInput;
};


export type RootMutationCreateVpnGatewayPeerArgs = {
  input: CreateVpnGatewayPeerInput;
};


export type RootMutationDestroyVpnGatewayPeerArgs = {
  input: DestroyVpnGatewayPeerInput;
};


export type RootMutationJoinFlexibleTestArgs = {
  input: JoinFlexibleTestInput;
};


export type RootMutationLeaveFlexibleTestArgs = {
  input: LeaveFlexibleTestInput;
};


export type RootMutationMarkParticipantAsDeclinedArgs = {
  input: MarkParticipantAsDeclinedInput;
};


export type RootMutationNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type RootMutationRegisterChatArgs = {
  input: RegisterChatInput;
};


export type RootMutationRemoveAttachmentArgs = {
  input: RemoveAttachmentInput;
};


export type RootMutationResolveTestBlockerArgs = {
  input: ResolveTestBlockerInput;
};


export type RootMutationRetryPayoutArgs = {
  input: RetryPayoutInput;
};


export type RootMutationSendEmailConfirmationInstructionsArgs = {
  input: SendEmailConfirmationInstructionsInput;
};


export type RootMutationSubmitCaseResultArgs = {
  input: SubmitCaseResultInput;
};


export type RootMutationUpdateAccountSettingsArgs = {
  input: UpdateAccountSettingsInput;
};


export type RootMutationUpdateCaseFieldAttachmentResponsesArgs = {
  input: UpdateCaseFieldAttachmentResponsesInput;
};


export type RootMutationUpdateCaseResultAttachmentsArgs = {
  input: UpdateCaseResultAttachmentsInput;
};


export type RootMutationUpdateCheckUpVerificationArgs = {
  input: UpdateCheckUpVerificationInput;
};


export type RootMutationUpdateExecutionEnvironmentArgs = {
  input: UpdateExecutionEnvironmentInput;
};


export type RootMutationUpdateMobileDeviceOwnershipArgs = {
  input: UpdateMobileDeviceOwnershipInput;
};


export type RootMutationUpdateOperatingSystemOwnershipArgs = {
  input: UpdateOperatingSystemOwnershipInput;
};


export type RootMutationUpdateProfileCompletenessStageArgs = {
  input: UpdateProfileCompletenessStageInput;
};


export type RootMutationUpdateTestCaseRunVideoArgs = {
  input: UpdateTestCaseRunVideoInput;
};


export type RootMutationUpdateTestCycleInvitationArgs = {
  input: UpdateTestCycleInvitationInput;
};


export type RootMutationUpdateTesterAvailabilityCalendarArgs = {
  input: UpdateTesterAvailabilityCalendarInput;
};


export type RootMutationUpdateTesterQualityAssessmentResponsesArgs = {
  input: UpdateTesterQualityAssessmentResponsesInput;
};


export type RootMutationUpdateTestingSettingsArgs = {
  input: UpdateTestingSettingsInput;
};

export type RootQuery = {
  __typename?: 'RootQuery';
  additionalAttachments: Maybe<Array<Attachment>>;
  availabilityConfig: Maybe<AvailabilityConfig>;
  baseReward: Maybe<BaseReward>;
  countries: Maybe<Array<Country>>;
  featureFlags: Array<Scalars['String']['output']>;
  globalRelevantEnvironments: GlobalRelevantEnvironmentsConnection;
  joinedTests: TestConnection;
  languageProficiencies: Maybe<Array<LanguageProficiency>>;
  languageProficiencyLevels: Maybe<Array<LanguageProficiencyLevel>>;
  languages: Maybe<Array<Language>>;
  mobileDeviceOwnerships: Maybe<Array<TesterMobileDeviceOwnership>>;
  mobileDevices: Maybe<Array<MobileDevice>>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystemOwnerships: Maybe<Array<TesterOperatingSystemOwnership>>;
  operatingSystemVersions: Maybe<Array<OperatingSystemVersion>>;
  payoutMethods: Maybe<Array<PayoutMethod>>;
  payouts: PayoutConnection;
  rankingItems: RankingIssueConnection;
  rankingTiers: RankingTierWithoutPaginationConnection;
  reproducibilityTests: TestConnection;
  survey: Maybe<TesterSurvey>;
  test: Maybe<Test>;
  testCycle: Maybe<TestCycle>;
  testCycleInvitation: Maybe<TestCycleInvitation>;
  tester: Maybe<Tester>;
  testerFields: Maybe<Array<TesterField>>;
  testerPayoutBalance: Maybe<TesterPayoutBalance>;
  testerPerformance: Maybe<TesterPerformance>;
  testerQualityAssessmentResponses: Maybe<Array<TesterQualityAssessmentResponse>>;
  testerQualityAssessmentTest: Maybe<TesterQualityAssessmentTest>;
  tests: TestCycleInterfaceWithoutPaginationConnection;
  timeZones: Maybe<Array<TimeZone>>;
  usRegions: Maybe<Array<Scalars['String']['output']>>;
  viewer: Viewer;
  workHistoryItems: WorkHistoryIssueConnection;
};


export type RootQueryAdditionalAttachmentsArgs = {
  caseFieldId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryBaseRewardArgs = {
  testType: TestTypesEnum;
};


export type RootQueryGlobalRelevantEnvironmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryJoinedTestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<TestFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryMobileDevicesArgs = {
  platformCode: InputMaybe<Scalars['String']['input']>;
  query: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type RootQueryOperatingSystemVersionsArgs = {
  deviceTypeCode: DeviceTypeCodesEnum;
};


export type RootQueryPayoutsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryRankingItemsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filters: RankingIssueFilter;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryReproducibilityTestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<TestFilter>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type RootQuerySurveyArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTestArgs = {
  code: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTestCycleArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTestCycleInvitationArgs = {
  token: Scalars['String']['input'];
};


export type RootQueryTesterPerformanceArgs = {
  period: TesterPerformancePeriod;
};


export type RootQueryWorkHistoryItemsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filters: WorkHistoryIssueFilter;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type SelectFieldOption = {
  __typename?: 'SelectFieldOption';
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  value: Scalars['String']['output'];
};


export type SelectFieldOptionNodeArgs = {
  id: Scalars['ID']['input'];
};


export type SelectFieldOptionNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for SelectFieldOption. */
export type SelectFieldOptionConnection = {
  __typename?: 'SelectFieldOptionConnection';
  /** A list of edges. */
  edges: Array<SelectFieldOptionEdge>;
  /** A list of nodes. */
  nodes: Array<SelectFieldOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SelectFieldOptionEdge = {
  __typename?: 'SelectFieldOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SelectFieldOption;
};

export type SelectionsSettings = {
  __typename?: 'SelectionsSettings';
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  notStartedGracePeriod: Scalars['String']['output'];
};


export type SelectionsSettingsNodeArgs = {
  id: Scalars['ID']['input'];
};


export type SelectionsSettingsNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of SendEmailConfirmationInstructions */
export type SendEmailConfirmationInstructionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendEmailConfirmationInstructions. */
export type SendEmailConfirmationInstructionsPayload = MutationResult & {
  __typename?: 'SendEmailConfirmationInstructionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Scalars['Boolean']['output']>;
  successful: Scalars['Boolean']['output'];
};

export enum Status {
  Accepted = 'accepted',
  Declined = 'declined'
}

export type StringValue = {
  __typename?: 'StringValue';
  content: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type StringValueNodeArgs = {
  id: Scalars['ID']['input'];
};


export type StringValueNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of SubmitCaseResult */
export type SubmitCaseResultInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Array<CaseFeedbackInput>>;
  resultFields: Array<CaseResultInput>;
  testCaseId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitCaseResult. */
export type SubmitCaseResultPayload = MutationResult & {
  __typename?: 'SubmitCaseResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Case>;
  successful: Scalars['Boolean']['output'];
};

export type Test = HasId & Node & TestCycleInterface & {
  __typename?: 'Test';
  _id: Scalars['ID']['output'];
  accessToSecureEnvironmentInstructions: Maybe<Scalars['String']['output']>;
  activityType: Maybe<TestActivityTypeEnum>;
  additionalUrlsAndResources: Maybe<Scalars['String']['output']>;
  applicationName: Scalars['String']['output'];
  applicationUrl: Maybe<Scalars['String']['output']>;
  attachments: Maybe<Array<Attachment>>;
  blockers: Array<TestBlocker>;
  canReportBlockers: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
  cases: CaseConnection;
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  closesAutomatically: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  communityTestManagersEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  credentialsAndAccessInstructions: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  desiredOutcomes: Maybe<Array<DesiredOutcome>>;
  deviceName: Maybe<Scalars['String']['output']>;
  estimatedTestCasesPayment: Maybe<Scalars['Int']['output']>;
  executionEnvironment: Maybe<ExecutionEnvironment>;
  extendedOverview: Scalars['Boolean']['output'];
  externalIssueReporting: Scalars['Boolean']['output'];
  externalUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isClosed: Scalars['Boolean']['output'];
  isFeedbackProvided: Scalars['Boolean']['output'];
  isIssueReportingEnabled: Scalars['Boolean']['output'];
  isParticipating: Scalars['Boolean']['output'];
  isReadyForExecution: Scalars['Boolean']['output'];
  issueFieldDefinitions: Array<TestIssueFieldDefinition>;
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  payoutBaseAmount: Scalars['Int']['output'];
  payoutBoostLabel: Maybe<Scalars['String']['output']>;
  plannedEndAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  platformCode: Maybe<Scalars['String']['output']>;
  predefinedUserAccountsInstructions: Maybe<Scalars['String']['output']>;
  promotedGroup: Maybe<Scalars['String']['output']>;
  relatedTestCaseRequiredForIssue: Scalars['Boolean']['output'];
  remainingIssuesLimit: Maybe<Scalars['Int']['output']>;
  reproducibilitySource: Maybe<Scalars['String']['output']>;
  requestedEnvironments: Maybe<Array<Scalars['Hash']['output']>>;
  requireVideoAttachment: Scalars['Boolean']['output'];
  requiredAttachment: Array<Scalars['String']['output']>;
  requirementsGroup: Maybe<RequirementsGroup>;
  responseTemplate: Maybe<Scalars['String']['output']>;
  scope: Maybe<Scalars['String']['output']>;
  sdlcStage: Maybe<Scalars['String']['output']>;
  selectionsSettings: Maybe<SelectionsSettings>;
  shortDescription: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: TestCycleStatus;
  statusLabel: Scalars['String']['output'];
  supportsAutomaticTesterManagement: Scalars['Boolean']['output'];
  testCode: Maybe<Scalars['String']['output']>;
  testId: Scalars['String']['output'];
  testType: Scalars['String']['output'];
  testerCompletionTimeFinishesAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  testerSpec: Maybe<TesterSpec>;
  testerSpecificationLink: Maybe<Scalars['String']['output']>;
  trackerProjectUrl: Maybe<Scalars['String']['output']>;
  uniqueCode: Maybe<Scalars['String']['output']>;
  vendor: Maybe<Scalars['String']['output']>;
};


export type TestCasesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type TestNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TestNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum TestActivityTypeEnum {
  Exploratory = 'exploratory',
  Localization = 'localization',
  Reproducibility = 'reproducibility',
  TestCaseRun = 'test_case_run',
  Translation = 'translation'
}

export type TestBlocker = HasId & Node & {
  __typename?: 'TestBlocker';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  status: Scalars['String']['output'];
};


export type TestBlockerNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TestBlockerNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for Test. */
export type TestConnection = {
  __typename?: 'TestConnection';
  /** A list of edges. */
  edges: Array<TestEdge>;
  /** A list of nodes. */
  nodes: Array<Test>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type TestCycle = HasId & Node & TestCycleInterface & {
  __typename?: 'TestCycle';
  _id: Scalars['ID']['output'];
  applicationInfo: Maybe<Scalars['String']['output']>;
  applicationName: Scalars['String']['output'];
  calculatedEndAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  code: Scalars['String']['output'];
  customerName: Maybe<Scalars['String']['output']>;
  deviceName: Maybe<Scalars['String']['output']>;
  deviceRequirements: Scalars['Hash']['output'];
  externalUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  invitation: Maybe<TestCycleInvitation>;
  isClosed: Scalars['Boolean']['output'];
  isParticipating: Scalars['Boolean']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  paused: Scalars['Boolean']['output'];
  payoutBoostLabel: Maybe<Scalars['String']['output']>;
  payoutDetails: Maybe<Array<PayoutDetails>>;
  platformCode: Maybe<Scalars['String']['output']>;
  promotedGroup: Maybe<Scalars['String']['output']>;
  publicId: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  startAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: TestCycleStatus;
  statusLabel: Scalars['String']['output'];
  testCasesDocumentUrl: Maybe<Scalars['String']['output']>;
  testCycleCode: Maybe<Scalars['String']['output']>;
  testId: Scalars['String']['output'];
  testType: Scalars['String']['output'];
  testerSpecificationLink: Maybe<Scalars['String']['output']>;
  trackerProjectUrl: Maybe<Scalars['String']['output']>;
};


export type TestCycleNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TestCycleNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TestCycleInterface = {
  applicationName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  deviceName: Maybe<Scalars['String']['output']>;
  externalUrl: Maybe<Scalars['String']['output']>;
  isClosed: Scalars['Boolean']['output'];
  isParticipating: Scalars['Boolean']['output'];
  payoutBoostLabel: Maybe<Scalars['String']['output']>;
  platformCode: Maybe<Scalars['String']['output']>;
  promotedGroup: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  status: TestCycleStatus;
  statusLabel: Scalars['String']['output'];
  testId: Scalars['String']['output'];
  testType: Scalars['String']['output'];
};

/** An edge in a connection. */
export type TestCycleInterfaceEdge = {
  __typename?: 'TestCycleInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TestCycleInterface>;
};

/** The connection type for TestCycleInterface. */
export type TestCycleInterfaceWithoutPaginationConnection = {
  __typename?: 'TestCycleInterfaceWithoutPaginationConnection';
  /** A list of edges. */
  edges: Array<TestCycleInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<TestCycleInterface>;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type TestCycleInvitation = HasId & Node & {
  __typename?: 'TestCycleInvitation';
  _id: Scalars['ID']['output'];
  accepted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  onWaitingList: Scalars['Boolean']['output'];
  testerSpreadsheet: Maybe<TesterSpreadsheet>;
  token: Maybe<Scalars['String']['output']>;
};


export type TestCycleInvitationNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TestCycleInvitationNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum TestCycleStatus {
  /** Scheduled */
  Attending = 'attending',
  /** Closed */
  Closed = 'closed',
  /** In progress */
  InProgress = 'in_progress',
  /** Joined */
  Joined = 'joined',
  /** Open */
  Open = 'open',
  /** Paused */
  Paused = 'paused',
  /** Waiting list */
  Waiting = 'waiting'
}

/** An edge in a connection. */
export type TestEdge = {
  __typename?: 'TestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Test;
};

export type TestFilter = {
  is_open: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestIssueFieldDefinition = {
  __typename?: 'TestIssueFieldDefinition';
  code: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  options: SelectFieldOptionConnection;
  required: Scalars['Boolean']['output'];
};


export type TestIssueFieldDefinitionNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TestIssueFieldDefinitionNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type TestIssueFieldDefinitionOptionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export enum TestTypesEnum {
  /** generic */
  Generic = 'generic',
  /** reproducibility */
  Reproducibility = 'reproducibility',
  /** results_only */
  ResultsOnly = 'results_only',
  /** supervised */
  Supervised = 'supervised'
}

export type Tester = HasId & Node & {
  __typename?: 'Tester';
  _id: Scalars['ID']['output'];
  aboutMe: Maybe<Scalars['String']['output']>;
  address: Maybe<Scalars['String']['output']>;
  availabilityCalendar: Maybe<TesterAvailabilityCalendar>;
  availablePreferences: Array<AvailablePreference>;
  birthday: Maybe<Scalars['ISO8601Date']['output']>;
  checkUpVerification: Scalars['Boolean']['output'];
  city: Maybe<Scalars['String']['output']>;
  countryId: Maybe<Scalars['ID']['output']>;
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  hasVpnAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  linkedinProfileLink: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  outdatedConsents: Array<TesterConsent>;
  payoutMethodCode: Maybe<Scalars['String']['output']>;
  payoutMethodId: Maybe<Scalars['ID']['output']>;
  payoutMethodIdentifier: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  postcode: Maybe<Scalars['String']['output']>;
  preferences: Preferences;
  profileCompletenessStage: ProfileCompletenessStageEnum;
  publicId: Scalars['String']['output'];
  region: Maybe<Scalars['String']['output']>;
  segmentEnabled: Scalars['Boolean']['output'];
  skipAssessmentTest: Scalars['Boolean']['output'];
  streamChatToken: Scalars['String']['output'];
  testerRank: TesterRank;
  yearsOfTestingExperience: Maybe<Scalars['Int']['output']>;
};


export type TesterNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterAvailability = {
  __typename?: 'TesterAvailability';
  available: Scalars['Boolean']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  timeSlotCode: Scalars['String']['output'];
};


export type TesterAvailabilityNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterAvailabilityNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterAvailabilityCalendar = HasId & Node & {
  __typename?: 'TesterAvailabilityCalendar';
  _id: Scalars['ID']['output'];
  availabilities: Array<TesterAvailability>;
  id: Scalars['ID']['output'];
  nextPossibleUpdateDateTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  timeZoneName: Scalars['String']['output'];
};


export type TesterAvailabilityCalendarNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterAvailabilityCalendarNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterAvailabilityInput = {
  available: Scalars['Boolean']['input'];
  timeSlotCode: TimeSlotCodeEnum;
};

export type TesterConsent = {
  __typename?: 'TesterConsent';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  version: Scalars['String']['output'];
};


export type TesterConsentNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterConsentNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterConsentInput = {
  code: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type TesterField = {
  __typename?: 'TesterField';
  alphabeticalOrder: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  options: Maybe<Array<TesterFieldOption>>;
  type: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};


export type TesterFieldNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterFieldNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterFieldInput = {
  code: Scalars['String']['input'];
  value: Scalars['TesterFieldValue']['input'];
};

export type TesterFieldOption = {
  __typename?: 'TesterFieldOption';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  selected: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};


export type TesterFieldOptionNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterFieldOptionNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterGuideline = {
  __typename?: 'TesterGuideline';
  code: TesterGuidelineCodesEnum;
  description: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  title: Scalars['String']['output'];
};


export type TesterGuidelineNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterGuidelineNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum TesterGuidelineCodesEnum {
  /** best_practice */
  BestPractice = 'best_practice',
  /** educational_tip */
  EducationalTip = 'educational_tip',
  /** explanation */
  Explanation = 'explanation'
}

export type TesterMobileDeviceOwnership = HasId & Node & {
  __typename?: 'TesterMobileDeviceOwnership';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  mobileDeviceId: Scalars['ID']['output'];
  mobileDeviceOwnershipId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystemNameWithVersion: Scalars['String']['output'];
  operatingSystemVersionId: Scalars['ID']['output'];
  platformCode: Maybe<Scalars['String']['output']>;
  vpnGatewayPeer: Maybe<VpnGatewayPeer>;
};


export type TesterMobileDeviceOwnershipNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterMobileDeviceOwnershipNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for TesterMobileDeviceOwnership. */
export type TesterMobileDeviceOwnershipConnection = {
  __typename?: 'TesterMobileDeviceOwnershipConnection';
  /** A list of edges. */
  edges: Array<TesterMobileDeviceOwnershipEdge>;
  /** A list of nodes. */
  nodes: Array<TesterMobileDeviceOwnership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TesterMobileDeviceOwnershipEdge = {
  __typename?: 'TesterMobileDeviceOwnershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TesterMobileDeviceOwnership;
};

export type TesterMobileDeviceOwnershipFilter = {
  test_id: Scalars['ID']['input'];
};

export type TesterOperatingSystemOwnership = HasId & Node & {
  __typename?: 'TesterOperatingSystemOwnership';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  nameWithVersion: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystemId: Scalars['ID']['output'];
  operatingSystemOwnershipId: Scalars['ID']['output'];
  operatingSystemVersionId: Scalars['ID']['output'];
  vpnGatewayPeer: Maybe<VpnGatewayPeer>;
};


export type TesterOperatingSystemOwnershipNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterOperatingSystemOwnershipNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for TesterOperatingSystemOwnership. */
export type TesterOperatingSystemOwnershipConnection = {
  __typename?: 'TesterOperatingSystemOwnershipConnection';
  /** A list of edges. */
  edges: Array<TesterOperatingSystemOwnershipEdge>;
  /** A list of nodes. */
  nodes: Array<TesterOperatingSystemOwnership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TesterOperatingSystemOwnershipEdge = {
  __typename?: 'TesterOperatingSystemOwnershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TesterOperatingSystemOwnership;
};

export type TesterOperatingSystemOwnershipFilter = {
  test_id: Scalars['ID']['input'];
};

export type TesterOwnership = {
  __typename?: 'TesterOwnership';
  mobileDeviceOwnerships: Array<TesterMobileDeviceOwnership>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  operatingSystemOwnerships: Array<TesterOperatingSystemOwnership>;
};


export type TesterOwnershipNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterOwnershipNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterPayoutBalance = HasId & Node & {
  __typename?: 'TesterPayoutBalance';
  _id: Scalars['ID']['output'];
  balance: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  threshold: Scalars['String']['output'];
  thresholdReached: Scalars['Boolean']['output'];
};


export type TesterPayoutBalanceNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterPayoutBalanceNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterPerformance = {
  __typename?: 'TesterPerformance';
  acceptanceRate: Maybe<Scalars['Float']['output']>;
  acceptanceRatePercentChange: Maybe<Scalars['Int']['output']>;
  acceptedIssuesCount: Maybe<Scalars['Int']['output']>;
  acceptedIssuesWithoutEditsCount: Maybe<Scalars['Int']['output']>;
  improvementTips: Maybe<TesterPerformanceImprovementTips>;
  issuesCount: Maybe<Scalars['Int']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type TesterPerformanceNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterPerformanceNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterPerformanceImprovementTips = {
  __typename?: 'TesterPerformanceImprovementTips';
  details: Scalars['String']['output'];
  messagePlaceholderName: Scalars['String']['output'];
  messagePlaceholderValue: Scalars['String']['output'];
  messageTemplate: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  tooltip: Scalars['String']['output'];
};


export type TesterPerformanceImprovementTipsNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterPerformanceImprovementTipsNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum TesterPerformancePeriod {
  CurrentMonth = 'current_month',
  Lifetime = 'lifetime',
  PreviousMonth = 'previous_month'
}

export type TesterQualityAssessmentAnswer = {
  __typename?: 'TesterQualityAssessmentAnswer';
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  text: Scalars['String']['output'];
};


export type TesterQualityAssessmentAnswerNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterQualityAssessmentAnswerNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterQualityAssessmentPage = HasId & Node & {
  __typename?: 'TesterQualityAssessmentPage';
  _id: Scalars['ID']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  ordinalNumber: Maybe<Scalars['Int']['output']>;
  questions: Array<TesterQualityAssessmentQuestion>;
};


export type TesterQualityAssessmentPageNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterQualityAssessmentPageNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterQualityAssessmentQuestion = {
  __typename?: 'TesterQualityAssessmentQuestion';
  answerType: Scalars['String']['output'];
  answers: Array<TesterQualityAssessmentAnswer>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  text: Scalars['String']['output'];
};


export type TesterQualityAssessmentQuestionNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterQualityAssessmentQuestionNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterQualityAssessmentResponse = {
  __typename?: 'TesterQualityAssessmentResponse';
  answerIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  questionId: Scalars['ID']['output'];
};


export type TesterQualityAssessmentResponseNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterQualityAssessmentResponseNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterQualityAssessmentResponseInput = {
  answerIds: Array<Scalars['ID']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
};

export type TesterQualityAssessmentTest = HasId & Node & {
  __typename?: 'TesterQualityAssessmentTest';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  pages: Array<TesterQualityAssessmentPage>;
};


export type TesterQualityAssessmentTestNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterQualityAssessmentTestNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterRank = HasId & Node & {
  __typename?: 'TesterRank';
  _id: Scalars['ID']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  tierCode: Scalars['String']['output'];
  tierPayoutMultiplier: Scalars['Float']['output'];
};


export type TesterRankNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterRankNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterSession = HasId & Node & {
  __typename?: 'TesterSession';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  test: Maybe<Test>;
};


export type TesterSessionNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterSessionNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterSpec = {
  __typename?: 'TesterSpec';
  code: TesterSpecCodesEnum;
  guidelines: Array<TesterGuideline>;
  inScope: Maybe<Scalars['String']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  outOfScope: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type TesterSpecNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterSpecNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum TesterSpecCodesEnum {
  /** bugs */
  Bugs = 'bugs',
  /** localization_issues */
  LocalizationIssues = 'localization_issues',
  /** test_case_execution */
  TestCaseExecution = 'test_case_execution',
  /** translation_issues */
  TranslationIssues = 'translation_issues'
}

export type TesterSpreadsheet = HasId & Node & {
  __typename?: 'TesterSpreadsheet';
  _id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  url: Scalars['String']['output'];
};


export type TesterSpreadsheetNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterSpreadsheetNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TesterSurvey = HasId & Node & {
  __typename?: 'TesterSurvey';
  _id: Scalars['ID']['output'];
  completed: Maybe<Scalars['Boolean']['output']>;
  content: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type TesterSurveyNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TesterSurveyNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TestingSettingsResult = {
  __typename?: 'TestingSettingsResult';
  languageProficiencies: Array<LanguageProficiency>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  profileCompletenessStage: Scalars['String']['output'];
  testerFields: Array<TesterField>;
};


export type TestingSettingsResultNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TestingSettingsResultNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type TimeOfDay = {
  __typename?: 'TimeOfDay';
  endTime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  startTime: Scalars['String']['output'];
};


export type TimeOfDayNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TimeOfDayNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum TimeSlotCodeEnum {
  /** friday_afternoon */
  FridayAfternoon = 'friday_afternoon',
  /** friday_early_hours */
  FridayEarlyHours = 'friday_early_hours',
  /** friday_evening */
  FridayEvening = 'friday_evening',
  /** friday_morning */
  FridayMorning = 'friday_morning',
  /** friday_night */
  FridayNight = 'friday_night',
  /** monday_afternoon */
  MondayAfternoon = 'monday_afternoon',
  /** monday_early_hours */
  MondayEarlyHours = 'monday_early_hours',
  /** monday_evening */
  MondayEvening = 'monday_evening',
  /** monday_morning */
  MondayMorning = 'monday_morning',
  /** monday_night */
  MondayNight = 'monday_night',
  /** saturday_afternoon */
  SaturdayAfternoon = 'saturday_afternoon',
  /** saturday_early_hours */
  SaturdayEarlyHours = 'saturday_early_hours',
  /** saturday_evening */
  SaturdayEvening = 'saturday_evening',
  /** saturday_morning */
  SaturdayMorning = 'saturday_morning',
  /** saturday_night */
  SaturdayNight = 'saturday_night',
  /** sunday_afternoon */
  SundayAfternoon = 'sunday_afternoon',
  /** sunday_early_hours */
  SundayEarlyHours = 'sunday_early_hours',
  /** sunday_evening */
  SundayEvening = 'sunday_evening',
  /** sunday_morning */
  SundayMorning = 'sunday_morning',
  /** sunday_night */
  SundayNight = 'sunday_night',
  /** thursday_afternoon */
  ThursdayAfternoon = 'thursday_afternoon',
  /** thursday_early_hours */
  ThursdayEarlyHours = 'thursday_early_hours',
  /** thursday_evening */
  ThursdayEvening = 'thursday_evening',
  /** thursday_morning */
  ThursdayMorning = 'thursday_morning',
  /** thursday_night */
  ThursdayNight = 'thursday_night',
  /** tuesday_afternoon */
  TuesdayAfternoon = 'tuesday_afternoon',
  /** tuesday_early_hours */
  TuesdayEarlyHours = 'tuesday_early_hours',
  /** tuesday_evening */
  TuesdayEvening = 'tuesday_evening',
  /** tuesday_morning */
  TuesdayMorning = 'tuesday_morning',
  /** tuesday_night */
  TuesdayNight = 'tuesday_night',
  /** wednesday_afternoon */
  WednesdayAfternoon = 'wednesday_afternoon',
  /** wednesday_early_hours */
  WednesdayEarlyHours = 'wednesday_early_hours',
  /** wednesday_evening */
  WednesdayEvening = 'wednesday_evening',
  /** wednesday_morning */
  WednesdayMorning = 'wednesday_morning',
  /** wednesday_night */
  WednesdayNight = 'wednesday_night'
}

export type TimeZone = {
  __typename?: 'TimeZone';
  label: Scalars['String']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  value: Scalars['String']['output'];
};


export type TimeZoneNodeArgs = {
  id: Scalars['ID']['input'];
};


export type TimeZoneNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of UpdateAccountSettings */
export type UpdateAccountSettingsInput = {
  accountSettingsParams: AccountSettingsInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAccountSettings. */
export type UpdateAccountSettingsPayload = MutationResult & {
  __typename?: 'UpdateAccountSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Tester>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCaseFieldAttachmentResponses */
export type UpdateCaseFieldAttachmentResponsesInput = {
  attachmentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testCaseFieldId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCaseFieldAttachmentResponses. */
export type UpdateCaseFieldAttachmentResponsesPayload = MutationResult & {
  __typename?: 'UpdateCaseFieldAttachmentResponsesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCaseResultAttachments */
export type UpdateCaseResultAttachmentsInput = {
  attachmentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testCaseId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCaseResultAttachments. */
export type UpdateCaseResultAttachmentsPayload = MutationResult & {
  __typename?: 'UpdateCaseResultAttachmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<CaseResult>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCheckUpVerification */
export type UpdateCheckUpVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  mobileDeviceOwnerships: Array<OwnershipCheckUpInput>;
  operatingSystemOwnerships: Array<OwnershipCheckUpInput>;
};

/** Autogenerated return type of UpdateCheckUpVerification. */
export type UpdateCheckUpVerificationPayload = MutationResult & {
  __typename?: 'UpdateCheckUpVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<TesterOwnership>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateExecutionEnvironment */
export type UpdateExecutionEnvironmentInput = {
  browserOrDevice: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  operatingSystemAndVersion: Scalars['String']['input'];
  testId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateExecutionEnvironment. */
export type UpdateExecutionEnvironmentPayload = MutationResult & {
  __typename?: 'UpdateExecutionEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Test>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateMobileDeviceOwnership */
export type UpdateMobileDeviceOwnershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  mobileDeviceOwnershipsAttributes: Array<MobileDeviceOwnershipInput>;
};

/** Autogenerated return type of UpdateMobileDeviceOwnership. */
export type UpdateMobileDeviceOwnershipPayload = MutationResult & {
  __typename?: 'UpdateMobileDeviceOwnershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Array<TesterMobileDeviceOwnership>>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOperatingSystemOwnership */
export type UpdateOperatingSystemOwnershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  operatingSystemOwnershipsAttributes: Array<OperatingSystemOwnershipInput>;
};

/** Autogenerated return type of UpdateOperatingSystemOwnership. */
export type UpdateOperatingSystemOwnershipPayload = MutationResult & {
  __typename?: 'UpdateOperatingSystemOwnershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Array<TesterOperatingSystemOwnership>>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateProfileCompletenessStage */
export type UpdateProfileCompletenessStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  profileCompletenessStage: ProfileCompletenessStageUpdateEnum;
};

/** Autogenerated return type of UpdateProfileCompletenessStage. */
export type UpdateProfileCompletenessStagePayload = MutationResult & {
  __typename?: 'UpdateProfileCompletenessStagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Tester>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateTestCaseRunVideo */
export type UpdateTestCaseRunVideoInput = {
  attachmentId: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  testCaseId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTestCaseRunVideo. */
export type UpdateTestCaseRunVideoPayload = MutationResult & {
  __typename?: 'UpdateTestCaseRunVideoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<CaseResult>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateTestCycleInvitation */
export type UpdateTestCycleInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  status: Status;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTestCycleInvitation. */
export type UpdateTestCycleInvitationPayload = MutationResult & {
  __typename?: 'UpdateTestCycleInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<TestCycleInvitation>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateTesterAvailabilityCalendar */
export type UpdateTesterAvailabilityCalendarInput = {
  availabilities: Array<TesterAvailabilityInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  timeZoneName: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTesterAvailabilityCalendar. */
export type UpdateTesterAvailabilityCalendarPayload = MutationResult & {
  __typename?: 'UpdateTesterAvailabilityCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Tester>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateTesterQualityAssessmentResponses */
export type UpdateTesterQualityAssessmentResponsesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  responses: Array<TesterQualityAssessmentResponseInput>;
  testCode: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTesterQualityAssessmentResponses. */
export type UpdateTesterQualityAssessmentResponsesPayload = MutationResult & {
  __typename?: 'UpdateTesterQualityAssessmentResponsesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<Array<TesterQualityAssessmentResponse>>;
  successful: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateTestingSettings */
export type UpdateTestingSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: InputMaybe<Scalars['String']['input']>;
  languageProficienciesAttributes: InputMaybe<Array<LanguageProficiencyInput>>;
  testerFieldValues: InputMaybe<Array<TesterFieldInput>>;
};

/** Autogenerated return type of UpdateTestingSettings. */
export type UpdateTestingSettingsPayload = MutationResult & {
  __typename?: 'UpdateTestingSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<MutationError>;
  result: Maybe<TestingSettingsResult>;
  successful: Scalars['Boolean']['output'];
};

export type VpnGatewayPeer = {
  __typename?: 'VPNGatewayPeer';
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  lastConnectedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  publicKey: Scalars['String']['output'];
  userConfig: Maybe<Scalars['String']['output']>;
  userConfigQrcodeSvg: Maybe<Scalars['String']['output']>;
};


export type VpnGatewayPeerNodeArgs = {
  id: Scalars['ID']['input'];
};


export type VpnGatewayPeerNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type Viewer = HasId & Node & {
  __typename?: 'Viewer';
  _id: Scalars['ID']['output'];
  desktopOperatingSystems: TesterOperatingSystemOwnershipConnection;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  mobileDevices: TesterMobileDeviceOwnershipConnection;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type ViewerDesktopOperatingSystemsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filters: TesterOperatingSystemOwnershipFilter;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type ViewerMobileDevicesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  filters: TesterMobileDeviceOwnershipFilter;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type ViewerNodeArgs = {
  id: Scalars['ID']['input'];
};


export type ViewerNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type WeekTimeSlot = {
  __typename?: 'WeekTimeSlot';
  isoDayOfWeek: Scalars['Int']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  timeSlotCode: TimeSlotCodeEnum;
};


export type WeekTimeSlotNodeArgs = {
  id: Scalars['ID']['input'];
};


export type WeekTimeSlotNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type WorkHistoryIssue = HasId & Node & {
  __typename?: 'WorkHistoryIssue';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  payout: WorkHistoryItemPayout;
  status: WorkHistoryItemStatuses;
  summary: Scalars['String']['output'];
  testName: WorkHistoryItemName;
  testType: WorkHistoryItemTypes;
  url: Maybe<Scalars['String']['output']>;
};


export type WorkHistoryIssueNodeArgs = {
  id: Scalars['ID']['input'];
};


export type WorkHistoryIssueNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** The connection type for WorkHistoryIssue. */
export type WorkHistoryIssueConnection = {
  __typename?: 'WorkHistoryIssueConnection';
  /** A list of edges. */
  edges: Array<WorkHistoryIssueEdge>;
  /** A list of nodes. */
  nodes: Array<WorkHistoryIssue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of resources */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type WorkHistoryIssueEdge = {
  __typename?: 'WorkHistoryIssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WorkHistoryIssue;
};

export type WorkHistoryIssueFilter = {
  status: WorkHistoryStatuses;
};

export type WorkHistoryItemName = HasId & Node & {
  __typename?: 'WorkHistoryItemName';
  _id: Scalars['ID']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type WorkHistoryItemNameNodeArgs = {
  id: Scalars['ID']['input'];
};


export type WorkHistoryItemNameNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type WorkHistoryItemPayout = HasId & Node & {
  __typename?: 'WorkHistoryItemPayout';
  _id: Scalars['ID']['output'];
  baseAmount: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  payoutBoostMultiplier: Maybe<Scalars['Float']['output']>;
  rankingTierMultiplier: Maybe<Scalars['Float']['output']>;
  severity: Maybe<Scalars['String']['output']>;
  totalAmount: Maybe<Scalars['String']['output']>;
};


export type WorkHistoryItemPayoutNodeArgs = {
  id: Scalars['ID']['input'];
};


export type WorkHistoryItemPayoutNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum WorkHistoryItemStatuses {
  Accepted = 'accepted',
  AddedToAmountDue = 'added_to_amount_due',
  InModeration = 'in_moderation',
  Paid = 'paid',
  Processing = 'processing',
  Rejected = 'rejected'
}

export enum WorkHistoryItemTypes {
  ExploratoryTest = 'exploratory_test',
  TestCase = 'test_case'
}

export enum WorkHistoryStatuses {
  Accepted = 'accepted',
  AddedToAmountDue = 'added_to_amount_due',
  All = 'all',
  InModeration = 'in_moderation',
  Paid = 'paid',
  Processing = 'processing',
  Rejected = 'rejected'
}
